/* eslint-disable max-lines */

interface ProductImageSet {
  label0?: string;
  label1?: string;
  label2?: string;
  label3?: string;
  label4?: string;
  label5?: string;
  label6?: string;
  label7?: string;
  label8?: string;
  label9?: string;
  single?: string;
  kit?: string;
  gift?: string;
  gift2?: string;
  travelsize?: string;
  carousel?: string;
  alt2?: string;
  lifestyle?: string;
  lifestyle2?: string;
}

export const PRODUCT_IMAGES: Record<string, ProductImageSet> = {
  MENPRO1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5GMRwIuDhdHgDUXeEIKA6k/806e421ca4adf50496456de0abd97673/label-men-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1rFsoiTYFiofRu0K6i1tCq/e97ac6bfaa50a49bdd51ab4a73252369/product-men.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/NP4VXw6tvIpDbJCPRyOBR/2822ed5c9562059235cc8239827253f2/product-men-pills.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3UhOk6vrfJE0AEKgrlVxo3/4bec0283bca92113c445507f2c599921/MENPRO1_5.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4JYrSRyIgdzBVBbDBp9oYQ/e3e721631f1ebbb2e8f2970b68dca22a/men-pills-badge-usnews.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/NP4VXw6tvIpDbJCPRyOBR/2822ed5c9562059235cc8239827253f2/product-men-pills.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/WKVzvr5chwUG6KR3xUAwn/d35e3816261c9b3ce68425e112d5e801/men-nsf-badge-pills.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/46ADMgCGpf3Sh4YeFWH5lU/66d8c376821346e68d97117594b622e5/men-badge-pills.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/WKVzvr5chwUG6KR3xUAwn/d35e3816261c9b3ce68425e112d5e801/men-nsf-badge-pills.png",
    carousel:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3qDOKEMrZf7m6gXz2wrj0L/6772b1f158ef5a890929b2573c98b98f/men-pills-badge.png",
    gift: "https://images.ctfassets.net/0rbfqd9c4jdo/10s85I10s2xRjp7r5qbXql/08d9ae0923ed3b7fa374d3e37b1ad4cb/men-kit-gift.png",
    gift2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5tsZP5d3VWBm4f6NV0RqLg/89e3b51e1201a94a5205c9591a615448/men-free-gift.png",
  },
  MENPRO3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5GMRwIuDhdHgDUXeEIKA6k/806e421ca4adf50496456de0abd97673/label-men-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/i9BFDrbSutRtQ4aDzIKGf/3657d4cd1ae2a105e65219a0ea604faa/MENPRO3_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6RyBeywd12Pj0jqBtsECA5/b439406142d3c54a2149ee7f01d9eea4/MEN3_3.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6RyBeywd12Pj0jqBtsECA5/b439406142d3c54a2149ee7f01d9eea4/MEN3_3.png",
    label4: "",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/JNuwZROxCA6gRylajjtuz/0fc7d1425e78d61023b8351612340664/menpro3-us-news-badge.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3aqcPdlqT5OI8XlORhQgqu/783465dd672cbfc8972afedf0a58649f/MENPRO3_5__1_.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3nm1zbSUKBTpfbr4uyXYOu/ff2c3dfcc0561660f055e6ebe8e9d84d/MENPRO3_6__1_.png",
    gift: "https://images.ctfassets.net/0rbfqd9c4jdo/3FdT5LhhdX9rZ2Wh41Z8Lt/b21809de11e5e46201581e08a39d13e8/men-core-gift.png",
    gift2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3WaFjnTWeLkjyX13CmBqIL/59b1527e2e49917fbbeaa5286d093213/menpro3_free-gift.png",
  },
  MENPRO6: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5GMRwIuDhdHgDUXeEIKA6k/806e421ca4adf50496456de0abd97673/label-men-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/AXexW6Qs1EEHSGLhOX5cX/971e20610296473040325b8f6c59cd65/MENPRO6_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6nRIML2TtnArsLzxZoJFs8/176e95c1d932637608747fb023eef137/MENPRO6_3.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6nRIML2TtnArsLzxZoJFs8/176e95c1d932637608747fb023eef137/MENPRO6_3.png",
    label4: "",
  },
  MSR1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4yA6ajE7WFZBqMWn3E1YtN/575a7d651974895c6bf2efd379b471fc/label-men50-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1uyoyRwRiyXYx9FmJRYKeS/4366da971fd7d43f101b6784ff81ed57/MSR1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2xuGBEtEQHsrB0dOqF2LxH/aa800fe026222e68a1e2070fa893d1d4/MSR1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/LWVPJpUaWGHMhnLZwixNT/f4c6650ebe719d7e8f41d070148ae595/MSR1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/78pRudkIJyfJbqRLcGsacT/ea07110384fb61f084fdae804aa5a342/MSR1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7nC37BV3q4aRxVcscAxocV/7fcf2671c16b50751d1f9c374f6f6eab/men50-bottle-badge.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3cfCy8P94stfZfrtUx3hob/9c4771a76faa9e1c5a83431782cb1b39/MSR1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4OhWolXqK8i1H9vpRsv5K3/eba557343f1034e3c74e45cf33cb1fec/MSR1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3K7MpEXjjIIltzQFySiwgw/aea8b08d1f98f7113b072d19775f5d27/MSR1_8.png",
    carousel:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7nC37BV3q4aRxVcscAxocV/7fcf2671c16b50751d1f9c374f6f6eab/men50-bottle-badge.png",
  },
  MSR3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4yA6ajE7WFZBqMWn3E1YtN/575a7d651974895c6bf2efd379b471fc/label-men50-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5qoLgRKmZ8Nng7PUIZzB1J/3af3ca945044ec7d294bcd83fa49352c/MSR3_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6P71D3FegV67uHjLIVXVrO/b7605d79f56685489a83e0e6670972e3/MSR3_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/29BuGG08OrpWJaTpsvVIm4/776cb056a9e33e9b1f93d2d636ad0b74/MSR3_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4C87A9i8K85SzUdUgQxfUH/0fa9cbf914746faa7c7d7b0e528a32ea/MSR3_4.png",
  },
  MSR6: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4yA6ajE7WFZBqMWn3E1YtN/575a7d651974895c6bf2efd379b471fc/label-men50-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1mPzsujg4MgxAAzVmsbjFf/1c7debbd9a1173e4b5ecad3edd4a6f7a/MSR6_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6myFmmwa9XEnpJxBFfSP2e/728cbe02f6cabda58d93c42e712609c8/MSR6_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6myFmmwa9XEnpJxBFfSP2e/728cbe02f6cabda58d93c42e712609c8/MSR6_2.png",
  },
  MENX3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7m86g4SYY14QOd52yYH0x7/9484fee420d8e3ef095ac94daf73c9a3/label-men.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4GvZwkLjLL6yz0iLdedfO9/f3c9107accdc9e9702913ca4acf14ac1/MENX3.png",
  },
  MSRX3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7m86g4SYY14QOd52yYH0x7/9484fee420d8e3ef095ac94daf73c9a3/label-men.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6zpBsCfnrKZzetmfqtFv48/6e6086d880ec0dd80421545016249bd6/MSRX3_1.png",
  },
  MSRX6: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7m86g4SYY14QOd52yYH0x7/9484fee420d8e3ef095ac94daf73c9a3/label-men.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1jK6AlTjHg0iDF8MKiY63M/bdc99501e13f076c653a1ff0c0fd4181/MSRX6_1.png",
  },
  MENFUL1: {
    label0: `https://images.ctfassets.net/0rbfqd9c4jdo/6W2qkWX8KXxuPcnrF0wDfQ/1a5519cde9fa4e249dfe55bfd6137984/label-ga-men-text.png`,
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1q5fMNguNmmrD96wDhcTic/1d61f00a98ad482eb67f471e69a1254a/product-men-full-support.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3jZeB2frExEKCYPrgG0GfV/8c09bf3f73b5d8dbf64a7d9a97528688/product-men-full-support-pill1.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1f0xKB7VaOrT1U3ei8Xx2k/8f5c7a770610d0b6c211de5f348c3bde/product-men-full-support-pill2.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4GWu3yhd6wjtkGbhojpx7s/b81c0656d608c5c8948733eea8f30de7/men-product-full-support.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4CvbnyohYeYHwKpCCqdKoX/5c562f10bf7ae7f0ac46ebf2081ae45e/product-men-full-support-pills-badge.png",
  },
  MENFUL3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7m86g4SYY14QOd52yYH0x7/9484fee420d8e3ef095ac94daf73c9a3/label-men.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Q5d2h50akWSjYlGJIRrpy/76ca6607a59874c687545adaa26171b7/product-men-growth.png",
  },
  MENFUL6: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7m86g4SYY14QOd52yYH0x7/9484fee420d8e3ef095ac94daf73c9a3/label-men.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Q5d2h50akWSjYlGJIRrpy/76ca6607a59874c687545adaa26171b7/product-men-growth.png",
  },
  MENFHK3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7m86g4SYY14QOd52yYH0x7/9484fee420d8e3ef095ac94daf73c9a3/label-men.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/11K6NqELQbyzmrDLnbCrNu/49c885e554f99628277028f565e3fc34/product-men-growth-kit.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4j1g1UH1N8HbZkW6JLI7dJ/63c496ccf19e2a12e33081deec3d252a/product-men-fullest-hair-kit-pills.png",
    gift: "https://images.ctfassets.net/0rbfqd9c4jdo/mEDmJFvfyAFZ9C2ngKySQ/ee3d15acba561e11dafb655a4e4cc748/fhk-men-gift.png",
  },
  MEN3PROMO: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5GMRwIuDhdHgDUXeEIKA6k/806e421ca4adf50496456de0abd97673/label-men-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1rFsoiTYFiofRu0K6i1tCq/e97ac6bfaa50a49bdd51ab4a73252369/product-men.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Iu1Q5Y119DRL1N2XCAf92/dda14a021be762022b775a963450cb85/product-men-badge.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5QudScSptWr9kZOt5NyvvO/7a97b52f56b10e46d9254dc860a031d8/product-men-pills.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5UTK9prcQFbM9mChmYjRFh/ff0a40851df5c946eb6029b94be1dc0e/product-men-badge-pills.png",
    single:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2NYxzwFTsaQ9NNdjFGUnhG/7af9c8351ea89e39a46f33a7151ae118/promo-mens.png",
    kit: "https://images.ctfassets.net/0rbfqd9c4jdo/1P57RCPNtIMd2fjoWLMUTl/931a28660d7e547cf39eebda60b41472/promo-hairkit-mens.png",
  },
  ADV1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/41k6y9QfVPYGz3NPe5UElU/eb048fec70b838cbe96fc191d91f2e75/label-vegan-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/21CbvPfrknzgjUJDmRxC1L/d8eb5d58c170c2eab6c52ff1e0b4179d/ADV1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3g70s7Ijd11UTVDQuICp7V/250ee776c0bc3ab06ae882d18c74b2f1/ADV1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3CfJsRqPtamAfG60uyYfkM/604778e44253362140bed892d3f30217/ADV1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1d2fQFbmMqXykseB08nXWv/b5d95dffa7b1460862412f52dab154c6/ADV1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/19cZgcfOA67PzAAJMhchdW/bb75a1c76a6609fee6814c5e34318e06/ADV1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6a5THIMrMC9G4Ch3p8jF4g/8dd63b6bac74f6019ef511a6ac725fd0/ADV1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/497lyXm9XPVmeRUa4rE4th/4554a5b8a3e19ba890d4698eb03c8d97/ADV1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3oKko7k4kgXqQef6xcvANc/97449a8617b410274c1f991ed9fedea2/ADV1_8.png",
    carousel:
      "https://images.ctfassets.net/0rbfqd9c4jdo/bLDTpuHX0eGtADDDjkdoL/418df107422852faf3038627c6ba6125/adv1-bottle-with-tag.png",
  },
  ADV3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/41k6y9QfVPYGz3NPe5UElU/eb048fec70b838cbe96fc191d91f2e75/label-vegan-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7cIr4B6XoMmlHp3bcihIdX/6858e3025b0c8aded2ab8bc9bd38bea9/ADV3_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3uFWEAOWCWQ6vLG2y52Yp7/dea4f0955740d96e2e78586109d75a10/ADV3_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1SMJHevbEEI0IUjgKQDhTC/22010cd32b84ab157d828e849788c3a5/ADV3_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/67ldc65v0IxIbtQWlFU7L6/f194793a2db5e737d4c9b2114a82aa66/ADV3_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5dpnXDDolgM41oPZbBBFxh/9247ef0ff3d0a08141cabdfd4dfc409c/ADV3_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1GDVdgy1eut8pmkiWtITxb/94096b686fccc7d952cf49b9bc7ece90/ADV3_6.png",
  },
  ADV6: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/41k6y9QfVPYGz3NPe5UElU/eb048fec70b838cbe96fc191d91f2e75/label-vegan-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/NYUhGhl6E4LyWx2NJkpte/dfff420ee2c020e469c88995e62ed710/ADV6_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1QubTT8VzBaa5EJcXWP26J/9a5736661925fa0476c2a760d4066a5f/ADV6_2.png",
  },
  BAL1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Dnrv2EF6zocSmtOhpOZ7F/483deea6c64ac0a46f981c6be2e598b2/label-balance-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4wYUcusHz8GyNh0m6PPvQC/76f9021bb643668e488683cd86a8f925/product-balance.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5bCmskwfOHLrDqp0gGp3mO/f2ab21f48b1ee8293c5804625d888199/BAL1_2__1_.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3SMUpWp804YgnTwGYLmZPu/b952671f4fc7a019e03bc296f8415d3b/product-balance-pills.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/RwXGiCToo66NwQtJfRxgW/6ab7faac1286129d6d775d6b33fc48a6/BAL1_6.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7FYlveePseNz5LxrPcT5qr/79ebcf2c44dba8e22521be817bd7d399/product-balance-badge-pills-editors-choice.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/RwXGiCToo66NwQtJfRxgW/6ab7faac1286129d6d775d6b33fc48a6/BAL1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4W8wc9xUeIqJWqiYoZpyAy/177bace592519f8c4fdd34a5230d7493/nutrafol-balance-nsf.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6GuRG1JlXCz0oTluELjR8W/34f8c6ee0fa6b974c1f36d906704810f/nutrafol-balance-nsf-pills.png",
    carousel:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5XmamnoPQxadSrvMLmK5hY/32521658a018e9246f5b3e450f0c4bac/bal-pills-badge.png",
    gift: "https://images.ctfassets.net/0rbfqd9c4jdo/6ImlVsLMX4o3fhPtfH2SnD/943604045bdc5b3ae5b6b52e54aa8f3d/balance-kit-gift.png",
    gift2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7EoSzwLspM0QEli58fWoeY/f2e5cf405bbdb2fc527ae3d99aff25eb/balance-free-gift.png",
  },
  BAL3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Dnrv2EF6zocSmtOhpOZ7F/483deea6c64ac0a46f981c6be2e598b2/label-balance-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3eEgNHQKzgxtpIAfewEbJt/af89e7abd19fe3cc337374aa44bf9cf5/BAL3_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6pNSLDDyhZxbxakryal3aM/19ab901af9112c7cd06d14745d465810/BAL3_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/76eV9N6REYvQeLflbkU456/1de02e7d856943ebf9902f0ad29de3b2/BAL3_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5tYITUQ5YNPlVivmsj06R2/0516258446388adde948487eab30ee9c/BAL3_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2nl044rAYXEFFTo68GJ42X/1db2609033241b31bfdabb9aab28de1f/BAL3_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5BPSRfa51GWOZfSJoiawoV/8a43521472e8c2864aa0956cc3156168/BAL3_6.png",
    gift: "https://images.ctfassets.net/0rbfqd9c4jdo/2RNnvqXfKFdVdsZkUHzRJN/97a4cbca5be6a65d98938838833205dd/bal3_free-gift.png",
  },
  BAL6: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Dnrv2EF6zocSmtOhpOZ7F/483deea6c64ac0a46f981c6be2e598b2/label-balance-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7eaVkJObfSqJX089pZsKcd/62b90c19fdcd74793a2c649ab2211e94/BAL6_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Ps2VZU4vxxuFGpi8oGLSQ/286aabefe6c33741ae2af9e08ec9fce5/BAL6_3.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Ps2VZU4vxxuFGpi8oGLSQ/286aabefe6c33741ae2af9e08ec9fce5/BAL6_3.png",
  },
  BALGI1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6W2qkWX8KXxuPcnrF0wDfQ/1a5519cde9fa4e249dfe55bfd6137984/label-ga-men-text.png",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/356pIOvCTXCLY1ZxKHWl2M/3515dd5e6e1b41fa795296a33876e45d/Boosters_3DCollagen__2B_Hair_Serum__PillsSubstance_3DOff.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1P7PUPXU6TUimQxJQIVKLd/4686371912941793f4f225c613b47afe/Frame_1556.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3bD4L4TC7U5WZmxsvl0W9W/6f7e0bc8d7798e7892959430077d17ae/Balance_collagen_serum.png",
  },
  BALFHK3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1MvolZCdspa9FD7fdk6VaE/0544e2e8bd86e9915a02679c39f359b8/label-balance.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5zEshDDhAUOa46CcUqHsvd/e36bc09850e84e122e14b1c5b6bb86fc/product-balance-growth-kit.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2mtf7Um9jctxmhU8BuD9dd/40267d9e0e43c8b4c6078d2397c65c50/product-balance-fullest-hair-kit-pills.png",
    gift: "https://images.ctfassets.net/0rbfqd9c4jdo/7c5rgA4JnVZn44nKTQFeJN/b03c6448bc971f5235e936b5286425b0/fhk-balance-gift.png",
  },
  BAL3PROMO: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Dnrv2EF6zocSmtOhpOZ7F/483deea6c64ac0a46f981c6be2e598b2/label-balance-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4wYUcusHz8GyNh0m6PPvQC/76f9021bb643668e488683cd86a8f925/product-balance.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6aBN9yyCcvAULfVC6RZ7VV/aa97859ce315fd1b71c64f20f300e7ce/product-balance-badge.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3SMUpWp804YgnTwGYLmZPu/b952671f4fc7a019e03bc296f8415d3b/product-balance-pills.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7V7COM1YUYLRB7cjd5qCm/07211792a63ac8e549f31c6b5c97ff28/product-balance-badge-pills.png",
    single:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4nXTJiAANguirdAcOxz4F1/331246e9e18a0584ae7272786231049c/promo-balance.png",
    kit: "https://images.ctfassets.net/0rbfqd9c4jdo/2cJgnb4N8DdMGY7rUyERfV/8fbfad01c54d7346caf582ddb1dcc2d4/promo-hairkit-balance.png",
  },
  POS1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6GaFILrfOozlelhkiXhTpj/e66e5df9983e5015a9bb2184d5f4ff94/label-postpartum-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5nbbTkfSQCTUvzoQCy1mqd/dfe79ce501d9233cad73476525fc7569/product-postpartum.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5nbbTkfSQCTUvzoQCy1mqd/dfe79ce501d9233cad73476525fc7569/product-postpartum.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2VtRHG73WC3QeuvNIb7PYR/c6a35281b03f6aec8f7ee84367ea6f64/product-postpartum-pills.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3Aj1lgETyVbWG5FIDqd2PJ/45bf24f23149a89e76d8aa58ebd4edb5/POS1_6.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3Aj1lgETyVbWG5FIDqd2PJ/45bf24f23149a89e76d8aa58ebd4edb5/POS1_6.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/623nPADjxj6OFQ6EHrRrJ9/42b4a6fc9cfb385f04aabeffc0120c00/nutrafol-postpartum-nsf.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/59VG1JBLb1lBZBhTzxl3nN/cffa0db104a011cf903fc652e422ee65/nutrafol-postpartum-nsf-pills.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/59VG1JBLb1lBZBhTzxl3nN/cffa0db104a011cf903fc652e422ee65/nutrafol-postpartum-nsf-pills.png",
    carousel:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5CqSAyps9MZpd5xbSvtKz6/3bdd5edef003bd0a723018ca23c48582/POS1_badge.png",
    gift: "https://images.ctfassets.net/0rbfqd9c4jdo/1Vny683jmThAHQzEyyXwou/8e07eac6ac5c9a082b152320735bab5d/postpartum-kit-gift.png",
    gift2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3MxDGh0U86H9DtYFqV8zbW/304fc59d4bc66987158da5bac59c68a7/postpartum-free-gift.png",
  },
  POS3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6GaFILrfOozlelhkiXhTpj/e66e5df9983e5015a9bb2184d5f4ff94/label-postpartum-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4pfXr9DsKiMWoy9d3qufEY/c337b366d38f4e031999cdfcc711d6fb/POS3_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/23IahNyb78hMnoz8R18f3e/af36bd5bb59b4f29958de34ef27de2f6/POS3_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7CkQ1QXfq8lnG6J5iXf3zB/e2722eeb07f365b3197c3cb08240f2a1/POS3_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6CQJAAhvOTUoC4ghkbnNhT/b7146e9d0ddadb34d53f5c3bc4dc5978/POS3_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3WQ8SfTSeOYhog7ctITgqa/7b672d2f9ce188697a30c9a702831d2f/POS3_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3xvcDGOo0GINu2nPzgmAMN/f271d3d2bcc7cfa695e28a16d8e994f7/POS3_6.png",
    gift: "https://images.ctfassets.net/0rbfqd9c4jdo/5eovorNOIAgjMiCq2GcqPt/fbcc08e1d810b627a295b63803d0a6bc/pos3_free-gift.png",
  },
  POS6: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6GaFILrfOozlelhkiXhTpj/e66e5df9983e5015a9bb2184d5f4ff94/label-postpartum-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5fNBWTKOeGqll1PMtTMGSo/55015197f785965d6fb42a3b54ffdd2e/POS6_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6v7QVYJapNTwyTOSIxm1ef/265b61f1d6894f423fcf661e8a5767ac/POS6_3.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6v7QVYJapNTwyTOSIxm1ef/265b61f1d6894f423fcf661e8a5767ac/POS6_3.png",
  },
  POSFHK3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7o48MBneUBYcXTXjDm8NlX/841e4beeef9af2a31e3c6985486b84f5/label-postpartum.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5Sr3nQPqcihyjLBtWTDtCT/a56eb8ab3676895770d11c8a73bff848/product-postpartum-growth-kit.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1uagHOTkjKvi07bmGEV2fv/49ec129e2b60eaed903116b631a66f87/product-postpartum-fullest-hair-kit-pills.png",
    gift: "https://images.ctfassets.net/0rbfqd9c4jdo/cX398B1kJjijEDT6eA2ec/491751bf73c219c4954abe7d8c8f0ea0/fhk-postpartum-gift.png",
  },
  POS3PROMO: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6GaFILrfOozlelhkiXhTpj/e66e5df9983e5015a9bb2184d5f4ff94/label-postpartum-spu.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5nbbTkfSQCTUvzoQCy1mqd/dfe79ce501d9233cad73476525fc7569/product-postpartum.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5nbbTkfSQCTUvzoQCy1mqd/dfe79ce501d9233cad73476525fc7569/product-postpartum.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2VtRHG73WC3QeuvNIb7PYR/c6a35281b03f6aec8f7ee84367ea6f64/product-postpartum-pills.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2VtRHG73WC3QeuvNIb7PYR/c6a35281b03f6aec8f7ee84367ea6f64/product-postpartum-pills.png",
    single:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7H8sBxRaznUfLOsH3nYD5R/343ed428a1ae267d6a35d18697f7eaaf/promo-postpartum.png",
    kit: "https://images.ctfassets.net/0rbfqd9c4jdo/3Rp4NfCpKG4XUBdZxZAKx3/c508beb7c47ada379b3ced8ba720a8e9/promo-hairkit-postpartum.png",
  },
  GACTIVATOR: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5riNaThhDLnB4dAQvbLyBw/06376ba6f90b4b1679eec95c8c467947/Hair-Serum-ingred-list-cropped.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2RIBi7MAeaF3L6IgWDZsPg/b893cbc4d99c9554edee516e02ac493e/booster-hair-serum.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/CAByMuK5nVvSU2nvZvJRH/f86f4419bbe403ec1d347e19535bcb57/booster-hair-serum-pills.png",
  },
  MGACTIVATOR: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6W2qkWX8KXxuPcnrF0wDfQ/1a5519cde9fa4e249dfe55bfd6137984/label-ga-men-text.png",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2hN3xaMYUd9tqIGjIEtz2g/b6e51a39340f41dc618fed424b22f383/booster-hair-serum-men.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3J5e419fhYTIwGfeE0yZF2/f219b31c32224c6c73dccb41dcd54ed8/booster-hair-serum-pills-men.png",
  },
  STRESSADAPTOGEN: {
    label0: `https://images.ctfassets.net/0rbfqd9c4jdo/44wGHj2DXAoS3l12zTb6zW/5ee324e3f0532a9c30dd5f3925fdd2df/label-stress.png`,
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5ISs27oAWhhIv3Q1YNBkss/ae78e8e8c62a453956928198ec26048c/booster-stress-adaptogen.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4VfoDkAca2ccTXPi9YFhre/09535ae5dbcbb50657005e576e75fd88/booster-stress-adaptogen-pills.png",
  },
  BENERGIZED: {
    label0: `https://images.ctfassets.net/0rbfqd9c4jdo/1eE6OhiR08gVqxDcvM3G4x/d33251226f24a16b88791cfae5a2f684/benergized-label.jpg?fl=progressive`,
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2MkCRGxUOkRVWkJfHuoOsn/30e8e8168699c0aabdab52e752daa263/benergized-1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5eb7Triv3qZTpICIQUJHWu/05458c4e9bfaf8d4f609b41ce5d9a206/benergized-3.png",
  },
  HAIRBIOTIC: {
    label0: `https://images.ctfassets.net/0rbfqd9c4jdo/2XVt3oe67szfLdkJfHKRvz/18d3d05dfc727cd125083e47b6f25f60/label-hairbiotic.png`,
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1wc2ur9J0tSTbfgCtHr09P/36536f4db9daf875138011e4880e40d6/booster-hairbiotic.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/53f4uoZjuEavu6H70k2sEj/34084bcd8843ec331ed0f4a3321bd793/booster-hairbiotic-pills.png",
  },
  DHTINHIBITOR: {
    label0: `https://images.ctfassets.net/0rbfqd9c4jdo/5d4cvYcGl5wNPgoPepKBi3/6167fde0662532520b014a824fbc09d9/label-mens-dht-inhibitor.png`,
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6buEEnV6TLyzB6LXCdO1ze/97cf61a207fbd3bccee6b7c6a2c11ac7/booster-men-dht-inhibitor.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5XCwEzMuMHReMb12Bi4mpl/2907d8d2bd109eb17af8396678d6ee07/booster-men-dht-inhibitor-pills.png",
  },
  CINFUSION: {
    label0: `https://images.ctfassets.net/0rbfqd9c4jdo/2SD5QJk2K3XwK58m7OvHJq/a3f633eae249553a5c60267fd7dd00b9/label-collagen-infusion.png`,
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1SjonRAthhIY0s2h5iE6nF/e7d36ea4f4ca92cec3e06ca4abb6e99c/booster-collagen-infusion.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7N5pBQBpj9Kp5QPNiuLiv/5fc59d5af6ab800511198263fdd30801/booster-collagen-infusion-pills.png",
  },
  CBUILDER: {
    label0: `https://images.ctfassets.net/0rbfqd9c4jdo/1amT6WITYF2UYImZo3TLJ3/fa2f9c66ac0b16de4899473dd06385a4/label-collagen-builder.png`,
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2IvaP6p3rY37CMbbyFQlrn/c1e86decd6e681944b10b1c2020cca25/booster-men-collagen-builder.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/24DB5ap5T0OP9CYfORHVBX/c56d669be6e7ad022383e9fa50e820d4/booster-men-collagen-builder-pills.png",
  },
  HORMONESUPPORT: {
    label0: `https://images.ctfassets.net/0rbfqd9c4jdo/4Ou7tW1WBwFukVfRgV58gl/e59f93208d0ae6f03a35e32aaf48f857/label-hormone.png`,
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/73RPc2lEk8d7SR3AejlDHC/0180cd6fed39a9e7883e4af5f7930f7a/booster-hormone-support.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5aSZOBOQGINQHvDW7JNX7s/f560573abe0ecd5288c137b9bf0b3b23/booster-hormone-support-pills.png",
  },
  TOXINCLEANSE: {
    label0: `https://images.ctfassets.net/0rbfqd9c4jdo/22FbL2aaBzmiCUVredz7pr/4f86a4cdf80d4ef70000856d309e8844/Nutrafol_Toxin_Cleanse_Supp_Label.png`,
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/62aQ7nswZ7PMT1nI0co3Zl/19004bb42d7c32c60b53618a65b47240/booster-toxin-cleanse.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2qLbmNKsnmaHZVUbWOQLOs/de66c82e7683acccdaf9c7e3d9ef830d/booster-toxin-cleanse-pills.png",
  },
  RPURIFIER: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3nk9XRYKyUmdlbOpXFmLB5/010e06f93aa51e4ca3ed75576d581aa3/scalp-root-label.png",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6sryivVHYAMr2cmLj3QvML/9bd9c8db40e6f804a5c1722ac8dc959b/RPURIFIER_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4p9FrjehvQtXofAuJFzgFe/00bfdfd3ec68ae55feb2a363c99931c6/RPURIFIER_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4q9rmMEYPhE0rW1ZPH3Oz9/93b64b9d425ea392b96f40e5dd5f5b0c/RPURIFIER_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4nSaF1WKJQQbLFun5NkhS/35baf41c1395fcfbc12568f8090e347d/RPURIFIER_4.png",
    travelsize:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1mCZxyGtHz7wMLTN8CTfj4/666a2aae9defda53e041af2dc979fe79/2oz-Shampoo.png",
    lifestyle:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4ytqI6PNNbbvxHww4H8QFd/fdca5de95a78481867234a5ff13789cf/shampoo_main__1_.jpg",
    lifestyle2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4WUYaVfzKg3leOYygIMrN1/220e6f31a301ccb665d8eff69ed75707/shampoo_lifestyle_2.jpg",
  },
  SDEFENDER: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7zMXlrbPWZoeTDJst9rDb6/6a3fd43a644719b4f17dc7fe13623071/scalp-label-conditioner.png?w=780&h=780",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/34Yy0gqbhIS4hBl2LnaUJm/3e94cad154cee9ec4f0adea676891c6b/SDEFENDER_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/66lmYqyrjhzqi1TmKMLUZq/4b11812a154ad3d45fb0d3daca627b75/SDEFENDER_2.png",
    travelsize:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4BFIAzMjdbJAtmwullTXWf/736285a66799957b4a0f096c736d8ba9/2oz-Conditioner.png",
    lifestyle:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2J4Xp2FlCQHFImt3NBpQ6c/1ff3bdd5a641c3f8fbe588802e90c30c/october-crossell-conditioner-modal.jpg",
    lifestyle2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/101e7M5OXVeScAPIdQo6yA/10ba63d6411d162be97f674e2142f184/conditioner_lifestyle_2.jpg",
  },
  BBLOCKER: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2p5bb8rAHwMLhqHTmAeU9p/a82eddc8a18389381fff8c6efb9ff9d8/Nutrafol-BuildUpBlocker-IngredientList.png",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/36EbApRXzDoLaigqTDPXAp/55d2569a82b9b9d03a3be6f1db49635d/BBLOCKER_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6DDQ9o6owGRkqbj98uDE2j/9cd2ecab19e010d2251ca886e2b3f4ec/BBLOCKER_2.png",
    lifestyle:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7l3QhvRtyuz34dbajqU6Jd/c59a3beb12589152e75ffaaf6a87cb94/scalp-mask-main__1_.jpg",
    lifestyle2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4PhmM26DKRv1kJXJdgs5i5/8225ef8528fe40481cd96c1cf4eb04b4/scalp_mask_lifestyle_2.jpg",
  },
  HBALANCEKIT: {
    label0: "",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5kbFo8s3TSyDrAPr0KkfHb/50d4769617be1838716ccf58d5d54e86/scalp-kit.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7wQ2zHt0VaS6sjMeKITcYU/77de442c03a2faeaa9a810fa656c9d84/scalp-kit-square.png",
  },
  HBALANCEKITFULL: {
    label0: "",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5kbFo8s3TSyDrAPr0KkfHb/50d4769617be1838716ccf58d5d54e86/scalp-kit.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7wQ2zHt0VaS6sjMeKITcYU/77de442c03a2faeaa9a810fa656c9d84/scalp-kit-square.png",
  },
  SCALPSCPROMO: {
    label0: "",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/v4eHe4ukcnag6K7aLkbHL/318e0d26ff3df9cc80deda0b97a2a074/Substance_On__Badge_Off.png",
  },
  SCALPSC: {
    label0: "",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4EEXboFQT8A9iIKR9JuOse/8ff6637bb1533cedcc14ef45a1ca3187/SCALPSC_1.png",
    label2: "",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/v4eHe4ukcnag6K7aLkbHL/6c346d7c6885dbda85e289e7f23aed7f/SCALPSC_3.png",
  },
  SCALPSCK: {
    label0: "",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Snu0puLYUwIKcjYIvzasB/78cb01ff243726a6aa7114917abec339/SCALPSCK_1.png",
  },
  SCALPSCGK: {
    label0: "",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/71Bol5EQ9dIyEdFB3NATEE/4e8ea4a7c06eded920c8e793cb5527d2/SCALPSCGK_1.png",
  },
  CAREKIT: {
    label0: "",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/RddNmQWR7aeHHk0jjslym/b7c097e26ff9b5841c38f36b07c37388/CAREKIT_1.png",
  },
  BAL6SCTRAVELPROMO: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3H7WFKiSdsPBkvEzOmcvro/981affd0507ee9d919c4ab29403ab45d/BALSCTRAVEL6PROMO.png",
  },
  MEN6SCTRAVELPROMO: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1PGf7MoLKPPjYfxBRldFgs/a3cd274afcdc17491f6b6e83d0ae8943/MENSCTRAVEL6PROMO.png",
  },
  POS6SCTRAVELPROMO: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7wfPSrxmQ1JzSDBfrzzJWe/9aed750a29f11903f2382483a8f24904/POSSCTRAVEL6PROMO.png",
  },
  SCALPSCTRAVEL_PROMO: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4MImsLxKB09AbbXOkrMJi4/fc10b5458988965525f3a4bfe96bbdda/free-two-items.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/42C9EvXGhIqqY8HXoFroBZ/ba93ad4299e67f8cbd8a063359560ec6/SCALPSCTRAVEL.png",
  },
  SKIN1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/20gZofbMylOOheWcFBnsaz/1170675cc6e71f1099e8026cb4aee609/nutrafol_skin_supplement_label.png",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7hjb2zrgbd4RvtlNWrCl9K/a4e604a141d363639fb47077bb87f5ce/SKIN1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/DGFd6iyouc8rRO33iupSW/6d4ac2624224892162cc3bd33466f2ab/SKIN1_2.png",
    alt2: "Clear Skin Nutraceutical bottle with four pills in front.",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/32iZ4ig8h1gJM7xHcGR1bg/ee2dc517bfc54d5b3c4f12c7d20a0821/SKIN1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2dElCLVWQ28yn111DgEQr4/0276363bf213820ef6907b4da0a200e6/SKIN1_4.png",
  },
  SKIN3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/20gZofbMylOOheWcFBnsaz/1170675cc6e71f1099e8026cb4aee609/nutrafol_skin_supplement_label.png",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7a8G8YHHxMmVebjROKQ7t0/543a037dced011acd5508ba72d50382f/SKIN3_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1SChcbHfg8gnPY810uUQjX/04360e6996e01979d6759d605bbb4d8f/SKIN3_2.png",
    alt2: "Clear Skin Nutraceutical bottle with two pouches and four pills in front.",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4mxncFJA4aUNuPqcH3aM7Y/0b5b9a8d67b1ae0632a7d444cd565c5b/SKIN3_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1pGOGo9zGVFA2bfij6Hw0Z/eba6fe4cb4b79c9f47e189218ecd7b40/SKIN3_4.png",
  },
  HAIRSERUMSML: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5riNaThhDLnB4dAQvbLyBw/06376ba6f90b4b1679eec95c8c467947/Hair-Serum-ingred-list-cropped.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4TX6M1V6B5C705wKxvw7Tx/4454569ed7ca6c582d9813e8cafcd882/HAIRSERUMSML-01.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1d7QbGPNBEeMCAqySd5AL9/cf7c867206f4e13ea090e742f00783f9/HAIRSERUMSML-03.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/73Gb3KtXPddYbCtFCTgiHU/5730bbc57b65476eb0ae628a898a396f/HAIRSERUMSML_6__1_.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4RLaNips2EBghU9WKpQlyd/b389859fb440b89d33eff5919508f0d1/HAIRSERUMSML_4-2025.png",
    lifestyle:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1ExTQmwtesxfHwA6XgVR81/b00f6063bbeaaef483e0ea7f26c371c0/october-serum-lifestyle-image.jpg",
    lifestyle2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2kGf40gYPmKKBzbOZ9tBl9/07aa9944e9b47f6909619ce3b4805bc6/hair-serum-lifestyle-img-2__1_.jpg",
  },
  MHAIRSERUMSML: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6W2qkWX8KXxuPcnrF0wDfQ/1a5519cde9fa4e249dfe55bfd6137984/label-ga-men-text.png",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/lSlOwd8r5CsL2tzQpzIFQ/63add9a8234db08d90d46754d17fd7eb/MHAIRSERUMSML-01.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/75cULbtPOzuJTTgNgSnE0i/80a0cf6bf1fc0fcb7669becc3041440c/MHAIRSERUMSML-03.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3voNVi186ZJZpjFLVkd792/1b99db008d4ac3742299da089d89aa00/MHAIRSERUMSML_4__1_.png",
    lifestyle:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6c1EPM7i2dwj4zaZlx4Z2i/8d573774db4de96560e1e04e4db585c2/october-crossell-men-serum-modal.jpg",
  },
  ACTIVECLEANSE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4TXfuiun9x1vyGm563xORZ/7987a1d6b2e2c729c194eaf5c8c1e17e/active-cleanse-label.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6atjN1xczKEwJSoY8WTkaU/da02796d49b69aa968b05484818b30e2/ACTIVECLEANSE_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4IpQb32A93BHRNRiKCzp0z/03a8e300066a99fc9ba92d0f3113c91b/ACTIVECLEANSE_2.png",
    lifestyle:
      "https://images.ctfassets.net/0rbfqd9c4jdo/59HI2zXJSq74iUqfrqclTt/36bf1f6fd75340c49aa5b29395e004f9/men_shampoo_conditioner_lifestyle_2.jpg",
  },
  MENX1: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5bCmCfklc8JoTE9tXQq4Tw/a4a5b5691b0f0e538d44d95efb5431d6/MENX1_1__1_.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5bCmCfklc8JoTE9tXQq4Tw/a4a5b5691b0f0e538d44d95efb5431d6/MENX1_1__1_.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3dfBw17nBZI3HQnPK9HENr/ea5f6396d409183ae7ee5a54a8046163/MENX1_2__1_.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1tWI91sSy8q50hUTUAW1wr/6d70a9e7e4a3ac6c424f54ee7deabb37/MENX1_3__1_.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5LdbN9GTT6PiSQgBmmMFAs/69d123525429b3903192d87e4742b560/MENX1_4__1_.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3nhlEUGLbGxDe6Ff41AS60/8b0f95e3b81b784f2010f7e56a5e75b1/MENX1_5_1.png",
  },
  MSRX1: {
    label0: "",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5s6FDTE9FonIm8OaBl38C/7a97c4a025fadf8c5083c7950ceee6e7/MSRX1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/43NZA9Z660JBoTSVtNxajc/b94e816386129f7003ea9aa1c38cb049/MSRX1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3yiuia3dQUjab0a2grBlI2/03929ef8cbbe5d46083a3a9067c95b6d/MSRX1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2k527ps9CfzxaNvKE2e6xi/473232791941b9768ec5f8fd272b66ac/MSRX1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4yVTb4EHA43dHZ1A17y4ol/b12cb79fb6b40cde43770e24bdbfb9e2/MSRX1_5_1.png",
  },
  MENGSML3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7m86g4SYY14QOd52yYH0x7/9484fee420d8e3ef095ac94daf73c9a3/label-men.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6LsQJouiONFmt0znRYo7Ch/2032d370e892c1bf75424aacc4475c53/MENGSML3-01.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/YMgoCWk2zXbKREGfK64sY/e45068a2c0baa5ae81303b87a49da55a/MENGSML3-02.png",
  },
  MSRGSML3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7m86g4SYY14QOd52yYH0x7/9484fee420d8e3ef095ac94daf73c9a3/label-men.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3RXGKLGxKF88UBT9kPStgE/d416aa9b72b16edebbe0a005b1d32e5f/MSRGSML3_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3RXGKLGxKF88UBT9kPStgE/d416aa9b72b16edebbe0a005b1d32e5f/MSRGSML3_1.png",
  },
  MSRGSML6: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7m86g4SYY14QOd52yYH0x7/9484fee420d8e3ef095ac94daf73c9a3/label-men.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4KiRQFpOLgfNuE5RGAO4Uz/525db928f24ad56b546e056161f9c83d/MSRGSML6_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4KiRQFpOLgfNuE5RGAO4Uz/525db928f24ad56b546e056161f9c83d/MSRGSML6_1.png",
  },
  ADVGSML3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4xaoBpVr0vpHNf8klTjewi/27b20064dbb6e403c6cb225da61e0a9f/label-women.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6wwxEVGkYF8TBGPn8bSpc5/a4341036ff0145da770b8106493bce6f/ADVGSML3_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6wwxEVGkYF8TBGPn8bSpc5/a4341036ff0145da770b8106493bce6f/ADVGSML3_1.png",
  },
  ADVGSML6: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4xaoBpVr0vpHNf8klTjewi/27b20064dbb6e403c6cb225da61e0a9f/label-women.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2zs9lqYrzYioSwfFL2aU65/cde2557ba00fa73d71339f3f1a7205cd/ADVGSML6_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2zs9lqYrzYioSwfFL2aU65/cde2557ba00fa73d71339f3f1a7205cd/ADVGSML6_1.png",
  },
  BALGSML3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1MvolZCdspa9FD7fdk6VaE/0544e2e8bd86e9915a02679c39f359b8/label-balance.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/43bYh5dapRAYC6nlET2e4q/6397d1422cb77c0e4e3e2f26eb03b86a/BALGSML3-01.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2Q421M65V6ejJHbp7MD37X/9a4af1746f237b75c2ac2a57d50b9b53/BALGSML3-02.png",
  },
  POSGSML3: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7o48MBneUBYcXTXjDm8NlX/841e4beeef9af2a31e3c6985486b84f5/label-postpartum.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4V0LfUNeudUdKACuUblvvU/5ed95deacc7cd69286b244d75b6c3fef/POSGSML3-01.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3lnhOXh3645NmVklFrTUBD/fe63d607bacc0dd45629296be25f96f8/POSGSML3-02.png",
  },
  MENGSML1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6W2qkWX8KXxuPcnrF0wDfQ/1a5519cde9fa4e249dfe55bfd6137984/label-ga-men-text.png",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7y3HszgvtjBLaq1BainkFI/44134966c0707ab2f4ed8bcf228ebb09/MENGSML1-01.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6hKbJSUvoKtzL5l3Cnp2Kv/db293160145c93d37a3d118c1812a7ac/MENGSML1-02.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4CntHAIM17FQ3fAhTwkutr/04bafeb57e6582f731f0d342ceff09cc/MENGSML1-03.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6UBfcrvkM5pHp08Tui2DQk/0cd33e0b4b727ac3aaf22b1caa4916e8/MENGSML1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6a6Bl85oe5laig3J5dU99W/39b604e1bd0ca6c5ee22a876a46e443e/MENGSML1-04.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4WgwInwanU1DAkeqBuG6Yx/aa5f4b686ea4e02fab69dbef3489f059/MENGSML1_5.png",
  },
  MSRGSML1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6W2qkWX8KXxuPcnrF0wDfQ/1a5519cde9fa4e249dfe55bfd6137984/label-ga-men-text.png",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3RyS5cL3Ro79njDBYM3dzJ/6af39537d80254c9cff86caa5ec6fde7/MSRGSML1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/MyYPoD6yveWF4uBPnZUbV/48dd14d6d6179f55647ef521b8edff58/MSRGSML1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/NOegwCHtCZ4qrxwYcLgBs/fc91864d794dae8e833ddb57fddf4163/MSRGSML1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7954HgmSz7jQ2UaJFBzFQN/b553c40eb95077bd7948ed923d867b39/MSRGSML1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1P0MyEkYzaQG3GporIwWLB/65d3b7988d8851fe611559c48b644dae/MSRGSML1_5.png",
  },
  MENDGSML1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6W2qkWX8KXxuPcnrF0wDfQ/1a5519cde9fa4e249dfe55bfd6137984/label-ga-men-text.png",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/kVUb3bfhZX2AOx08KeK0j/3582ee16b89bb760ee45307d4a38712b/MENDGSML1-01.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/kVUb3bfhZX2AOx08KeK0j/3582ee16b89bb760ee45307d4a38712b/MENDGSML1-01.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/kVUb3bfhZX2AOx08KeK0j/3582ee16b89bb760ee45307d4a38712b/MENDGSML1-01.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/kVUb3bfhZX2AOx08KeK0j/3582ee16b89bb760ee45307d4a38712b/MENDGSML1-01.png",
  },
  ADVGSML1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4xaoBpVr0vpHNf8klTjewi/27b20064dbb6e403c6cb225da61e0a9f/label-women.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/16xJUP66K5sIbdpRmBNWX8/b9ffcbdcad1296226bc4af508bffc313/ADVGSML1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3CQaSdX8VW2ekRDOjMN8cy/a250549d89a1e0828de568c80de40eae/ADVGSML1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5aPiubEp0fq1hPESGmLuQA/af50fbc7f962985473dbe2bf61ad2d5c/ADVGSML1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/662zlg8xJaXbWJH3uwLDIY/aa8250211b032276a77997b441180486/ADVGSML1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5zobbdqVGaz4Y8cnyfrN5X/d4ab371fe71e5b89cbe652b735f4613d/ADVGSML1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1wON0pPipSCJlJ09IwVYEq/6d1c8f6db93275c7473bd94d0444f203/fhk-wom-badge.png",
  },
  BALGSML1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1MvolZCdspa9FD7fdk6VaE/0544e2e8bd86e9915a02679c39f359b8/label-balance.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5xowfvJk0EZHOPmqEHxoS5/190efd8d3cd11029cf98933572a3ceb0/BALGSML1-01.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6BZsABz9qAZCs38QwXNSV/d3b52ae2576721e15e9a65123e1784e7/BALGSML1-02.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/xa6R92RAVHWtaPnG3bG9E/66cc0edb275adde449696189a29b98b8/BALGSML1-03.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/50f12psRdCpwwvWOtwBm9A/5f3a5d3a2b03b2cb9ccc8b2c8a970a53/BALGSML1-04.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3XCN8Yn32ljuv4e2qtXdwJ/5107b3a6f9336a5d6edc3346dae4b415/BAL3_3.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7AYTt76RtHZIRsqfXqzf05/2eb24a5f92894fc9abd4ac67c8f1057b/fhk-bal-badge.png",
  },
  POSGSML1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7o48MBneUBYcXTXjDm8NlX/841e4beeef9af2a31e3c6985486b84f5/label-postpartum.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6nCmbA5B9sRb8QoOYkDacG/cc11ad165c1a30632fb288df4c6ebdfc/POSGSML1-01.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/UPO8yBAmXl4IQfkUGVsyd/83d91d13f7de5eecc51581e7bae681d6/POSGSML1-02.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/nrR6fX8pIWvX6IQ4VNzgj/457e66da43548bb27f11cf7545a89030/POSGSML1-03.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/37eG3PzJ2RjJ0kQn9Hmo6b/aa113b4277574531438248cbba18e492/POSGSML1-04.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7LHbxYgcYggU9AVoVwD35F/b859f03b5fa96e83e65e6b554b950e41/POS3_3.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/vc9wlZlMxQtVUmxmTYOiQ/942d6f2806aaa07bd85cb792500235fd/POSGSML1_6__1_.png",
  },
  SCALPEKGSML: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3vQzWKeK2779w07tmcaFOH/a65ba17a50805fea63424724cf8ac9b9/SCALPEKGSML_1.png",
  },
  SCALPSCGSML: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1ayPA8zEE2PoJobxmK7rH3/2d61c659d2bf8cbfa7c0b37ef6b158c3/SCALPSCGSML_1.png",
  },
  MSCALPXGSML: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3SI73GvXuKyIpQeIyNWu6I/c651dc7b59f6d439b05030ae242c2437/MSCALPXGSML_1.png",
  },
  DEFENSE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/LVpzLpiERpgKd8odXVAj0/fe98101d15a1114e204b7de8df83219a/defense_label.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7miB7jsGSKgSllbaiWcdzw/a127a846dad689c60a6798c8d23fba8c/defense_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1gjj9RrKIBqkUpycrhZrWT/0127688fe976b4d4fbdc715b20b5b2c6/defense_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2Nqt92VBXADWezab9U65sH/fd58259b239497135b7aac53b3e6ca29/defense_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1IB0hZkbXYBcTAl1XQkAYE/691b606147669c723b830354c5ce6dc7/defense_4.png",
  },
  EQUILIBRIUM: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1mBhe2AwSZUYEhxxNx9VqI/e43462de9e543930e68a2b1d6df7d508/equilibrium_label.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6mU42sAKbdRR42Idd9LNpO/b5ca787c8d70ca146c710953b75b22ae/equilibrium_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6MBKqR0Lt8iOyz7WBvTaVl/83a9b446fb511e36f205b52504683855/equilibrium_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7qsM7tLuMKg8z89iceTh87/4295e3d24a92c619aaaf1978a44a549d/equilibrium_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5K4NUnfQORsS8TPbdu9CuE/44f6b5fc8554537f15e5231dfb80e936/equilibrium_4.png",
  },
  LONGEVITY: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7qxBDM9HU9VEgIW5hyFJLJ/d8aad2b6da370f6c3b6d44be9db9196a/longevity_label.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7FuMhhkWyJjpqxzhfWuQb1/1da585dd42306a6b927ec9ee44519380/longevity_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1JFsDw9FtThg00ZEXJcpSj/df329135cec51af3b2fd067d0650b122/longevity_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/53k9xYPYQw4TiWrcLlDeXc/91b18a3d715456c9a179a999fe865ec9/longevity_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1oMYZAB0R1l7Xwulcdwnvv/63682423479e14824899db77d4da1899/longevity_4.png",
  },
  RESILIENCE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2y1mggNyT7yiPohDhsmKHP/d2410b36082b3576dedce35022da5957/resilience_label.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1aswV83XljPskj83P6XJOD/4f6599d6a9426dcfe890a8d598432e31/resilience_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2H26WYVTyiXRiLnOsUaIA4/524c7af337246e07c309df1aedaf4d0f/resilience_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3C9Z91KrcoNzXtksUdYVfd/262d05fa80fe2767b7df7871fc12d856/resilience_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3apMedD6s0SJW5npjvh6TB/6feece3f502653fd1f2d4207ddac4d74/resilience_4.png",
  },
  SHIELD: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2rRd2FMO1OGtowc6AARfUx/b8cf5a053b4a511ce41d19a75b983e0f/shield_label.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1FRVxoV5kxsOY4ngV036UF/909950540be69373bd9197a93792fa43/shield_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6GZRgJItRuCY7g81aZtutr/c3b60c70b946a6cde3352f2d7f64ccca/shield_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/fF0dVWgkTRxt8F0lHOBab/14874d2e997d5c1ca62da166a6f4d3c7/shield_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/64KsM8l9r6eiQ07qMsPQM7/5291ca799d7f69b5d7defe8aa4d19dab/shield_4.png",
  },
  STRENGTH: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7eM87X6LksORINynk5REPN/c6decd249e6bc47884bff3383192e6cb/strength_label.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3S1VqdSpDURR8VXcynCFVo/e72dac3cda19afd78470dcd9b37d7e2e/strength_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7tNiGpASI5wtpjcRTXFRap/1ac22669ebbae06d18f1bd66cb7bf568/strength_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1W7jhiK0N0boFPCwqKOh2n/2d2dcb421ba8cdd92cb80425243acb98/strength_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6PXKD6sKN4aNO9iRE5cih2/31ee88f9560bcb6e73e67cca3b071436/strength_4.png",
  },
  SYNBIOSIS: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/DrvMN1LDqu1pYzks7Pr0Y/7e319225aaa794d4d1e826cd841559c9/symbiosis_label.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2YsTj2emwnWnSV2eqGyGbi/ef56d70281080412ca0fca15ff3479c1/synbiosis_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/44TJ2fWe5Ef0mKAJ1RidMx/619fc479aa6dc7f96df622f7ffd47f41/synbiosis_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3PPJuWEqHaPHqy95GuItvh/c9f5d417e828c0138ba61e508e1bd18e/synbiosis_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4tmQMnz4jfubyKokluuWhJ/e8d9bbeac2cb49c7f9f6391f8a79c19a/synbiosis_4.png",
  },
  ADVAC1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/41k6y9QfVPYGz3NPe5UElU/eb048fec70b838cbe96fc191d91f2e75/label-vegan-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1TcwfGL6tXlW3bstDrgdMY/aa6aa02b4e1f18232f098304e2c04971/ADVAC1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2nMrYFibFsR1svPNAK9Xrd/1df81a3def156afe374310c00ecd20a8/ADVAC1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2nShlJXy2Ifwg1S2pveuHa/bf0805b7225591e211ba848c2eadf2f8/ADVAC1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3jitQklNz10uOTDEfE8pPw/46cd4036f3abf9a356f1f7daf4e22e46/ADVAC1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2E8uGd4jVnJI8UrxZ8Jsm3/6a653de2b33ad1ca4d4f0865a28f3e98/ADVAC1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2FJxLo8NaIfCUkbsPqpNyi/c3c570baa60da61add384f75aa95b474/ADVAC1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Sh576N2NjPDH0lYlSm0Fi/9aa2e36bb9ffd03870ed0eb3f3b089b5/ADVAC1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4lexfy3xG0pDpFlwdwVf8G/2dab788711c0af06b61a547cb4c9cd06/ADVAC1_8.png",
  },
  ADVAC3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/299haj5K4YT4DbqsIdVB2x/2798abb62109771d8840ca286d1933ba/ADVAC3_1.png",
  },
  ADVAC6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5YjUu6vrFzD13HQzvmNYgp/63e1732e2f7323b2ec38081bd55a27b4/ADVAC6_1.png",
  },
  ADVAS1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/41k6y9QfVPYGz3NPe5UElU/eb048fec70b838cbe96fc191d91f2e75/label-vegan-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2467eLgLz4awmtU9Vj8toS/ee1db9c3af5a946a685e4e323cd1abf5/ADVAS1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2sfqPxm6aj2IC5AdfUVMVr/f890124092aef45cba074a43f09213f0/ADVAS1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5R6fGYqp6uwOolZlCcol7s/e54180711483331fc3a5b7aea5b7692d/ADVAS1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5A3fwD4vTR0il1ROXjwOl1/8bfa5b9a4f29836a6bfca64501b4b22f/ADVAS1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1jlGLQx5arYKOivjE9yJzM/f960000b91aea4ea74739b6cc9f8cdad/ADVAS1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Sbp7YqRppaskUisPEtS2f/b1dc2e3f2e91303892ce9b6f02836b07/ADVAS1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5rl2fYP624C1HiPfoLTNkf/243734f300a86a13ab416e5113c7b568/ADVAS1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4ZJHJ5gk6cvPOv53IJvBR3/1a7e377999c721d8ea472ed5ee18f773/ADVAS1_8.png",
  },
  ADVAS3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5nQCYn9Bbpb2qXIJLVDpYv/f05cf95a566f7c70a04456c104e57a50/ADVAS3_1.png",
  },
  ADVAS6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/50yqi401SkKeeFttdRsSGL/4c41290545b1fa8904e46b66ba03bc42/ADVAS6_1.png",
  },
  ADVAH1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/41k6y9QfVPYGz3NPe5UElU/eb048fec70b838cbe96fc191d91f2e75/label-vegan-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2fxJo22wNc80SgzvFKsE7r/a73e8f9e428ea68b84f9298c6638b68a/ADVAH1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6PVQ6wJuWJLmAkBCBq158Q/a3c5638980f9612be7f8904d808784a7/ADVAH1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/I235sfkszuBPqcsT3w7gG/3cc4e5bddeb2f4028b5b22cc145dbd28/ADVAH1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/135aJm5KksIXsKwiocyU43/16ab84f0d16af8565d1efa344ab6a07d/ADVAH1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5Ijfjt3P6AY6yEryFkgoIb/bdcdee0780c1a6d17ee9eb532728070d/ADVAH1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2Z2ZSKxd9UiiJiz0GVQyWU/6cc10af006479cbaaf156bb4c2077f77/ADVAH1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3WFarFki1bbh2jqAfqwrBW/2de86347b3440588fb00b68da48f91fd/ADVAH1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/58ef50kcQf73zwbKtAfs9A/8abe5edc81befb5ee6456f9430f59d54/ADVAH1_8.png",
  },
  ADVAH3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7ax70RXhWrO2lSYK4QIlqJ/e999bb84e606bb32b642f0a2fdfcbed4/ADVAH3_1.png",
  },
  ADVAH6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1ua2J0UW2gpGAu3TxVjGuU/e8fb74f53511766ba7929766ebf1d7c2/ADVAH6_1.png",
  },
  ADVAB1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/41k6y9QfVPYGz3NPe5UElU/eb048fec70b838cbe96fc191d91f2e75/label-vegan-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6yiErwdbmckWrsB4UvDhP1/8513b624448b3c1cd5fbb9e00bdcb82e/ADVAB1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3qFpHlck9DQr3WSuTkUySe/4276bea5503e5ddbc8a858f8d7500431/ADVAB1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6gTj46oGGrtjIPZf6d4faR/24802d40e43d97e307f1e74bac0762fb/ADVAB1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3UP1WsDszMbE5R5XUHatfW/77ce6569f92ec84a90e92d265959cf63/ADVAB1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5WmVd9f1erQQp9yNdvD7nF/b9fcf76e198dcc42e50cc3ca32cdaf1f/ADVAB1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/47ckMJLDSQDg2TSDaQf3GM/e9be8de76a862b577659ea2a5e3f03b8/ADVAB1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/28wvw6yfMQEy2hz3KXsHo2/0b6bfc970178d435971cd02aa6851a3f/ADVAB1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/24QBPdRnFotqMyIY0jGn7x/6e192878d57e18b95a46e03404efacd5/ADVAB1_8.png",
  },
  ADVAB3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4aBC7v6S2g0gh9nbLZ5jta/3ddc84fa3413152c0d6da76e299fe1ba/ADVAB3_1.png",
  },
  ADVAB6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/aor94i2pXVRZGiK6K7k3j/4adaf6573359c5527d4f4fada0c64735/ADVAB6_1.png",
  },
  ADVAM1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/41k6y9QfVPYGz3NPe5UElU/eb048fec70b838cbe96fc191d91f2e75/label-vegan-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5yeOSsIQjNLamGsDbCtRAW/9e435fbf31818285da0052828e58a887/ADVAM1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6ZUXBKNuq7veJY5A4hStqX/4293a923bc00a75dddc079338fc24014/ADVAM1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1v5v77iilhFp5Evw0SSoTt/1811f516091f0323f2a730caea5b7ae5/ADVAM1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1lb593vbY81PoCpVTzBbDL/51d2adce00031f035a16c0c67250492b/ADVAM1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1IBxcqPofoW7zz9pWfXrXi/d11ddbd3632b832cd17f667a44c0d5a6/ADVAM1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7ThMqgQ12PU32aWKIGkJM/8a881eec3db30cdc36300622666ec511/ADVAM1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2lc26Pkx4Iv42tBNgqZ1ks/6ccd57497e47160c2b00ba290d3064c7/ADVAM1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/14EgULPP2uAV51nfbGUZUb/ee54d8df7ea54d3f82c65d125a74cfb6/ADVAM1_8.png",
  },
  ADVAM3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/OXM4PfdwNVNoFftgxxLwI/7605c4f33b816fd3e9d6eb7c3b0a866a/ADVAM3_1.png",
  },
  ADVAM6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1mxy1VdAvWCiEzydnLpWQY/ae0cdb33ad38f37adc0c9039942b7e5a/ADVAM6_1.png",
  },
  ADVAT1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/41k6y9QfVPYGz3NPe5UElU/eb048fec70b838cbe96fc191d91f2e75/label-vegan-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3LaPmSlQe8uGS1kFAZHhWs/4d6531eac263916e675ccad648b09932/ADVAT1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/QzlCQrXWuHQOFIeqZJVfZ/d9ec446baf9dd95dbea24ebda466dfb9/ADVAT1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/28M9V62lhTEoKvjPgEvi7A/465f29fc9aabe3d0c25b5466b42b1f30/ADVAT1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4DuLaxbrp8Aue8EMTZAJIW/fe58def1262ae592c3da9cb3dc17297c/ADVAT1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4qDzFNfJc5Cg3hz4GfDvBB/b4c2013b892e7237f640af0e8372bcb2/ADVAT1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/AJzfDnR48RYswB6Yz5GYv/070de0f56e8f4648a872d9e230b26ac6/ADVAT1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3tiVhvGfzrF5npcshSNgNo/a714e76e0ad0c70fd02e1fc297f6f9bb/ADVAT1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2FLNdV45G10sdWC9dUYzoJ/1b02bdabe948cfd293d5d066d2309912/ADVAT1_8.png",
  },
  ADVAT3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1mf87Gp1OwZVLNqXPbopTa/e5d2b7b4bf1f066f5862e74f749a4f9d/ADVAT3_1.png",
  },
  ADVAT6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2IxVwR7EambK3eolA3pfTC/db3351b44cba6598be091de2f7f9ba57/ADVAT6_1.png",
  },
  BALAC1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Dnrv2EF6zocSmtOhpOZ7F/483deea6c64ac0a46f981c6be2e598b2/label-balance-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6iKobV45PaP8QK4uiQr5QI/d80dd98e9e987387ef241292a1aa0ff3/BALAC1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/Nb9jktiXLOyVaXeWyfjlw/5cbdfdf4ca2cb493bf3e4bb4127e3cb8/BALAC1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2nI2WwTLvGhFTXS62iLm7R/d87b284d8ae6170693da2804e03e27bd/BALAC1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1H0DLJNz8dyZzeyrRXDbHT/ea715d7328883c4c9fec0be2765400fe/BALAC1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/BLuyZinjf0eDb7izvES7W/369b152367c81e94db8cfb282fa5959d/BALAC1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/N6TDmM7EME4FPnqxkZL2k/5e04db2c7d1c80b74b6183fe0e78d126/BALAC1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2pIv63xzwAGMQXc3OV3SVz/0a66c0d95e10c328497c5d57f5bb3078/BALAC1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/Fuge3S3r7VPGar5gxZ1lc/d783b886562e37b9c6a7bd0db4174546/BALAC1_8.png",
  },
  BALAC3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5zJoKejDfn5nPNcrrWVTER/43d6005d08cd0f5f1ed04afde1579c86/BALAC3_1.png",
  },
  BALAC6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2QPohoguR2cKhtH2PcrzLs/1322ca90800ac414fe3c02f304450ba4/BALAC6_1.png",
  },
  BALAS1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Dnrv2EF6zocSmtOhpOZ7F/483deea6c64ac0a46f981c6be2e598b2/label-balance-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/42XQWsEdnZkfnZMegAz0Wl/8ad0cac28d125c5e9041fc364fe41542/BALAS1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6SImCSUMsImYJ0CWYKiL9Q/c77addbeae44cded0c1300530342e043/BALAS1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2bt6OWlYNkae6TMYhfWLRq/1b73e5bc1f14ba1a8c35c5d1ae25e170/BALAS1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Lz2IObiacMOTCOU5oojbh/b5beb917a75dbb524389fb94324fa2b8/BALAS1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6HtIoXqqjrke5aEnP7Xs3N/0aadf59f94efc7bff682c7b2a550ab6e/BALAS1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4j2PMNTnMgWnJjbzw2N4CF/30829274155c0e985b446f5b5fb6daf7/BALAS1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1zF11MbuVEw0m4D0FdQVyg/7374d17511ed36c1d83f239d11ef4880/BALAS1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1krF6yUptd1JGu6p9DJ3cb/d12470cbb80f387bbf2c17653971c928/BALAS1_8.png",
  },
  BALAS3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1qXVVWIgKXNEZhD4QrwBnj/b76c7d0f07d41b526eb17dc48e451c7d/BALAS3_1.png",
  },
  BALAS6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/lq1lPcwolujjMBmRSD48N/65a18a6aa15977943161794e077f4fb6/BALAS6_1.png",
  },
  BALAH1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Dnrv2EF6zocSmtOhpOZ7F/483deea6c64ac0a46f981c6be2e598b2/label-balance-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5FT1hlho9sKjcAnmFwqgQG/aa855148d30a42aecc0a19c79721fc9d/BALAH1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7uN6UhM6yHL6YVlHK8eqt3/93bd62d7150ebffb143f4892b57e3b58/BALAH1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/30RBIxZVSFXYIFyJTpQGEW/470d25ac6eeae4585f6506b6b56625bd/BALAH1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5Fk7ZbMKk2xKa81NfaG5WL/f1e2baaf67cd2249fde1e6eedfb695ea/BALAH1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2NfgohNkhNN3AzvVfOg6x/8d23fad7f1ef78651f0e6224e534d658/BALAH1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4gk7pMqrEAxgapNbBD3TcX/00114cafb9afad0877d4063e076bd866/BALAH1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4hWrLz0AGOXDWPROZ70Vqi/c3dc5406a71d2f97c86094bc47431f96/BALAH1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6cOtrcWrba0arbeRpem3Dv/7ed481cc20a75375d274243854985629/BALAH1_8.png",
  },
  BALAH3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/MBi7oyaYmpLCUmnPPwGpQ/09e0663d90e6d980d22498813d652a8f/BALAH3_1.png",
  },
  BALAH6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/71IebuVgiTAu3iSa2stgVr/d95621ac48f5e2075ac72fc91aa531f5/BALAH6_1.png",
  },
  BALAB1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Dnrv2EF6zocSmtOhpOZ7F/483deea6c64ac0a46f981c6be2e598b2/label-balance-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1ZriHfr0iNgxK8UAleOYuO/3260fcc2c10a24bcf5d6783cd73c5f13/BALAB1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3W0S02ek4iTESuIIFmxDgr/495dfb30b9464e08a1f0591322d1acfc/BALAB1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1XmwcvqlF8L9T6pXNV7sUd/58ed2f9958f7154df3a2dcb163f5e51b/BALAB1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/bGBkhA0qbZfA3UgAkHoJK/4045430e5a8ad96fe4d54e252f80b26b/BALAB1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6iXs2CtpREvNy6Vs0I67H7/1cc033ac4ad7be0ed2bdcd27ef884c9a/BALAB1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6rUy3jtEvR0xH4gAuLFq2/600b914edd3659ffbf223bfb501ee765/BALAB1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7xhrvswAQSnzRAxPsrijRb/45cd3f8baf87c04151ebf15fd70f6277/BALAB1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6tiMYerMUIpmsGV0wt2jW5/c0d369c9e456ab363f1a0d96d39577de/BALAB1_8.png",
  },
  BALAB3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2vcF1rDdRk5GL2kWy0WlL6/224886b89c9971179cbb8e325feba410/BALAB3_1.png",
  },
  BALAB6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1lkoWCRUbBNLTQnqoocQY1/c9cdc03c60f294fc7ec486cd328b2ed3/BALAB6_1.png",
  },
  BALAM1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Dnrv2EF6zocSmtOhpOZ7F/483deea6c64ac0a46f981c6be2e598b2/label-balance-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6AUPGpUhkz07HVyGil2wtM/9adc2d9b9e8a382c1095512790513388/BALAM1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2hoJphiKo1DEg7R7fApP1J/b8d13b7f6cc664a9bf2d2a410fedcf60/BALAM1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3xoWnTrL2lC32dn3qSiKS7/5173842e9a52958895aaf9cc75356e45/BALAM1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7Cl7eBd8xhGMPTwGZ9ELTN/32664f85bdcf549784c650b41f633d2c/BALAM1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3SRef96GcxfTVZDKOX6PO1/96d0173ee972c325d253e719312e154d/BALAM1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3RsVT5SCyUa7nCw7qgsIGh/aa070a7c2b91c5151c010859f2bcd7f1/BALAM1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1dXOBrxt4t4fognm93mp9B/b0e7047ef17f81c1926411b4ed68763c/BALAM1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4fDqHVLKFKs7hj9DDczNi0/cc4d21287856cac69a5c4ccbc99b62f4/BALAM1_8.png",
  },
  BALAM3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2HbWMTfBuXHMrKzdZdqcGx/8859be375ef605f7b277193bedec91bb/BALAM3_1.png",
  },
  BALAM6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3Nmk54mCZJLM0xswLKfaHm/60b95f99a11145c7c32e634d33bf4a78/BALAM6_1.png",
  },
  BALAT1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Dnrv2EF6zocSmtOhpOZ7F/483deea6c64ac0a46f981c6be2e598b2/label-balance-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7EE1Z00iatQRCio9osBrWJ/85053bb9cbfe8e39e193edb89d20f88d/BALAT1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2Buasr61MxgSOQtnfMtWAw/cd156765240d8e126284cab3cc6f67e9/BALAT1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5O7fRQXhCu2QiBL9MvcTiM/30f3c346762c92c72ecf092af74945e3/BALAT1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4kVrkWkzwqfdSxUYyOXHpG/40f49fea1e64b3b681564b6b0608ee0d/BALAT1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Dvt8jW4bvNboEs8TzrOWA/8a6392b4964fde5867b76bb401c88351/BALAT1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3X7zW0QRYpKOmAz7eS9XC9/0e39d95d312b026932563c906297e4bc/BALAT1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1FrLdcRkZCsl8uaTijl9q6/f27440fb120de3a7ad99562ea50d2d0b/BALAT1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1nZvBM7owB5eliNQvl63pe/a9842d3b431c359849652e0333dc6f77/BALAT1_8.png",
  },
  BALAT3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Nd63XVqZQlqU5tvVpdf7L/e1a08b09c933af8cbf83a016cb3ceca1/BALAT3_1.png",
  },
  BALAT6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7cSeqwD3368nJ4cBPn57Bd/7d1a627e707935c9ea163017f419e8ff/BALAT6_1.png",
  },
  MENAC1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5GMRwIuDhdHgDUXeEIKA6k/806e421ca4adf50496456de0abd97673/label-men-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/43636tgT17iX2VwsE2FeIk/aa0146909560d912d403f89714c2e252/MENAC1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/CirfLENIA5tuOUL2K0mAU/1c3cd1942c77b4b2bc2a99fbf9fca070/MENAC1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6TxsJmP8YvyhhxhPz7QVep/59c904294129c0597ebac71bd7990a6d/MENAC1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5lHYDg61bXukBtgdAWZXLE/a3766fd6066ae9ae28169fc36b4fb930/MENAC1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1JacokQ0JjISpUKLgTPJTh/19f3f375af6d4f7e456ce1ae4b9c0b82/MENAC1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/66V0zKwBmqNGpWPM2k83Tq/52d858c7c3dd05714420cbe858e511d8/MENAC1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6pxxtQmVYOEg4IT4LHWUgV/44ab926083a52a3a09a395145fc2b563/MENAC1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2GObQKILhm8iwl49ylhuqP/b610a0949106298a34af7203f0ac1a4e/MENAC1_8.png",
  },
  MENAC3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2TVDiouBuW1vVLEGEXowMs/649d92fd00f010e6f35207cc5adc2a9a/MENAC3_1.png",
  },
  MENAC6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3TqGbWIPVCqkN5A6PJ25JH/2cc05cc3b37d1e60a92d113950c3841e/MENAC6_1.png",
  },
  MENAS1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5GMRwIuDhdHgDUXeEIKA6k/806e421ca4adf50496456de0abd97673/label-men-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/66wnsluwcb4exsNnRPPVA3/07bf960041069f6bba6104b19aac3aa4/MENAS1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1ELjAwZ4u6tmPLCAgcOS9N/d05f362f0eab67ebfc0e6be09ded2055/MENAS1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4bRy80Rx9AeEeBp5FccPKf/53cc04aacf1dfc0aa1a78dc95b368930/MENAS1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5V6vM7bnph7SRu54Ezhgn3/91235d3a7a6deb5ae028c6aea49dc3c4/MENAS1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/13Z9EONconjDTtnHNKTNXk/1c88f5582285c890c9d051c350f6649c/MENAS1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3wNqhzY9eRm56spAtzfMJ4/0becb9b13881de0625f5634c6bbf1c89/MENAS1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3Ew4dzBpZP7GEqq4XQRl43/31e0b241888e33ea6bb9a1a417ecc08d/MENAS1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Qke5EQWWYD6ke4GgF5URW/a31724b6a26c36429acaa1474cc3d4e2/MENAS1_8.png",
  },
  MENAS3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7gnOfQ1ILZSV6WDgNEiAq4/cf93c90fff5d789e8434982029ee630d/MENAS3_1.png",
  },
  MENAS6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3DouVgHFyKTH8kK8EkKKsq/1063dfd8e8faca6fec586db9a4148d6d/MENAS6_1.png",
  },
  MENAH1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5GMRwIuDhdHgDUXeEIKA6k/806e421ca4adf50496456de0abd97673/label-men-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7chvFnNz3Ul8Rhe9gQBD5v/7f13a418ced58c815fb98ade12dcd3fc/MENAH1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/zXxsUJGsGbtYlabAPqhwa/3721de27d96cc805dad40343633c3f4c/MENAH1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3zD7WxIM550784wQVSJDrK/565956080e5c00a52be36e002e5c4edc/MENAH1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6hKiq4zLE9yJK8oarNZmeR/b3ef094b9d7116d830d6f16be669af0f/MENAH1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3zCSujOevqkWKeZc0Fjt3S/904f27f8d75eedf818c7a5df6aba9391/MENAH1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/43Uptdu8hI5LnGJvuTSRoz/e75ccb48b29944d9ab8bd20c47889399/MENAH1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1HeVB41aGgSqqNErszuNwU/668fac827f16831dc4cce42d3321f7f2/MENAH1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/wb4mxpA9DBNJb6FeieLoS/c63035c9ee828cc3906a07e6f7a02b68/MENAH1_8.png",
  },
  MENAH3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2XGbHn2mXATR0jjgv6ZjnA/cc413467e46a7ae3df9e90b1d55585e6/MENAH3_1.png",
  },
  MENAH6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7HSJnET6cYhFBsG51nm0NU/627c6d217e42e5b5827e9e469ee76493/MENAH6_1.png",
  },
  MENAB1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5GMRwIuDhdHgDUXeEIKA6k/806e421ca4adf50496456de0abd97673/label-men-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4LSd9RdJc7zAK99NKHif1h/41718b4f0e838ccc1f8d48c5fdcbaf66/MENAB1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3XK3ZumRlQ0mh863v6u4zn/56b812b2ca916939a58e43635b8f5651/MENAB1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2TJfU2wS0w6POZlw1jmRSV/dfdbacc34f90e517e964f4326177b4a5/MENAB1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3WlnHy8o8SlzhXxwUnB2ta/d1e3c9fe06029f6eed8e16bc8c158a01/MENAB1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1l2aK6hghTtxNBwSHA4jPp/f6c07df11275483aa8b1fe1032046d88/MENAB1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6pE1iwnYz4NCIx8Q5ML4t5/714754683a3a9cc5aad1b5de80da3a8f/MENAB1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/70VNkJv597XrkpJLXChc7E/5222213bcde94af40afe5a15b5de0389/MENAB1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3Tw1YCdY9f5J5GwVVWXaG9/1681dbc15d02f1c0b70c2ac4268da7af/MENAB1_8.png",
  },
  MENAB3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/01M6zxZyOPl2uZOon9lZq3/8723db7863067490fdedc997d4e6b46f/MENAB3_1.png",
  },
  MENAB6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/tUveuG2YaqYRgZ3XcwbyW/f634eafa0d28d04887630e2536e8f103/MENAB6_1.png",
  },
  MENAT1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5GMRwIuDhdHgDUXeEIKA6k/806e421ca4adf50496456de0abd97673/label-men-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5wdgYt1rN0SruMMoYS44rL/2a5e9f72c115ef0e598e1259251deb3a/MENAT1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/70KeZGTpzeicBKzpviHQkM/4d6c1ebafa12d43443c52443c14c0572/MENAT1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1XP0BN4iI99lbkaFPDXrqr/7e47acb9e50178f87d3e0c0a1917ae68/MENAT1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/ZusnpudWF4xjOW8FuJRnV/615a24637d776e179e9e7a1bea8ca8aa/MENAT1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4c8MGNHiq7Dv2fl90nka1T/82b66b62c632f6b67160029dda15c300/MENAT1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1KkyzKYF7R5GvB9YRrRZZa/63dfd50f97a2729cd56a2687c0ace480/MENAT1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/h5XCuNv2kJK2PX1Iep6Bk/a0b7b28ff364a852c1aa0a8657e110a7/MENAT1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/rlX6cOyUOIk3TyTFw2owS/fcf256e244933efa1ecd3cd9cef3f82a/MENAT1_8.png",
  },
  MENAT3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/OLh44vWiLDDHQHI1lkE6u/9a912432904a0691d3a9a67fcddabc99/MENAT3_1.png",
  },
  MENAT6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2AUCwtX3PmKEVeqV9f8HUz/5e3d4d9e40e2e63e7b96e94c92fb8ce7/MENAT6_1.png",
  },
  MENAD1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5GMRwIuDhdHgDUXeEIKA6k/806e421ca4adf50496456de0abd97673/label-men-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/XwmIrnL0gOz5BY3Uqn2Mt/f0b7982d7b248e350c5db70ce29e0dee/MENAD1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7EU1jT9V2hkAMhvf7B6erG/28759034bb031b05fdf888f0b4a53d41/MENAD1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1IO14x94z9LAcz82OQ4nHS/9a4a081d4c100f63e0655f109a3458cd/MENAD1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2Nk3kT5wVMqWlpO5OyDG66/b9357cb0b9dcee888ed6d15bb4137b55/MENAD1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/53RuySrU8Y42EWQ9DrY2Y6/3720ca14430de65bc139cc498ad377bf/MENAD1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3JLGVJqOcDbhNgXWWRMiu/5dc49837891f4985c90f5771f8800718/MENAD1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2whR7tPJC1kHfiTNAYUw4O/9a62a163708ed4e283a2b0dba442f711/MENAD1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7CCQuv5GaqeSnEqVxJNcQE/28248be72d3908d9807d8dbff585a5f5/MENAD1_8.png",
  },
  MENAD3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4HsfcH4zV3goGaPGLTq1H5/7fe760b71e7d238129889d6b28604e96/MENAD3_1.png",
  },
  MENAD6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/cGZwjShSmJRDLxgPeiJsm/ad39a28ca4b38b7df83b28fc4f18bd77/MENAD6_1.png",
  },
  MSRAC1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4yA6ajE7WFZBqMWn3E1YtN/575a7d651974895c6bf2efd379b471fc/label-men50-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/74kXT8rxk1lmEE0uQwTslJ/0d5303d7a48cae1d91ca29a52d4c343f/MSRAC1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5ErAPLODX5EtpV3MOPrOPy/27ee19f74856b80d01391aa63223f04d/MSRAC1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2GfWDBCLGdHqmTGDgVlhEp/6256d2ce223544938e2af4c6f1757554/MSRAC1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6TgQ5rdGl9TZQlSBTGz8py/c0a063579ad412794438a06b644a8a1e/MSRAC1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/LGNMjvLFxhqP9y8X5oT02/f2a4237b2b5732ebef730d53851a1a66/MSRAC1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7IlavFe0BonxpYgKkDMXOw/869c97715ce78ea31a7736c61f9d941f/MSRAC1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5ncHRdxkItvR89j0qaim7g/106f0804f00e33f8c60d74ebd913c99b/MSRAC1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6cgps2lsyG1koTN9veY2PP/57852e0756c3a52e819e5bfd4eb27902/MSRAC1_8.png",
  },
  MSRAC3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6OSuKMKUIkeA0gFaUVSdrK/2cd156cf016431a81b52f78334702aeb/MSRAC3_1.png",
  },
  MSRAC6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7xxySYB5HexUrY923WCMKq/e88fb5436b67513c04a5985f3f384d25/MSRAC6_1.png",
  },
  MSRAS1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4yA6ajE7WFZBqMWn3E1YtN/575a7d651974895c6bf2efd379b471fc/label-men50-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5ITWlUNRjeXKCOD8RM5wAS/8629029d4d072307e9d850c788a239dc/MSRAS1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2RqD7S2EOqHdhl2u8DQvWS/e85af66af174b35efd56069b839fb178/MSRAS1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/rFFmKvOk45Hkasval64lk/1f4dd67a8d4680c47ccf377c27691632/MSRAS1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6wQB65JxXeTRh088gTJ5AT/020e44229a01eb3835376c65f0014bd4/MSRAS1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/ToD6CupS7Cr0Wb7wsn058/1578398da0f54d3ac4ce59a0336f292b/MSRAS1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6lyzbsHZupB61MQeGcsdwc/cf769dde5b7a4549b174ca4fe21c3118/MSRAS1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2sZq2eC9cTs4VuWMmnLtY0/bc5c3a0c9722860b0e7948d4f910071e/MSRAS1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1F2udmv0tujkc2OzZFLIx5/94e0033d951bb1a039437f89b84346b4/MSRAS1_8.png",
  },
  MSRAS3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6oyB3pcyAkZGxN6eZADNDc/f269f85cc8ce35abe0205e4ef5331f0c/MSRAS3_1.png",
  },
  MSRAS6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6uoaqdInJlcKG2wCcoVvtx/25344ce62ba6d07b298e6eba5cca2879/MSRAS6_1.png",
  },
  MSRAH1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4yA6ajE7WFZBqMWn3E1YtN/575a7d651974895c6bf2efd379b471fc/label-men50-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1Ie6lEZx3BzAvKt8rQJ26c/71a9a4e755e7b10267edc860ad93f17b/MSRAH1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6vr1QNOUqNeWbdEePoJp1Q/7bb6a1cef497683f5cfbf510deef40b5/MSRAH1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2afEAkGE62WUG8nM2p8xru/81fa2c2fcaf815f0dde9110746271fa8/MSRAH1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5H9b1NTiesKJNG23Y5hcAi/d6c2a6ab6a3a1b98154088ad04e3424b/MSRAH1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5xHWEqGQfO6PjjkB3berF/d31f14a48be574c1aee3c02acd22500a/MSRAH1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2z7FCAeRKXaq8dOgomBfb2/b38ca7cf91bee646e12335163d73af87/MSRAH1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2T22cQMkbVLWJnTpqOUGi1/eaf36628143eb4ebe05b43720d786f72/MSRAH1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3Vh7SA1ps42bAWWpQ8YBBn/f1f25793bf34658de55d361676f979bc/MSRAH1_8.png",
  },
  MSRAH3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6xCh34wgrl6RVDSPaRVHwp/cf1f6936ab70081399c4ca7896a50ed6/MSRAH3_1.png",
  },
  MSRAH6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4dODW1OfPKEFIsYEeBeW8f/935f5b0436f1f0e3e8832a2bac064e6f/MSRAH6_1.png",
  },
  MSRAB1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4yA6ajE7WFZBqMWn3E1YtN/575a7d651974895c6bf2efd379b471fc/label-men50-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/367PnAh8WH75OvpXfiEdQT/38379710f4e1a368803e0e67772e5360/MSRAB1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/NRq3Jxw6MaxMeVOetbwpK/14d13ed9ff3c71da66197ea2bc871527/MSRAB1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/HEPizxabJWrKSTzooIbrY/ab9483e02d4e88e58ed7aa6764db6ff3/MSRAB1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/59lkwv2shd5WZ7PDrI9tRX/0a57ac558d33a7eac08c1448447ec845/MSRAB1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7eFYs9r0Yb6q3jF72L7DXW/c5c7140932a9efa5d5680b8084470650/MSRAB1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/20VnGHQoU0jKKyVDmhHhhn/3b1a3a99833090c538804dab9f52eb18/MSRAB1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5m4871uKsvdh14vlvb8UxQ/cfc238948a83c9d24da93348a6a2b0d9/MSRAB1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5gibod6ZqffR9MevfYeCQJ/cad35bd68de547256e6c5dc771be7b45/MSRAB1_8.png",
  },
  MSRAB3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5KManiqhb2qftJTlCn1txH/660a45f444a31876ae153863705e1135/MSRAB3_1.png",
  },
  MSRAB6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3cAJaWkN9l8CedNCtpyfVW/1528a40733dfb9896d25be55fb01d1ed/MSRAB6_1.png",
  },
  MSRAT1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4yA6ajE7WFZBqMWn3E1YtN/575a7d651974895c6bf2efd379b471fc/label-men50-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5B5DBRadOY3np3NMJFIQsS/690d1c18f32f68f65d6806d122e2e597/MSRAT1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1h6lg7TvHtGLC4bcepGYTh/44eaa018ba20d6ad33693ca50a19c4ee/MSRAT1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7BcG3cjqORv1iqcFfduBFT/3dfdba38b95884f756318552764d56fd/MSRAT1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2Q2GikcAPH22jdJGyINGl9/2df8a78d6f3aeae1874e31c270774965/MSRAT1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6TsHsItDKNXmFjk9SHnzRI/87b7c5b3b8d549d60ed659d2096e56aa/MSRAT1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4By27uHdUVkjvFBFllarxc/cee4a1256ba5b5f57ccb86b0d2092010/MSRAT1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3zEy4UgXNg4XsvhIHb6VpY/93ccc4f61c616057d773cbc28af5ab63/MSRAT1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/30ukrP48EnvcLprelsRE2L/3b91f6a4c478cd8ce26f8b0973625504/MSRAT1_8.png",
  },
  MSRAT3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3fByZCds4BCLkftIjwQe40/eafdcf44862b647e08bce472f5f7a725/MSRAT3_1.png",
  },
  MSRAT6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5zGuysmOvDmAaBa4uh3bqh/0a849b98e7152fcce45813103c9f3915/MSRAT6_1.png",
  },
  MSRAD1: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4yA6ajE7WFZBqMWn3E1YtN/575a7d651974895c6bf2efd379b471fc/label-men50-spu.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1k1VNQSGGWXvRGYKXRPoe9/39dcbca1b8de562a9227a221a70a4240/MSRAD1_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4J9v2rFMfU0htHdbtqDCv2/4a82a4845b97e7c076e52b39ce540e6a/MSRAD1_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4ReL2xL3UjAFAXexd1QHwW/82aa89ee583fb12d291c8d8e21eaa40e/MSRAD1_3.png",
    label4:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7zAz5wfEDXK3zYj0wh2Cqh/d7f7a44313b4993e41ed0c6b30a65072/MSRAD1_4.png",
    label5:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6LcIaVb0RvNZiJzyBbEeRT/63761154d2f45827a881424a42ac1f66/MSRAD1_5.png",
    label6:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5QVO2THIWLnBl4L1BKXLqO/8b502148c2bcecca5f10522659ca6122/MSRAD1_6.png",
    label7:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4zEtaoamxlR6Q5qa42XB89/58a9f2cb647bae4f9b28b66ba3295f05/MSRAD1_7.png",
    label8:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2LQx3kGHAYyWF0DcVW0fq3/025195a2e05654a1a03aa5f74b663693/MSRAD1_8.png",
  },
  MSRAD3: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7eZkfnyn3GTYv3kwUDgZee/2451dc8c219a637ca3c2fbbddf0509da/MSRAD3_1.png",
  },
  MSRAD6: {
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1eHXytr74kOVv5zPzFPR5u/9c9fa205ff824be9a99a85294c271c2b/MSRAD6_1.png",
  },
  STRANDSERUM: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/01tKxWefB5hEAno9rV22gV/aaf7d866736356174bd9d6482e859fcf/STRANDSERUM_label0.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/23l42nFfgNwi7rmjFjEqZj/dab27a89f4cdb9cf7889f34eccc53fb7/STRANDSERUM_1.png",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/20D1HsXjEFCuJDOpxGYNeW/372b7001382a3569ebc8b152fbc1993f/STRANDSERUM_2.png",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7ifplv1hG5tJRQleDUUKLt/bbddc5f61deca6cc22b2d74368060462/strand-serum-lifestyle.jpg",
  },
};

export const INGREDIENTS_IMAGES = {
  SENSORIL_ASHWAGANDA: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4fPqRSds0uve2nbg39msiG/f51437279366ce38ac49036a0071a8c6/sensoril-ashwagandha_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2H92fWyhykbNpg7nRaPs3F/af2def99a2cc5bf03b215a15082be6ea/sensoril-ashwagandha_3-2.jpg?fl=progressive",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7GIm6SHB8STHrCoFeOz9V9/dd774ee30c5efb73e4070d05fd9428e5/sensoril-ashwagandha-powder_1-1.jpg?fl=progressive",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5BMUkYMovIvklxu8R1133P/053ce9d73b78bfc07cdea233602411ee/sensoril-ashwagandha-powder_3-2.jpg?fl=progressive",
  },
  CURCUMIN: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1xBaXEJQzZXDRvJbsp9Ylh/aa1171c741c49cc176e87f4088f92d68/curcumin_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2Zqqvgp6RxnH2CVxTe8LKV/5bde6483bf80713e0084dd5d2ec0cb24/curcumin_3-2.jpg?fl=progressive",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1CiBKdqBf1MvpP8W5ddVY0/45b6fcf043debb66b3795d2bfeb9685c/curcumin-powder_1-1.jpg?fl=progressive",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/ZgUfrOyxXfh57KNn1Bi81/b083e356ace2adf1b03929f954ea0cac/curcumin-powder_3-2.jpg?fl=progressive",
  },
  SAW_PALMETTO: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3F1eO7GCXWebAoZLLkTr9S/97e006f155d61296f6e1cb04d420581f/saw-palmetto_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6SEdI8xfk61qUxcmSVVrdo/a307318a99c1c74d6d552bbf4615ca83/saw-palmetto_3-2.jpg?fl=progressive",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3PGcgc1RmD2S8tHGRN8dkQ/6ea85fa074f3a8c5da9192d776a0a61f/saw-palmetto-powder_1-1.jpg?fl=progressive",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/SyzlDo8De9yHu6GNoA2Or/e34131270ec675c7370711e761294f22/saw-palmetto-powder_3-2.jpg?fl=progressive",
  },
  APPLE_POLYPHENOLS: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7bDMyQBgf4j3hbWmQsLOGS/73b13b142462c27909467badd90075a1/apple-polyphenols_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/rbBKeVnYzDQORiPR4ff7d/a265846704388f7a276e3a98c26bae40/apple-polyphenols_3-2.jpg?fl=progressive",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/54XSXZtP0m1RBLB7yGenbw/fd2664d1af72bfc7c657f0fbde6fdc09/apple-polyphenols-powder_1-1.jpg?fl=progressive",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7JUyFuuUloSYXENUEvGiv2/267d6afa290b95356a631b948114c460/apple-polyphenols-powder_3-2.jpg?fl=progressive",
  },
  STINGING_NETTLE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/66EsuHKqVR4Bq6y9vgzaT0/dfe916e456d25ac01029b2dcbb3d337e/stinging-nettle_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1Wjjgt8H1iFgjA3DThrnbX/af2a98ba4b32f96e54c70a9822718cb3/stinging-nettle_3-2.jpg?fl=progressive",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2nlvtzYAjUn3TXPoWmXT29/9a927f540d91b8d2ce7993249e067812/stinging-nettle-powder_1-1.jpg?fl=progressive",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1Lf6q01R93cTUCoKiOHwTq/851479206c77ff74ebd765d084f5e631/stinging-nettle-powder_3-2.jpg?fl=progressive",
  },
  TOCOTRIENOL_COMPLEX: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Bhda9ptFOBCg9TTiYZdBN/d992e18707cc42266f91db185f0c1c93/tocotrienol-complex_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4pkgkqQyyWo2XWtPQwO3np/7a88430f3eec5d5e385494b61e45f176/tocotrienol-complex_3-2.jpg?fl=progressive",
  },
  MARINE_COLLAGEN_PEPTIDES: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2aiEhOGqtEZgpDuAh7scmG/3e11ea23dd244ff862a92dc5af878106/marine-collagen-peptides_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6STDXZlZC4kp59F82oDwIs/dda42f57a086f950d219c6efa7b600c8/marine-collagen-peptides_3-2.jpg?fl=progressive",
  },
  MACA: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4k9pRZICZyawJHS0bs1gNJ/5b0a54427dccf37616efddd3b321366f/maca_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5V9PKcCwZtZlIKdIJbPt41/7447bbb2e1cc844d6baa499d23c6d15e/maca_3-2.jpg?fl=progressive",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/pKPxqf81U68UQ8OecYDHW/26fee3f5315eaa4ee99059055894aafd/maca-powder_1-1.jpg?fl=progressive",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3hHyOueUenzRZC1jnWgswC/4a83d597a4d647fe56c7ded539e352d0/maca-powder_3-2.jpg?fl=progressive",
  },
  SHATAVARI: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2YXSDFWfqbIy3xZylJKdT2/cdf8cd3d4fb889034ad861e0ce0ef140/shatavari_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1pq67XuSsg58ixXBHG6xvd/60988b23e31e11b7c3138ea68e104477/shatavari_3-2.jpg?fl=progressive",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1nhBBmXqVSKqB98BZlqTam/3174976463fd15f03b70c635c59aedb9/shatavari-powder_1-1.jpg?fl=progressive",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4LsNXQfFmIAvSahwBeVaNg/ef129428f55581d71e921c61341b4495/shatavari-powder_3-2.jpg?fl=progressive",
  },
  DHA_OMEGA: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5u1X5c2f55faAyN3g59bNl/064c19e2cf73c0af3aef6f5f2442c670/dha-omega-3s_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6GLv1KxC0Y3rmd3joUokRu/e1dad94c0904a9729269a09362e5f8d1/dha-omega-3s_3-2.jpg?fl=progressive",
  },
  ASTAXANTHIN: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4NpTIupw2YtKTpecelWst/75e1c945b9f838d6c06ead77dd81b67a/astaxanthin_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/9jmjtsviXtifbJC5U6wZW/1880120bb35a4c6764d605063729c44f/astaxanthin_3-2.jpg?fl=progressive",
  },
  COLLAGEN_OSA: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4ayu7jzqegU2AMFAjCy7Yu/c49cf33b6ca3e95926cce59acb2f3f11/collagen-osa_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/Ry60dPDNVOsewPDOqTJ0k/0c9e8085e2cffa429c32518e7924c0e4/collagen-osa_3-2.jpg?fl=progressive",
  },
  THEANINE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6eYO2C2Q4f09CgyxLHzowM/8cbaccc0c1e9fef9d624716f3fc35d87/theanine_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5ieujXJv3yIdJsryqGb5Sk/c9715b6c7b3126130b6e99651d9c8cde/theanine_3-2.jpg?fl=progressive",
  },
  KELP_MINERALS: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5otZJBKR1Bl1yzYOOUfX5F/f920f22531dfb2b1d77863a3a7d0c9a2/kelp-minerals_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6zDBNZA0Tjorfb34cRQCKO/3c5110841a6202334ad157d35a608e65/kelp-minerals_3-2.jpg?fl=progressive",
  },
  RESVERATROL: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/78xTZWJqGeIT7akQsazp59/7dd7ef98e941d1ea599a936b4f8b17f3/resveratrol_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5KoJj1zWTvqNq0f2KiLnuq/8fe229ea08721d5448476e582a2acaea/resveratrol_3-2.jpg?fl=progressive",
  },
  HORSETAIL: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6UhAKJV9mLyR3vpn52MP46/0da11215af5f14f3a4d447fe9387d64f/horsetail_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2dTPwhJnD703sqesDqIrk/562b76939f68c00e77f2b439a9a498d5/horsetail_3-2.jpg?fl=progressive",
  },
  KERATIN: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4dKKirRFGozj9wKf4D8QY/45470125a377fc0f1a6b55928eece108/keratin_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4nll5dJJcE7XYHkj1prCcd/7e2cbaa848a9f1a167bed491924f4cfd/keratin_3-2.jpg?fl=progressive",
  },
  REISHI: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/rwCWdcjDvvDd5TYRaXKJv/8dffa6eed6fca88e7184b9e407cd293e/reishi_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/26Zi41zVznF86hRSrWJTnm/aca7ac269669f66d819e28def45cddba/reishi_3-2.jpg?fl=progressive",
  },
  HONOKIOL: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1QSVXfnzDZ6gvrKzTneNWV/417aeccfcf2d65b4e1e1473871655536/honokiol_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/59Ews9lbv88n5JaLdJkAft/4103847daf6f6763b25f1d1826c7f8ef/honokiol_3-2.jpg?fl=progressive",
  },
  AFRICAN_CHERRY_TREE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3BRNt1p23dIbyqHqZh6k7C/7c8ff2932e3975c278941b0975ca36bc/african-cherry-tree_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/WkY4C3ddd7ttEvpeRRPLP/8741ef2ce651842992a1455cc1626932/african-cherry-tree_3-2.jpg?fl=progressive",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2LppjVWKx171K1jOWflAYM/fede7a3ffdd045b9279f1d5e55bd47b1/african-cherry-tree-powder_1-1.jpg?fl=progressive",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3WkDpFVFAHzdrA5VlkoVzO/d719a0c4c020a1535392425ceebf0741/african-cherry-tree-powder_3-2.jpg?fl=progressive",
  },
  LACTOBACILLUS_REUTERI: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/46DM3BOumBWGyUkp6arQYC/5672abf5e13cf0186cb4cfde3907a98a/lactobacillus-reuteri_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7fm4ITxCdSMBNaUBMZZ2dK/fe79d5d39f3c136fe235bd242a9f0cd7/lactobacillus-reuteri_3-2.jpg?fl=progressive",
  },
  LACTOBACILLUS_HELVETICUS: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/49XcjnG0EPZIppiu3DDHXX/3ce1f577266a9d56ed309fa0b1f012c1/lactobacillus-helveticus_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6yVLmal06EJQjF1X3GJbGL/1a5736016e14b4311e469a7a5fcec2a2/lactobacillus-helveticus_3-2.jpg?fl=progressive",
  },
  PREFORPRO_BACTERIOPHAGE_PREBIOTIC: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2ztSXuDpkTotbEPajVDsnN/df8790a0b8f3c86325e97ad168c1259c/preforpro-bacteriophage-prebiotic_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6lcQNIpMYbesBjJ6taMmJR/51985399e2db95fa85cd8541493a02c0/preforpro-bacteriophage-prebiotic_3-2.jpg?fl=progressive",
  },
  RHODIOLA: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5MYdRj4jNBzjNtV40mcsgy/53c0f0ce2a1bb0856ff501063e1e4046/rhodiola_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7c99DVCGiWWKUm6yKyVsYO/7a149594b5d28ae273a0d36fff5c9076/rhodiola_3-2.jpg?fl=progressive",
  },
  CITRUS_FLOWER_ACIDS: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5QUKUWDogxpRm1srpKjBl5/65cd22f2caf89eabdb5a98cfe1bd0fa3/citrus-flower-acids_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3WLyyOzq8YoGQgue5SkpR2/0a4b2ff3482552c090512d93dc4fd740/citrus-flower-acids_3-2.jpg?fl=progressive",
  },
  MILK_THISTLE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/J5344AaOVABj0rGYFKWxK/7a7d028a42b0a4aecd316ac46acbfd54/milk-thistle_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/ULWlhwD5P3Y3b79HCyYOo/4cb14d7d1f3f1e2add2c7acaf4fc2b9e/milk-thistle_3-2.jpg?fl=progressive",
  },
  YELLOW_DOCK: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/UI4x8sOMsTssZn706VjRB/e2e322a803b614545b3f16184e50a034/yellow-dock_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3mjRaK4ZXu7ptkQJODnSJZ/d767d326414444845d82ca3144cec86c/yellow-dock_3-2.jpg?fl=progressive",
  },
  GREEN_COFFEE_BEAN: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6ZqhBmj8KpxF9UJ0x1ajsV/fe321fa0f54df0614ec8effa6dad6142/green-coffee-bean_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2zNO03SOBsXqtOJgjvzHfi/2a2c5a35f22962b4d1af0ae92f5a9e20/green-coffee-bean_3-2.jpg?fl=progressive",
  },
  METHYL_B12: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/15niaL2swrGCRuWXqQdnTl/a0289f0bf7248bd43b2bbcb8ba423dcc/methyl-b12_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/26X1gfq4dqtfCIsI2e1yB/1106ec5b82adfc7cd3c246dd50da183a/methyl-b12_3-2.jpg?fl=progressive",
  },
  METHYLFOLATE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7wiOPrtNemmtRk8v3kIGlo/ef6b77d76194a679681ef062cedc5ada/methylfolate_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2IZx4aEg7TYefvrSFsFj8A/e4c324fd5992d81658cd87d2b2e309a1/methylfolate_3-2.jpg?fl=progressive",
  },
  IRISH_MOSS_PEPTIDES: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/59gErlYsBgXmqVBNVGrdek/64f28dad5fd60ad6d1f318ad27ab1d5b/irish-moss-peptides_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6fioKn2pEM5fG5plvEj4Bn/f0f9c2fd2c42a509e5a74684396916c4/irish-moss-peptides_3-2.jpg?fl=progressive",
  },
  PEA_SPROUT: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6hWHyELzhRnmgjkWHGSLA0/00de0d2228cc6fad48d601bd69f9fa79/pea-sprout_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2J184OUHqCLCJ1rVBVhg1C/2b507a05409673cf46968b3afebfb365/pea-sprout_3-2.jpg?fl=progressive",
  },
  MOLDAVIAN_DRAGONHEAD: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/uE5jnxi7YXeHodzRr5DJK/e1b9d53e1dc3006493499f2b8ef1189e/moldavian-dragonhead_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2vr5gzaSm0xY7PkpTAVMZo/fca548dfee7e6881b36cc16e42c3625b/moldavian-dragonhead_3-2.jpg?fl=progressive",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3EK49Z3qo0Kjct4sHXIhC4/f951d8e928d5db209adeeaba587379f0/moldavian-dragonhead-powder_1-1.jpg?fl=progressive",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3R9ce9emSOWfbfBUdzki7t/2f69ed77431245fc086d92ac06f35941/moldavian-dragonhead-powder_3-2.jpg?fl=progressive",
  },
  SEA_BUCKTHORN: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7IWVFN0G0uYbFQZkwhtINE/d05bedc866cbc1ce7a445a71c610155a/sea-buckthorn_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3Gb2vYnSRu9LFOuh61GsII/a2bfc6f99ff492fb53e51ed4758ca7c4/sea-buckthorn_3-2.jpg?fl=progressive",
  },
  BACILLUS_SUBTILIS1111_PROBIOTIC: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6XRfe3GaKVBtk9I29UWHKK/8cfb44f1df6e7a7693123637a6b8984e/bacillus-subtilis1111-probiotic_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1TvEKF1UVsmdHMaICyWmzj/55ffb72ba5b7d10331c1795d51e659b1/bacillus-subtilis1111-probiotic_3-2.jpg?fl=progressive",
  },
  B_COMPLEX: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3vs2BhEtUMxnqmosBbzCcz/1ef96341547123ea9a4c5b902a29a742/b-complex_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6xeERUmoWvTtCyR5lh0df0/428f096a2b6c1b478eeae56a1b8f1be0/b-complex_3-2.jpg?fl=progressive",
  },
  SCHISANDRA_BERRY: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5WsZUTEdEXw3YJRIdz4wUl/45286d71de5d73e2f010e7fda3cb3e4b/schisandra-berry_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1t1I7OQ9JQthFa4BbIjNUK/ee507e50d13347fbf418d8721456cff1/schisandra-berry_3-2.jpg?fl=progressive",
  },
  TERABIOME_BIOSURFACTANT: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4DapA8qmyTJOuV8Jhfe71z/ae8ba6c237785e4fef0b2f5a5b9479f0/terabiome-biosurfactant_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/DPe06NqTDx8QGsN1dlDXD/4447b461c0a18605adbdad35e3425b19/terabiome-biosurfactant_3-2.jpg?fl=progressive",
  },
  PREBIOTIC: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/j6TrchCjaRQcjeD3ymwgc/98063e4b177e7a0aeaaf0c21ccfe794b/prebiotic_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3MCi3Kpgek5FacaP9rmf2r/c0a6e950b120f14012817117785de25e/prebiotic_3-2.jpg?fl=progressive",
  },
  VEGAN_PROTEINS: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4lgvkeRhxCZLYaF60k1FWB/b0e3334daa288a768f3543d30688ef3c/vegan-proteins_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1unh0WsSuaQIrV6iz93oIL/539fa72c55fa52509bfcbf7d6f6df76a/vegan-proteins_3-2.jpg?fl=progressive",
  },
  QUINOA: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Jjjkr80iEA9P0HIxxDIGy/664a1a1b9254713fec3872a4f7ee0a98/quinoa_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6zZiIxRqi5wZ2McuN5CMo6/d958b9c0e91dced7e6d6d7cf121a2e31/quinoa_3-2.jpg?fl=progressive",
  },
  JOJOBA_ESTERS: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2Ted4MoVEYcq9bn7JDzJbM/ab9ffee55e208bc8e80171281988fdcc/jojoba-esters_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5frw6duTTJJ8Wb07r8sZEQ/4d065752a33545f5083b8a4bf5c9b6ab/jojoba-esters_3-2.jpg?fl=progressive",
  },
  AHA_FRUIT_ACIDS: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5b96quxsOc5ut1JkcMkunx/5622146fc3b4bbcdffdab295719c5c41/aha-fruit-acids_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3aICw13zmI7r2ffbQc0jrW/560c7fe18bb15d3d2deec447c68a7244/aha-fruit-acids_3-2.jpg?fl=progressive",
  },
  AUSTRALIAN_WILD_BERRIES: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1iiTmxqf412A3pj4H4xmpY/6f785c0d693be835d48d5ebee4b9ac23/australian-wild-berries_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6zZWXHbcfLy8aaAn809EQZ/f870dc806d8746956083f6b85c9c7a33/australian-wild-berries_3-2.jpg?fl=progressive",
  },
  MSM: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5WS33qR7RrgyXDZHaBegMO/b117a0f1866cbf4a3657ad6ab6e68fc8/msm_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1wzZaZeX3jqpMHFT0RMkSM/70f31baf5d2a2d389067dcf70f23f899/msm_3-2.jpg?fl=progressive",
  },
  SMITHSONITE_STONE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6DkseKQHJMeh9nLwvDJpfP/7a273b934b932cd67ba8f93ad5e82fe3/smithsonite-stone_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/zNB61q3ca4KfnjJcqPWHg/4892f1c58b3f98612a4b428684032d95/smithsonite-stone_3-2.jpg?fl=progressive",
  },
  PRICKLY_PEAR: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6NLff1g5mpNrhJExOU0hS3/b8867bae6933a0a18cf5c6c576df0179/prickly-pear_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3beKEsqGNdrRqVP5PiKQEB/3970fe74fc9d35ff2ae384ab5dd1a76b/prickly-pear_3-2.jpg?fl=progressive",
  },
  POSTBIOTIC_ARGININE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3Ht1i4yKH8QyPQFjVJ7LAy/4cc0ffdafcd76b1604d0e205348618b0/postbiotic-arginine_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2odzxBkxu7NpY1or4DJXt9/096fb5c47ff31688075a0d946beb7b7d/postbiotic-arginine_3-2.jpg?fl=progressive",
  },
  POSTBIOTIC_L_PLANTARUM: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3xCevEm53kH5nxtxNAgtWr/81c406ada423dd7c77c61baca8bd4baa/postbiotic-l-plantarum_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5GAr3C1t3gDHYXONGeF1y5/dd74caadbbe085723889c22026a8c8bb/postbiotic-l-plantarum_3-2.jpg?fl=progressive",
  },
  BACILLUS_FERMENT: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2pxjCn46043Cnl3BNGBvBu/e1a92975987d8a179644770e50fb6201/bacillus-ferment_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1VLq7FDBXFpfSmqiJkQ8Xt/5e8acf416cb5832cd057e79139679090/bacillus-ferment_3-2.jpg?fl=progressive",
  },
  COQ10: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/8XTFZQGrh3OK9ssqgZtny/b612df616586ede757132de1e01034eb/coq10_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/34mKnxemPlnx1L8H612YTJ/f3f492a50a38a4bc7431b093330e31db/coq10_3-2.jpg?fl=progressive",
  },
  ARTICHOKE_ROOT: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6DQXiGkjSf4FHn3vNLCVvD/369c32167898592d8adaa4be1c8769fd/artichoke-root_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1FrzA6PrGK7DwiLoKrTpur/b4264b9d44d7f284c5a485415bb2401c/artichoke-root_3-2.jpg?fl=progressive",
  },
  CHROMIUM: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3ScOpQX7147sfOI9ODPp2P/ed54d1734830c74b6e9972445a181bd2/chromium_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5j5tTXXLT6Fb6sMtk9AMqM/4cdee81cf586ce5d1f29f2a3e1a1336c/chromium_3-2.jpg?fl=progressive",
  },
  MYO_INOSITOL: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/WhunKvrOqJve0EGSt07jV/788525f03e57792418f2e5712115dcef/myo-inositol_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/81bpEdRDgGMlItQYD4lBb/95ca827bbe173256109e6712d4007ea4/myo-inositol_3-2.jpg?fl=progressive",
  },
  GLUTATHIONE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5kjlln60Gv8vVGsHR6xrFS/46a314838366025a222277300119c3a7/glutathione_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5SZJbBIxos8Sq7jXS1eXeL/823a58376a6c902e673877318a697467/glutathione_3-2.jpg?fl=progressive",
  },
  ALPHA_GLUCAN_OLIGOSACCHARIDE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/HCz5rzdrgD5IrpIscLxiV/34892a087fc340e88145da24355e3911/alpha-glucan-oligosaccharide_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/16WktwcmSfRAHuqcCHj4QM/beadf5610b04a1d9f62ce1b74134451a/alpha-glucan-oligosaccharide_3-2.jpg?fl=progressive",
  },
  CHIA_SEEDS: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7nv9anBb19x1swfXN06iCu/13da346e74d1f184d9a53c85ca65dff2/chia-seeds_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5nrd82ZgEVZELgb6rLQkKM/099244fee932f95344b288dc9599e38c/chia-seeds_3-2.jpg?fl=progressive",
  },
  BIOSURFACTANT: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4bKN8LGRy0X1OIxXOoHhYn/bd0ae79747edcc6704983d292553415e/biosurfactant_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4jBfVynfMoYUx13WWyk2Qp/d4c5a9533822ad000da03dff0330836a/biosurfactant_3-2.jpg?fl=progressive",
  },
  XIMENIA_OIL: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4nuDq6fE9vfqYgIog0Huvf/38487c4e07151c61be3eaed86a3c130d/ximenia-oil_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1Up60DcRly6ee20aK8avaU/bc6071f842c62ebdba936b162c88ac0e/ximenia-oil_3-2.jpg?fl=progressive",
  },
  KOREAN_RED_GINSENG: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6NE23QbVzhqGjwMriKM3KY/5543018649a8065e0c60e93cb7d28f03/korean-red-ginseng_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7t06AnMmnBBP38pbGOP98H/7ae4dbbef764cb116c70b09faf5d4806/korean-red-ginseng_3-2.jpg?fl=progressive",
  },
  GLUCOSE_FIBERS: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/m7NxvfbKQ3OR75NPo36K0/29ff3e517d8c9d4319058d6899c467ad/glucose-fibers_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/pnDhAXr6MJACUQ1qgnUCr/ce6455bf3ff1352e9fde10534dba45f3/glucose-fibers_3-2.jpg?fl=progressive",
  },
  HYALURONIC_ACID: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3pKep3u998UDj4JFtZLNes/7ae598f444cc5bf4789d3d0b29b80f33/hyaluronic-acid_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3GuWwcTvL3je3xm8cno6Ua/b7aa89e6c33f37edb7aaba37c1f47f31/hyaluronic-acid_3-2.jpg?fl=progressive",
  },
  AMINO_ACID: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7djejbXLPJ2Fo1EHbVbrwf/f0776a8eac3e4b1a64f87af2a8553557/amino-acid_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5UaYHYfCB2YN75d5PvpHzg/5c92f24b1fc6fd03809d73279a981a1c/amino-acid_3-2.jpg?fl=progressive",
  },
  BAMBOO: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1wCOORG4uIC7aKvbXZQj5P/3ed54da9f1140823095c961085631ac6/bamboo_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/KuIq4L4Hn8TTKs2wBZdNr/ae4e51750238b151b6760718dc2aab65/bamboo_3-2.jpg?fl=progressive",
  },
  BERBERINE_ROOT: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6V1QiPK4Fto2G1Ro11j2z2/5c7072634ae3d9ecc2aad15461443ba7/berberine-root_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4CrLY8OMdzSU7Fll8K1aGI/c01e5210f871a1a8e4e4f140328e514e/berberine-root_3-2.jpg?fl=progressive",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4lfIqQDknskL4NWqz1dVUU/df040e1a1a456b0d5a887f5e231cc53c/berberine-root-powder_1-1.jpg?fl=progressive",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7sVsJJ0vrIRSlqyf6MeZVd/78876012f39aee2271b77460287da957/berberine-root-powder_3-2.jpg?fl=progressive",
  },
  BARLEY_SEEDS: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6y4L8poHnVBNRJpfXz0LOh/bc1f795fac8aee59ed8f7253714ba609/barley-seeds_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3ZKiMj35JPMea40TWZSzI2/fb69d34c77e66fe1bc82301f125c1f8e/barley-seeds_3-2.jpg?fl=progressive",
  },
  HOLY_BASIL: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1maNJfa8h3tPLHkCWvqZ08/02c1b4e56c8a479b48b2f81f82a9cd9e/holy-basil_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/Rfy2UG3paM7vvZwjwWgLA/86b037da80c25aa35dae82eb9715c4b5/holy-basil_3-2.jpg?fl=progressive",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/67CDU38IM6FyhaX9oQX5HI/03d51214243037da9fde3a66b316cee3/holy-basil-powder_1-1.jpg?fl=progressive",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6MU9geHetssMCJUez7a1gB/62bdbbbfcb25d58ad5c122fa9d5b3729/holy-basil-powder_3-2.jpg?fl=progressive",
  },
  GINGER_ROOT: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7IFHQnMYKhLie5DccZRMRz/e53ff8a35bd526bdd478373c85e6d1eb/ginger-root_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3sFVdAnUaUpc6qyQwFhlMC/5ec56ec1d8c5dd61da42e987f9e88af4/ginger-root_3-2.jpg?fl=progressive",
  },
  KONJAC_ROOT_POWDER: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4TKajtvvKnI2qUr4eCKJLn/7a731ca27beff5125fc87816316c50cc/konjac-root-powder_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3Fi3iTQHS2lwUejIxHd1Th/309d9445c77d61f800ca09c42b565089/konjac-root-powder_3-2.jpg?fl=progressive",
  },
  OLIVE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7JM5nsXoPYVuVlNObmOICO/00af91fa857293745871ed41f6e6c559/olive_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3oxUhl095vtycOxEPRFlIo/5cd2031ed5e06ec807cbee7feed8fa99/olive_3-2.jpg?fl=progressive",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5tt8W69vJODEzu5cQOM4eL/d652aaae184508f24a95627c3017e6b8/olive-powder_1-1.jpg?fl=progressive",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7aESWtm2v144I2iUh9yMO2/33ee4b796e76dd3c9452f49137b0cf7c/olive-powder_3-2.jpg?fl=progressive",
  },
  PEACH_GUM: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6RzqGn3eimefiRtBpNiDxc/c465f690f12aad057816fd3d410eebf8/peach-gum_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/Oj4F5K7NgSnjYplG39Cx7/3c55906ee857a6b487fd144419178658/peach-gum_3-2.jpg?fl=progressive",
  },
  POMEGRANATE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/79Ctsl5BqotlyKLdE7FbJQ/61a53eb4737ddc421742586d4106be22/pomegranate_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1hZETWF1TJmNDOdX3mXBs1/de925ae0058579ce2bd48b22e9784e0f/pomegranate_3-2.jpg?fl=progressive",
  },
  PULLUAN: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4c3GztO7nZ8AebCFZUREgU/59ef5a9c4c1a0d79e95e5f6713b4e493/pulluan_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7x5uBKb5eAzQ5HyjEYQ4Qi/fe1a6a9f91e2f77438fe93c314707263/pulluan_3-2.jpg?fl=progressive",
  },
  ROOIBOS_LEAF: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1mMXQpA7K642rdWuVbdvV0/76b27bdf21df300799e9ac6bc6bed0de/rooibos-leaf_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3AIaYL8RhrVPq9OE0PTP1I/647d86c9b6cfe64d1ea33fb52b50ea77/rooibos-leaf_3-2.jpg?fl=progressive",
  },
  SICILLIAN_ORANGE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/41pvtmCBXuwZiC2CI94G8/affd3aad2b93799e87f9b7100f06fb72/sicillian-orange_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/36mM8dgdd1A1uCtMNaxbHh/a4e2966b355eb23ce4151128da65086a/sicillian-orange_3-2.jpg?fl=progressive",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3RVAjDovAiE8CuN0zFF74u/73c6c3633d3c80188153b388d0b0abf4/sicillian-orange-powder_1-1.jpg?fl=progressive",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/weFaZIwSLtq4I40AUVdjn/2f579ec3d8d40bcd8fdf1ff04b578744/sicillian-orange-powder_3-2.jpg?fl=progressive",
  },
  TOMATO: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4wmv4oCRMr1ZIZmveNBKIB/16e284f84159208137951122c435165f/tomato_1-1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7jtnhtyPU9pq9RJnQAoyuB/136ecfd3afe5b5e6d0d7b3900572563b/tomato_3-2.jpg?fl=progressive",
    label2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4W9Q11vnrcQNmnQtqXb8Lw/ad0eced15b56facad662fee9fa9ac972/tomato-powder_1-1.jpg?fl=progressive",
    label3:
      "https://images.ctfassets.net/0rbfqd9c4jdo/33TLqYx1weQD28Qjy2bbRF/97a821847dfe372846f0994cbae8a2f5/tomato-powder_3-2.jpg?fl=progressive",
  },
  MARIGOLD_FLOWER_EXTRACT: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Z0rLfwIdiY1uHbbj5T522/1cc2de4f18be32c391ee224df35e46bf/marigold_1_1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6KvgMCNRm1b1S276hS4yK7/8480383e7b4435dc6d61ebc7f0a050ff/marigold_flower_extract_3-2__1_.jpg?fl=progressive",
  },
  VITAMINB12: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2s6smHqxmsTfIxpRRxTkiH/632bbf30880715d42435c0360dcd4a18/vitaminb12_1_1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5zVvl6B7iq3mXyFzocouk0/f54178a716d599b0eab3cc1476c53672/vitaminb12_3_2.jpg?fl=progressive",
  },
  MARIGOLD: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Z0rLfwIdiY1uHbbj5T522/1cc2de4f18be32c391ee224df35e46bf/marigold_1_1.jpg?fl=progressive",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5KBfIfpDrXMh7IrlJCNmTy/c864ba965d978bb9967ae6a1a7acbfe4/marigold_3_2.jpg?fl=progressive",
  },
  L_CARNOSINE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4vn7QT2rEuuh6zyH6Qkbgc/54c3ff585c62cd970fc0019118413111/l_carnosine_mobile.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/24s59bxjOaWVZ68iIzWmmZ/2b1121f35fde643d41a9446d1838b3fe/l_carnosine_desktop.jpg",
  },
  MULTI_ENZYME_COMPLEX: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4OBt2bFX7zRtADk9A358iZ/fcbd0e1d39507fced64fc4b7325fe535/multi_enzyme_complex_mobile.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/282w1ZzY8IZ2z8OBZ8gwlc/bc73f9ef2d3ad952f0906b500ff17207/multi_enzyme_complex_desktop.jpg",
  },
  L_CITRULLINE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3YQNzjoaW3pDOownFomGsX/f57023a466856991be19b51db762c63e/l-citrulline_mobile.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2J93hImwPYp7RrjxAe6IWx/a2fa916f19bc48df36775291114b10ff/l-citrulline_desktop.jpg",
  },
  BROCCOLI_EXTRACT: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1RYQbPE5wSJydETe7T02Aq/7d5546345bdc70b4969197eb0b880044/brocolli_extract_mobile.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Jr5BTZfLzbNsEuFJD9ycS/13fcaba5287891c117b101c55afacd18/brocolli_extract_desktop.jpg",
  },
  L_CARNITINE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5cwdLQ2qF6OtkU5MfsIvnU/9881f0a34ba28c199ce88b76e68e395e/l-carnitine_mobile.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5MTtpmlKUC6TcJD4rgHMhV/59c742a302bea6e4739f6647d559a445/l-carnitine_desktop.jpg",
  },
  NICOTINAMIDE_RIBOSIDE_CHLORIDE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3VBxoUKePn7m5UlrTVAlNV/f5cb36984ccee141554cab2bece777ca/nicotinamide_riboside_chloride_mobile.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7x2X4AQxzeLCmwlwL9yMiC/36315e960315f2a538663a33ebc51053/nicotinamide_riboside_chloride_desktop.jpg",
  },
  GOLDEN_OYSTER_MUSHROOM_EXTRACT: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3ckvkSdly66PyajGVd9ePX/d5d6ade9ba0ca40f7038c4b06e6ba615/golden_oyster_mushroom_mobile.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3yparxMtXIWFuLguzE5CMH/4b92e5e5c6e5565f1a60f480343eb479/golden_oyster_mushroom_desktop.jpg",
  },
  PQQ: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3CnIYYWXhG5cuTVWaoMI6P/082968c14fd8b237d2d057f28943aaba/pqq_mobile.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3fuxfGjePI6p5nZ6VTBm3l/dbb0bba484575a9e000392980c9be997/pqq_desktop.jpg",
  },
  LEMON_BALM_EXTRACT: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7yRMZtubGjq5JDeYXAWBtM/475b57a9969ee69abb73027ff5fea88a/lemon_balm_extract_mobile.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6XSX2qCyQACOeFL4Jjmbru/cb945c141c62701df981d2f7919d40fa/lemon_balm_extract_desktop.jpg",
  },
  ASTRAGALUS_EXTRACT: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1BdbFvSCFDVPMdCoGGoNaS/99a6766939f30514fe4e1855f4867202/astragalus_extract_mobile.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3QEqz8X37yDC1kZHIiDb3E/477c349f6a53cb0df6126bf5366fa72c/astragalus_extract_desktop.jpg",
  },
  JAPANESE_SOPHORA_EXTRACT: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4LEbfmVRe7l5fBwBrQJL3Q/ea2d7452271cff3d07f137058ee50d25/japanese_sophora_extract_mobile.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3oJEpjeUJKEgvChet4d6xW/d69179be0eb7c200b8d9ea7c4de3fa15/japanese_sophora_extract_desktop.jpg",
  },
  SUNFLOWER_PHYTOSTEROL: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/IKgFSCrh0GN50cTda44vW/8ccddb49244ed5303a78ff339f4a2c3b/sunflower_phytosterol_mobile.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5LrSJDoE80xJCOZ02duPa/ba860fd7e9e7873c278b9ed8a728f041/sunflower_phytosterol_desktop.jpg",
  },
  BETA_GLUCAN: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2rMK2ASPJfhBItdjgUnFpS/66d092d17ca818bd13ca1f74f556d707/beta-glucan_mobile.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2u9Jm7UC2RzsKU5ktt7qzi/af3b9c2e4401f5aaafcb0c2ba57ce5fc/beta-glucan_desktop.jpg",
  },
  PREBIOTICS: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2dHvXyShKSzIhjxOr3dqFW/dfaf1464d1ecffb831e6846c21a0fb6b/prebiotics_mobile.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7MCGw3RjWTu0TBX12tGq87/e3a147bad2b5729d8e1f6cf1ecda271c/prebiotics_desktop.jpg",
  },
  POSTBIOTIC: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1w5vdC039xCfStnpNYtW4r/b1c5cf722e77779eec7f7e5567353c32/postbiotic_mobile.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/dGpSTwphEZbYAAwUggFGS/ebdbc51b98e0d2aadf05dd3b83c6c3d6/postbiotic_desktop.jpg",
  },
  PROBIOTIC_BLEND: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4MvgPtVxPTYxiAFo830wn1/f1f11f1eaea9890eb3ce504d4f9611d5/probiotic_blend_mobile.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/Wsa093OQPr3lF2Lw9uqrd/5ae751a4511125d0818f5637f5c9f681/probiotic_blend_desktop.jpg",
  },
  WILD_OLIVE_EXTRACT: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3Z66Teoeuwe0Bo0627Hjcp/487b4e74ff9471b5573317eb41ef1b8f/wild_olive_extract_label_1.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/VWrDFm5KXs7dJkBhzjwaR/7284fddbf5eaa91857ab0975a32723e5/wild_olive_extract_label_2.jpg",
  },
  HEMISQUALANE: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3cyEiSPfWBS3MZF2zWza8y/6cd79e0d78f260e3287b3dc985623ea2/hemisqualane_label_1.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6I1sujQJXgko9TZ8jrk6Ug/7f5c0b569cf724bf0e6a115812039a62/hemisqualane_label_2.jpg",
  },
  ROSEHIP_FRUIT_EXTRACT: {
    label0:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6yHAwXn597jxm2DroVDadf/1d273c9ce323f114872eae9b19cd5c69/rosehip_fruit_extract_label_1.jpg",
    label1:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Lezhr9BQxp6tAQTDB3VJe/ee3cdccef63d0cc0496bbc76e6d19224/rosehip_fruit_extract_label_2.jpg",
  },
};

export const IMAGESMAP = {
  AREAWOMEN: {
    AFTER: `https://images.ctfassets.net/0rbfqd9c4jdo/6WHzREYtdHycLWOXWRbuYd/adcf52ae7d185b0ab3a171be3339a525/pdp-vegan-after-upd.jpg?fl=progressive`,
    AFTER_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/n53ybdw8SFtI4WlGqqSvb/044d93fe79982ac867363926ffcec8f2/pdp-vegan-after-mobile-upd.jpg?fl=progressive`,
    BEFORE: `https://images.ctfassets.net/0rbfqd9c4jdo/5NwjqzqOx5yjlZQY4rRg6i/2f8c8028247b86159541841db09f72e1/pdp-vegan-before-upd.jpg?fl=progressive`,
    BEFORE_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/5xXoVqltaffg2i55NDf8Md/7629a6ff7f861589499072b889e9fd91/pdp-vegan-before-mobile-upd.jpg?fl=progressive`,
    INGR: `https://images.ctfassets.net/0rbfqd9c4jdo/4l0lNIaYVE2RJEUNNB20id/1105a46a7b6b867128155164dd91fc37/pdp-carousel-vegan-ingredient.jpg?fl=progressive`,
    INGR_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/7lGaLHRshRKMjIv5z6Z9kO/73255010897cad7dba57518ee7230e83/pdp-carousel-vegan-ingredient-mobile.jpg?fl=progressive`,
    PACKAGING: `https://images.ctfassets.net/0rbfqd9c4jdo/4PIKdSiH0TbEfCub7ZCs4f/1e027dbfb853611e290d9032061f4e1a/pdp-vegan-package.jpg?fl=progressive`,
    PACKAGING_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/7C22dYrYJ0hXtVw1vu6GGC/bc033a039dd896946e86d0a35191f883/pdp-vegan-package-mobile.jpg?fl=progressive`,
    PILLS: `https://images.ctfassets.net/0rbfqd9c4jdo/7yorC9oCZV5tA7Aswn39ga/cc8bf222f40c76986c46b64ced71cc6f/pdp-vegan-pills.png`,
    PILL_NSF: `https://images.ctfassets.net/0rbfqd9c4jdo/ni2lELZAgMGc4Qp2BcYuQ/6dd6bfe3839fb69af090d1b53409f1db/vegan-pill-nsf.jpg?fl=progressive`,
    PILL_NSF_2: `https://images.ctfassets.net/0rbfqd9c4jdo/58SPd91iCzIRYrzaKVRDNX/514dfd431a4361a1961ef06a4cbf9cf7/vegan-pill-sport.jpg?fl=progressive`,
    PILLS_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/6HiqlzF1xHv42ireDImkpm/5a4f14f6f1e55feea7b07f29b61cfff9/pdp-vegan-pills-mobile.png`,
    VIDEO_POSTER: `https://images.ctfassets.net/0rbfqd9c4jdo/11mVw274szfcF2SaM3awvs/2bcab15db043f942ab5cb0cc76e05b39/2024Jan_PDPTestimonials_Desktop_Vegan_Bianca_STILL_732x960_v1.png`,
    VIDEO_POSTER_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/5dxgyn2m65gULnGjf5brf3/35eb13bec266f266974a631a3302f975/2024Jan_PDPTestimonials_Mobile_Vegan_Bianca_STILL_686x760_v1.png`,
    VIDEO2_POSTER: `https://images.ctfassets.net/0rbfqd9c4jdo/CW9JggVPHuc7WhNPkIBwc/9a2b1481cc0d3fb16972e6cd9ed626ee/preview-vegan-krystal.jpg?fl=progressive`,
    VIDEO2_POSTER_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/6L1tEZzL9RsHJKVb42r3WV/13ddbcc4a63b6cb6b249ebea2d606f6b/pdp-vegan-video-mobile.jpg?fl=progressive&w=686`,
    REDESIGN_INGR: `https://images.ctfassets.net/0rbfqd9c4jdo/4LiuOSJcmr9sM6gj3JxUGI/f1f0e62a55a3b3cefbf810a8c09aa91e/vegan-ing-nova.jpg?fl=progressive`,
    REDESIGN_BEFORE: `https://images.ctfassets.net/0rbfqd9c4jdo/67VVm303azD13FCtLUqVxV/e612b5362725f4491078c4e6a07492bf/women-advanced-before.jpg?fl=progressive`,
    REDESIGN_AFTER: `https://images.ctfassets.net/0rbfqd9c4jdo/1sEGkJwQoeKZxsfbr9AsPf/69d5f17c398cdefcc3606543549b8204/women-advanced-after.jpg?fl=progressive`,
    REDESIGN_BEFORE_AFTER: `https://images.ctfassets.net/0rbfqd9c4jdo/1Sw2jzv3fq9rNzHlY1XK98/52a6e921071873030b9f9bb4889b34c6/veg-before-after.jpg?fl=progressive`,
    REDESIGN_PACKAGE: `https://images.ctfassets.net/0rbfqd9c4jdo/1uiq4ml6odMHfmIbW8siFK/2b26fa1ee93c8ac228069b39a87c1a42/veg-pdp-package.jpg?fl=progressive`,
    REDESIGN_PACKAGE_2: `https://images.ctfassets.net/0rbfqd9c4jdo/2WsZS3QleI0GlUFCdfPmGl/5c5243a760405273a9e27cf2573d5a68/women-advanced-packaging.jpg?fl=progressive`,
    REDESIGN_STATEMENT: `https://images.ctfassets.net/0rbfqd9c4jdo/6LpAbIWRETpkMR3DLmtNSc/c60047057f1ec6009c34b9add477351e/women-advanced-statement.jpg?fl=progressive`,
    REDESIGN_STAT: `https://images.ctfassets.net/0rbfqd9c4jdo/1RZnkkk9pAd31wpoZDgoA1/78b950fc19db640f9a9d0d5e9df50c41/women-advanced-stats.jpg?fl=progressive`,
    REDESIGN_PILL: `https://images.ctfassets.net/0rbfqd9c4jdo/4iddyVxF4VYnZzbX8K2h1v/25c9e1cb61a4c1072bd6f9d0582095bb/veg-pdp-pill.jpg?fl=progressive`,
    REDESIGN_RGG: `https://images.ctfassets.net/0rbfqd9c4jdo/3c7pUgW8S8zQngTizaJE9V/55a306d68ad59685b4b82156a2c9f453/women-advanced-rgg.jpg?fl=progressive`,
    REDESIGN_VIDEO1: `https://images.ctfassets.net/0rbfqd9c4jdo/bHhD25YYKOrouNQPhI0vt/1d2e0afc5d80d4c4874f352637386b7e/testimonial-pdp-poster-kylee.jpg?fl=progressive`,
    REDESIGN_VIDEO2: `https://images.ctfassets.net/0rbfqd9c4jdo/39arbEJXsHEBvvptaFAofU/c785afe2408e25f6db483357cc155f5e/testimonial-pdp-poster-sabrina.jpg?fl=progressive`,
  },
  AREABALANCE: {
    AFTER: `https://images.ctfassets.net/0rbfqd9c4jdo/3u5QpGx1W3CiMbaqQmBggW/08a6213ffb792915cdf9de785670b759/balance-after-desktop.png`,
    AFTER_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/fSvSeXMYAY7MlVY7iiSlr/0cd7c557611c6a33fd6292f2e4ba300c/balance-after-mobile.png`,
    BEFORE: `https://images.ctfassets.net/0rbfqd9c4jdo/7CgyeDz4bycwy2tM3OQ2DA/354c6fe54e8c0efda15d04d74a66244d/balance-before-desktop.png`,
    BEFORE_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/3LqEOpCd6jCtmaaIWqMCO5/c12143c662f54247ae6578b4f05256ba/balance-before-mobile.png`,
    INGR: `https://images.ctfassets.net/0rbfqd9c4jdo/1BLIk48gilypBQqT9qLzrL/38cf9febf14c2fdefc82aa71a3caebe2/pdp-carousel-balance-ingredient.png`,
    INGR_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/H1cHC0HEkOVI0Z9wrDqua/3f573da8e650466a9755133a065b3f2d/pdp-carousel-balance-ingredient-mobile.png`,
    LIFESTYLE: `https://images.ctfassets.net/0rbfqd9c4jdo/3gZqTI7pTtlU4bTcSN4JAM/a1a6ccbce6cef452f723fe2dbfb28540/balance-lifestyle.jpg?fl=progressive`,
    LIFESTYLE2: `https://images.ctfassets.net/0rbfqd9c4jdo/62IFfV2RBt2l67brpKzhLV/ebadcacc88510fd8af6b093855246eb9/balance-lifestyle2.jpg?fl=progressive`,
    PACKAGING: `https://images.ctfassets.net/0rbfqd9c4jdo/2mDJD1VOZwcYJDU9eoyX1O/dd5690fa13a180e20aa0ebd092009ff5/pdp-balance-package.jpg?fl=progressive`,
    PACKAGING_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/10VqrMtAcIUUxWY5FdfLT8/45f6d3a32238bad42b6adbcb24808b7f/pdp-balance-package-mobile.jpg?fl=progressive`,
    PILLS: `https://images.ctfassets.net/0rbfqd9c4jdo/4IJgfp9hdASPi6aW5JQw3h/dceb3d93e1e678aa7711fa08b7acf832/ingredient-desktop-balance.png`,
    PILL_NSF: `https://images.ctfassets.net/0rbfqd9c4jdo/5qg7U8tYopLb0i3ZEqPBHl/a640dc52a18ffc0c747bf79a38f7f7bf/balance-pill-nsf.jpg?fl=progressive`,
    PILL_NSF_2: `https://images.ctfassets.net/0rbfqd9c4jdo/4Hz5C4DXt0Si1S0pQzRGoR/35c571f899402c1db55f2b5d03e6d46b/balance-pill-nsf-sport.jpg?fl=progressive`,
    PILLS_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/4LMew246p83IomxT3iVaWE/e11661a78efd2eb49ae7bb4d6e5c29ee/ingredient-mobile-balance.png`,
    STAT: `https://images.ctfassets.net/0rbfqd9c4jdo/45nhbwslEjOiNm5A9WuGT0/1cd81b34b8d37f11e15b334c192d6255/pdp-carousel-balance-stat.png`,
    STAT2: `https://images.ctfassets.net/0rbfqd9c4jdo/6RGFW3t2ABEgX0yVlnhTBW/0b1a25a627f1ff9d5a52f7338d640965/bal-pdp-stats.jpg`,
    STAT_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/7ijYSPs0SVsRuoL4x1W1QW/205b6953fae3c55622c4c3fd8932284e/pdp-carousel-balance-stat-mobile.png`,
    VIDEO1_POSTER: `https://images.ctfassets.net/0rbfqd9c4jdo/5UPqrBWvVtbxxACLjok9ru/74a29767600fbd71681a47186134f240/2024Jan_PDPTestimonials_Desktop_Balance_Stacey_STILL_732x960_v1.png`,
    VIDEO1_POSTER_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/3ZHAGKO6Mwv3Dc1qKyR4QE/45ac7210b3bb5d2c03863df7f1209a76/2024Jan_PDPTestimonials_Mobile_Balance_Stacey_STILL_686x760_v1.png`,
    VIDEO2_POSTER: `https://images.ctfassets.net/0rbfqd9c4jdo/5hQiAq10SkoH7xdb3uiMn4/45051057e85eb976d55ee850c453b535/KarenRochelle_Testimonials_Preview_Desktop_R2.jpg?fl=progressive`,
    VIDEO2_POSTER_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/6OU3Nu0dWwMP6TpDp1yazl/742c55437a2b1cb7be234981727d5ab4/KarenRochelle_Testimonials_Preview_Mobile_R2.jpg?fl=progressive`,
    INGR2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Cigm9FYmChg7omPmokRYG/63df4cfb149d0525c43963ed9830690b/balance-ingredient-desktop.jpg?fl=progressive",
    INGR2_MOBILE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5e4aUuKaBewWvkF4pnRXiU/2cb6fc96501a167aa5c6d8f391b35afd/balance-ingredient-mobile.jpg?fl=progressive",
    BEFORE2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/Kly9FdnIOXnm5XJiUsdEL/cb642b135893d85d75acaa9bae1c1d89/balance-before-desktop.png",
    BEFORE2_MOBILE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2fUU6kliXem5axmIHLJ5Pm/48333c426187ab4f6657a957c2a442ae/before-mobile-balance.png",
    AFTER2:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4s3XMnvfEFlZ5XIJq6TY4N/e42c89f0be4a5a1269d047b8b28d7cd9/after-desktop-balance-upd.png",
    AFTER2_MOBILE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4vbcIFSCFEajBzN9HiYJd7/a707e30427ffcd7b614099dd6f3e9c45/after-mobile-balance-upd.png",
    REDESIGN_INGR: `https://images.ctfassets.net/0rbfqd9c4jdo/48RnY0ZVsBFXlThBKK53Lk/d827333bc0e9567e0fec14bb6d9bef13/bal-ingr-nova.jpg?fl=progressive`,
    REDESIGN_BEFORE: `https://images.ctfassets.net/0rbfqd9c4jdo/5Ckp9EgpjXlkXowJPUNMBy/99de0b4f2bcdc4858b70c71073076569/bal-pdp-before.jpg?fl=progressive`,
    REDESIGN_AFTER: `https://images.ctfassets.net/0rbfqd9c4jdo/6z0vmasi7l2jQGPQbyKouY/a75eb29db33a507a00b0d6c68940fdfc/bal-pdp-after.jpg?fl=progressive`,
    REDESIGN_BEFORE_AFTER: `https://images.ctfassets.net/0rbfqd9c4jdo/6ZVGzOadyIA3E3QVDsXHaO/33b479ae42d9a8df7b2fa4ecb120ac15/pdp-bal-before-after.jpg`,
    REDESIGN_PACKAGE: `https://images.ctfassets.net/0rbfqd9c4jdo/6NJJXfX0cOWzV7WHrNT1Ja/e5e801b44e94cee33d4341114745ede8/bal-pdp-package.jpg?fl=progressive`,
    REDESIGN_PACKAGE_2: `https://images.ctfassets.net/0rbfqd9c4jdo/5Y3liwkiPM5S9jRvYXmQwS/5b14cb68d89a51010ed02a3af0c3cb6b/pdp-balance-package-spu.jpg?fl=progressive`,
    REDESIGN_STAT: `https://images.ctfassets.net/0rbfqd9c4jdo/x89CFel5933La70rROUBE/b5df15f40684ac6ab4840b1870060451/bal-pdp-stat.jpg?fl=progressive`,
    REDESIGN_PILL: `https://images.ctfassets.net/0rbfqd9c4jdo/QiIRDhJAH9xtTyEQyEdtN/d7d08fe17a5a240ccad3e64a4c3d1343/bal-pdp-pill.jpg?fl=progressive`,
    REDESIGN_VIDEO1: `https://images.ctfassets.net/0rbfqd9c4jdo/5fdCMzA7Y7EDxqNS9ale2M/7fe322c06de13b790e1a660ca476defa/testimonial-pdp-poster-amy.jpg?fl=progressive`,
    REDESIGN_VIDEO2: `https://images.ctfassets.net/0rbfqd9c4jdo/6M5Jh7nuxoNqSasJuwIgvO/53fe9b7e1581955665003b84f10d555f/testimonial-pdp-poster-kaneez.jpg?fl=progressive`,
  },
  AREAPOSTPARTUM: {
    INGR: `https://images.ctfassets.net/0rbfqd9c4jdo/7x01fs87Gi5SVX2mr2x8v0/9f49cf662c37bc9e3081db2576d412d8/pdp-carousel-postpartum-ingredient.jpg?fl=progressive`,
    INGR_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/2Q0tkV5gnyNl2TIKiw3Zlk/eed49751e04a468c70dce4c4fccd18cb/pdp-carousel-postpartum-ingredient-mobile.jpg?fl=progressive`,
    LIFESTYLE: `https://images.ctfassets.net/0rbfqd9c4jdo/5cLWhgVjsw7OtEVaTqvjnB/37a0ac587da1928958971175c498c926/pdp-postpartum-lifestyle.jpg?fl=progressive`,
    LIFESTYLE_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/4oOo9lrwVTyWdkp0L7w6wc/f00dc3cddb231efb49f4a4c1331a9753/pdp-postpartum-lifestyle-mobile.jpg?fl=progressive`,
    PACKAGING: `https://images.ctfassets.net/0rbfqd9c4jdo/6TWBbY4jZCfqC2AhKtv1hI/c58a4328ecba6aeb82ea5b69df70b56e/pdp-postpartum-package.jpg?fl=progressive`,
    PACKAGING_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/6zzo3JhB4SxbenpYaZorK8/0ad9fdafabead4481691dd1279731778/pdp-postpartum-package-mobile.jpg?fl=progressive`,
    PILLS: `https://images.ctfassets.net/0rbfqd9c4jdo/2NCokOmXrSswcKdU8f7dFH/e245b961c1e38176e1ee252902fd26d5/pdp-postpartum-pills.jpg?fl=progressive`,
    PILL_NSF: `https://images.ctfassets.net/0rbfqd9c4jdo/4alhWQ1Ay2kdnnHsDMoZSd/38f32ad956426da1a213937bad39c533/postpartum-pill-nsf.jpg?fl=progressive`,
    PILL_NSF_2: `https://images.ctfassets.net/0rbfqd9c4jdo/5tmgFScKvM8GtuOLdbfjYN/87992a0b096a95a14c2eec7a08c9a388/postpartum-pill-nsf-sport-updated.jpg?fl=progressive`,
    PILLS_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/33ps93A5dlxIsPhwLfi3NW/74079dafe035249cd4e6725d935115cf/pdp-postpartum-pills-mobile.jpg?fl=progressive`,
    STATS: `https://images.ctfassets.net/0rbfqd9c4jdo/2k9VLfQ5bDpsr8nkD2ELli/431bf9cac012d9329b5425a769178ede/postpartum-stats-desktop.png`,
    STAT2: `https://images.ctfassets.net/0rbfqd9c4jdo/5EdEb6Whw4aIj2g1UIl12e/46d841762f5e8fb43b40f753d255f098/pos-pdp-stat.jpg?fl=progressive`,
    STATS_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/1Pve4cwBLaGG6a66EPmztP/7cc4bfbd6f241c5445909a6107cfd21d/postpartum-stats-mobile.png`,
    VIDEO_POSTER: `https://images.ctfassets.net/0rbfqd9c4jdo/57CMSrJwFaMNl40tx6HcXt/de22bfedd783e61b579cc7575ebfa2d7/pdp-postpartum-video-new.jpg?fl=progressive`,
    VIDEO_POSTER_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/1xM6cX0DigKjRTLF2GS2y9/a463a58ce0b542cf4bff0ed13cf42ad4/pdp-postpartum-video-mobile-new.jpg?fl=progressive`,
    VIDEO2_POSTER: `https://images.ctfassets.net/0rbfqd9c4jdo/7l6HJGPrlPasdUBy7xjAHP/2c00cfc6565e4a9db2896c1fcf5fd459/Jojo_PreviewImagesPreview_Desktop.jpg?fl=progressive`,
    VIDEO2_POSTER_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/2vaLP7YiAhchkDBwp9uYbt/a130ca5a3ea646bb23abb988c00d0327/Jojo_PreviewImagesPreview_Mobile_760.jpg?fl=progressive`,
    VIDEO3_POSTER: `https://images.ctfassets.net/0rbfqd9c4jdo/1uERLHFPIeBiEIHTIcgodR/2fb078d261af967b8b9c2c5f67912eb6/2024Jan_PDPTestimonials_Desktop_PP_Gigi_STILL_732x960_v3.png`,
    VIDEO3_POSTER_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/3QSHml0p2elA1lKKHoUT8R/6147c1591e419887806e568ec3ff34de/2024Jan_PDPTestimonials_Mobile_PP_Gigi_STILL_686x760_v3.png`,
    REDESIGN_INGR: `https://images.ctfassets.net/0rbfqd9c4jdo/5fuLM7lQa44RlTu3zUdTDA/8dc60f91cd675884719b02d054564038/postpartum-ing-nova.jpg`,
    REDESIGN_PACKAGE: `https://images.ctfassets.net/0rbfqd9c4jdo/2rrwcym3w6yYULO5oxe19B/47939ebbc53d014179fe66cee4cce92a/pos-pdp-package.jpg?fl=progressive`,
    REDESIGN_PACKAGE_2: `https://images.ctfassets.net/0rbfqd9c4jdo/29t1FkqJzForpVAyo07BNw/18fbcdd867e039e27d6dfa638e448e17/pdp-postpartum-package-spu.jpg?fl=progressive`,
    REDESIGN_STAT: `https://images.ctfassets.net/0rbfqd9c4jdo/5EdEb6Whw4aIj2g1UIl12e/46d841762f5e8fb43b40f753d255f098/pos-pdp-stat.jpg?fl=progressive`,
    REDESIGN_PILL: `https://images.ctfassets.net/0rbfqd9c4jdo/6UDNOs9jEeYaktqgTgeEUo/c7497f76817e93ff86f058640691a48c/pos-pdp-pill.jpg?fl=progressive`,
    REDESIGN_VIDEO1: `https://images.ctfassets.net/0rbfqd9c4jdo/3bacsrHAI5KEPkuti8u1Og/ef788df616f629c7e6ddb04b81728f9d/testimonial-pdp-poster-badiya.jpg?fl=progressive`,
    REDESIGN_VIDEO2: `https://images.ctfassets.net/0rbfqd9c4jdo/6aSRw0QhshsKhuKsFppldb/64bf26988b7730ad266a73446ae2e1f5/testimonial-pdp-poster-gisela.jpg?fl=progressive`,
  },
  AREAMEN: {
    APPROACH: `https://images.ctfassets.net/0rbfqd9c4jdo/5gZR2ZwBmtWZ08Egfy0ARb/a7b36b970a7baf5fe58986588247775c/men-approach.jpg`,
    BEFORE: `https://images.ctfassets.net/0rbfqd9c4jdo/7b5zuq3x7tLh2wD0JCP4AY/ec3dfc1c8ebd8134713efffa23714cae/men-before.jpg?fl=progressive`,
    AFTER: `https://images.ctfassets.net/0rbfqd9c4jdo/kQFsQftgwJeozkHlKQSR8/a29db8bd7963419bc50db4eaceefcec5/men-after.jpg?fl=progressive`,
    BEFORE_AFTER: `https://images.ctfassets.net/0rbfqd9c4jdo/12Rrv2HVDz1oXpyN6BKIcB/e086259f57d63039a95b157636dc8093/men-pdp-before-after.jpg?fl=progressive`,
    RESULTS: `https://images.ctfassets.net/0rbfqd9c4jdo/3XpAm6PRuSXUuf4zlHsEnG/52256553121c45c038c493f3f7dccc39/men-results.jpg`,
    NSF_SPORT: `https://images.ctfassets.net/0rbfqd9c4jdo/1ym0msnZGzKng4MVZGKSC0/6a24482671bceadfd34c8f24d665273f/men-pill-nsf-sport.jpg?fl=progressive`,
    NSF: `https://images.ctfassets.net/0rbfqd9c4jdo/4piHXxtn7QSdmlmfbnfyqb/f46d3dfb0ca3aed73a3cdb9767079d17/men-nsf.jpg?fl=progressive`,
    PACKAGING: `https://images.ctfassets.net/0rbfqd9c4jdo/19qgNsKnQEdyYgMV1ZS3NP/c470a5ab8ceaad99e93daefc9e095e42/men-core-packaging.jpg?fl=progressive`,
    PACKAGING_2: `https://images.ctfassets.net/0rbfqd9c4jdo/4UTB9GXYx0F4Bvxm6SuDvM/46bd2a2a71b4273e3cb42f83d8a11cae/pdp-men-package-spu.jpg?fl=progressive`,
    STAT: `https://images.ctfassets.net/0rbfqd9c4jdo/1ozbwvXSiNyYgJRwEU7ZEx/9f9778a0e02ef58253a39b2abcc5a6f9/men-pdp-stat.jpg?fl=progressive`,
  },
  AREAMEN50: {
    APPROACH: `https://images.ctfassets.net/0rbfqd9c4jdo/3RlDe85yHLnXxBAcxjXI6j/fa071f8d8597da629a5e53b3cbfebeb9/men-50-slide-bg.jpg?fl=progressive`,
    BEFORE: `https://images.ctfassets.net/0rbfqd9c4jdo/4y69067YeH0FDRCdNWfApR/01be62c73852afb8c8af45b7899a71b7/men-50-before.jpg?fl=progressive`,
    AFTER: `https://images.ctfassets.net/0rbfqd9c4jdo/2iNWlXgJAS5udV9FICXV3i/549300cf595bb7429899c15fd8a34001/men-50-after.jpg?fl=progressive`,
    BEFORE_AFTER: `https://images.ctfassets.net/0rbfqd9c4jdo/46T3xdUhvqKPWbMbScSFjy/96397a9cfe7ee66c97afd39a4bc68320/pdp-before-after-3.jpg?fl=progressive`,
    NSF: `https://images.ctfassets.net/0rbfqd9c4jdo/3hBzhjQatUEbN6wKGuZB0R/13f11c235010950de83309c197dda4ac/men-50-nsf.jpg?fl=progressive`,
    PACKAGING: `https://images.ctfassets.net/0rbfqd9c4jdo/7yVDc3O4noC7y75zF3Lq69/66727f223c64dc32609a6a66ca10c98a/men-50-packaging.jpg?fl=progressive`,
    PACKAGING_2: `https://images.ctfassets.net/0rbfqd9c4jdo/1Te4LrIxl9trNWB4pEEUcx/d5d726d7eed79cb449999734be738cef/pdp-men50plus-package-golden.jpg?fl=progressive`,
    STAT: `https://images.ctfassets.net/0rbfqd9c4jdo/5ZCM8E7UeOp2H6ZWCz29Lv/a73d3105ef1647ae69cef7cbca957539/men50-pdp-stat.jpg?fl=progressive`,
    INGR: `https://images.ctfassets.net/0rbfqd9c4jdo/6JV7k6U2cj3yXWJIjFJSbc/b07a2008dd5c4e85f4ee1da338ef530a/men50-pdp-ingredient.jpg?fl=progressive`,
  },
  AREAGROWTHKIT: {
    DROP: `https://images.ctfassets.net/0rbfqd9c4jdo/2cg3ubITRc2WKs13EsSaKJ/373016d2224166b815eb67a5793b81bf/ga-img-4.png`,
    DROP_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/4z1ncB3iZdFFvjD21skcjT/7947a44d2b553e9190089d04829ab03c/ga-img-4-mobile.png`,
    INGR: `https://images.ctfassets.net/0rbfqd9c4jdo/7KpE8FPOM9cBfXtOooNZSe/01b5649a437f50f396aa79d1f99f41aa/fhk_ingredients.png`,
    INGR_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/2KIvhKn4LVKQuyOCmHw0XK/37ea33194ac3a95024b501b1eb218499/fhk_ingredients_mobile.png`,
    PILLS: `https://images.ctfassets.net/0rbfqd9c4jdo/5GVmrchZR4iymkT7c4UpMU/10e5becd430334179ab5876214e16702/Nutrafol-broken-pill-hair-growth-supplements.jpg?fl=progressive`,
    PILLS_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/3yHUccvuflJGoXJytlx4Ol/ac4597f11dc816fa4c12168f6f21d3a8/Nutrafol-broken-pill-hair-growth-supplements-mobile.jpg?fl=progressive`,
    VIDEO_POSTER: `https://images.ctfassets.net/0rbfqd9c4jdo/2PJYVKUFInmLjeIgXoDbvT/5cc71bccc90c96cb14f58a3977948cd8/Hair-Serum-poster.png`,
    VIDEO_POSTER_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/4GAiJAAWg3Ksfht2xqiFw5/f9a48494806bfe00145068238cc4a682/Hair-Serum-poster-mobile.png`,
  },
  AREAGROWTHACTIVATOR: {
    BOTTLE: `https://images.ctfassets.net/0rbfqd9c4jdo/5EryZ45rqN95f4F4Q83sf7/1a87b0bf3ea9b73c3fe5696a4e5e5718/Hair-Serum-hand.jpg?fl=progressive`,
    IMG1: `https://images.ctfassets.net/0rbfqd9c4jdo/19qJKDYF9xVnjCa9RLp3Hq/934deef84aa4a323b132b46fa6937288/Hair-Serum-Carousel-1.jpg?fl=progressive`,
    IMG2: `https://images.ctfassets.net/0rbfqd9c4jdo/4havF9Lgnuo6FEVAYmhja/869a22b2ccc414665595dd5e69f868b3/Hair-Serum-Carousel-5.jpg?fl=progressive`,
    IMG3: `https://images.ctfassets.net/0rbfqd9c4jdo/2X9Hpuo3zYkcT6QkF3Q17T/541a7d4184fcfc3c578a28b800ce1409/Hair-Serum-Carousel-2.jpg?fl=progressive`,
    DROP: `https://images.ctfassets.net/0rbfqd9c4jdo/2RdHdb7t8WQEltzJ9fkoNV/1e630dea2b2f2a35000e914332b99c24/Hair-Serum-Drops.jpg?fl=progressive`,
    VIDEO_POSTER: `https://images.ctfassets.net/0rbfqd9c4jdo/2PJYVKUFInmLjeIgXoDbvT/5cc71bccc90c96cb14f58a3977948cd8/Hair-Serum-poster.png`,
    VIDEO: `https://nutrafol.com/media/video_storage/Hair-Serum-Desktop.mp4`,
  },
  AREAHAIRSERUMSML: {
    APPROACH: `https://images.ctfassets.net/0rbfqd9c4jdo/2xT9Hf79jyCIXe6Fo3TItl/e41cedeefc2059717b42a9095cc880c6/serum-imagearea-1.png`,
    APPROACH_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/5olKRk9fQmlDbn5Q3mnkNJ/2dc51e42d064997399efac6d045bb74c/serum-imagearea-1-mobile.png`,
    PILL: `https://images.ctfassets.net/0rbfqd9c4jdo/4Ztv7uVcvLw8c0O0YLPkhW/1d709f7a8b05a55c50e4b1c87a2c3ba6/serum-imagearea-2.png`,
    PILL_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/24mswwEKTIcP8jPcxUCD8H/8341f96d6bafed2861cb2c6f0231169a/serum-imagearea-2-mobile.png`,
    USAGE: `https://images.ctfassets.net/0rbfqd9c4jdo/67lHzevlyE9IxPh28Kwe87/d074d99836633480812be5bbf2ab94c9/serum-imagearea-4.png`,
    USAGE_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/55LzvIgnUWZzwl6ENjKEOX/2d3f4e5deabd9ab6e501e5437303b868/serum-imagearea-4-mobile.png`,
    VIDEO_POSTER: `https://images.ctfassets.net/0rbfqd9c4jdo/5KCHir9VYb6wzvpg7Qnp2i/1a6c41ceaaba80d33989022e375dc491/Desktop_Poster_HairSerum_PDPVideo_05.23.2024.jpg?fl=progressive`,
    VIDEO_POSTER_MOBILE: `https://images.ctfassets.net/0rbfqd9c4jdo/5Up4oapTXV6AYWaxUNz3ik/99f894d2584aeb1227ee7435fe6f0074/Mobile_Poster_HairSerum_PDPVideo_05.23.2024.jpg?fl=progressive`,
  },
  RESULTS: {
    JON_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/xKPrPUjjHujDxyn0b01g0/c63261ed552abfbf29645cf25b149eda/results-jon-before.png",
    JON_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/WvPReUOtEAawwIrGDWlUx/807172f5941fbbfa5586abd49279b39f/results-jon-after.png",
    ERIC_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6eu54wMg7A5CqFIAmURyRP/86ccd09188fcc769145815ea8d8e314b/results-eric-before.png",
    ERIC_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/40j9q7HUFzfZ36lV6cCUtB/798928b64d2e47d025032607bc8c464a/results-eric-after.png",
    KYRON_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/JViIQVKP0EeH212AAFTuF/78ac00373d2fb5f6c7f9c89c6429e04f/results-kyron-before.png",
    KYRON_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5HyKayRFUYOVjYQF4TaOS1/95bb11cb7c73df531b2feff3b0e9969e/results-kyron-after.jpg?fl=progressive",
  },
  RESULTS_50_PLUS: {
    DAVID_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2F1DBBH2XzPAR4EpeBdc4L/7e2443d8ecbb44f25fabb47ae69f6d6b/david_before.jpg?fl=progressive",
    DAVID_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7upwVktzgdm6aBkpr2Ix5j/be8103531c137388ee6471b7bd43a8a4/david_after.jpg?fl=progressive",
    DAVID_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2ncXjG2Biiop0PYI3hZrvN/2fad54bd3d132dd1c3682782e77b3152/david_tn.png",
    GORDON_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/50IoVQK2xllD1FdWeV2wf/889543e7fd7003044876175006518f47/gordon-before.jpg?fl=progressive",
    GORDON_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2nKbp0SWcGaBuGUMSMLE7Y/14c6eefb181ff76e6f3cf941ce462dd0/gordon-after.jpg?fl=progressive",
    GORDON_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2ncXjG2Biiop0PYI3hZrvN/2fad54bd3d132dd1c3682782e77b3152/david_tn.png",
    RICHARD_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/23eEshnmE2AxlGFaPVOpqv/1b13de9125b101368173618865856f10/richard_before.jpg?fl=progressive",
    RICHARD_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1Y2Bar77ewZru3MPgS34EM/3cc1391d3567a805a5be3dd19a4822bc/richard_after.jpg?fl=progressive",
    RICHARD_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6gJHLL0yiW3B7Ct4ZxXhC4/f67150ea0faf59c78395e755b5e96ba8/richard_tn.png",
    OTTAVIO_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4BEWSfSNOrn9uENw83GSjr/3fd26925a84beb71c9b028fe27863606/ottavio_before.jpg?fl=progressive",
    OTTAVIO_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/13wC56g3meUcTHa8tY86Ps/e8b2d35964d797d6317174855f57b01e/ottavio_after.jpg?fl=progressive",
    OTTAVIO_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/74qyVXjxkMr1eiCepSe9Da/5a07a13d89a590cbbe0c92de8d9ab6bb/ottavio_tn.png",
    STEPHEN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6SLBDD2SHJAML09he4cCBB/9b2e264a1a2db006daecc9c3c3ba7305/stephen_before.jpg?fl=progressive",
    STEPHEN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3ZpQ5e9yEyJkV3pnkQm6Ov/f603f7265b2f3466702e21ac700ccdd9/stephen_after.jpg?fl=progressive",
    STEPHEN_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5xI01iidcdXdHCnlT9Z3fl/c6cdfa7b094fd0a7f91d1dec1adc283e/stephen_tn.png",
  },
  RESULTS_MEN_NOVA: {
    BRIAN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3FFJ9USkrbbbYlBYMmuik5/9c02ca3d0ab73c5ed0ab2a188dce4b10/brian-before.jpg?fl=progressive",
    BRIAN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4KYb93oX0pzujuGyK5YGNG/2906ee3c7ff35e6f693a9e3734778438/brian-after.jpg?fl=progressive",
    BRIAN_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5y6AMNMrNOo1l0DFEFrJ9W/1af241ab24e542962fccf558e7b2d65e/brian-tn.png",
    MARK_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6TOcwnB4NnjPHj0sluC4Nx/e0a78d11b96ba5540af5a86d2141c840/mark-before.jpg?fl=progressive",
    MARK_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3ScIEjgHreCdZXpLRrIIp8/6e5fe1e11da07f2663eb2879fd05769d/mark-after.jpg?fl=progressive",
    MARK_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7aMyR6usRwz0A7kzKz4YMK/d82d55676eceec8c3b7a44f83c996ae3/mark-tn.png",
    JIM_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3VjHlJ0wJMiNxflljLQooz/538138e923fd676c3d44215524269357/jim-before.jpg?fl=progressive",
    JIM_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/FplJWF9tsbyqAe7xiNFxs/2976649a74881683731b73908aa7ab9f/jim-after.jpg?fl=progressive",
    JIM_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2S4VaAHC2laRcxHqhaIN4u/6651ae9994d58df3e62b878f3973d39c/jim-tn.png",
    JOSE_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/77N8bXOfWlctu7muENUjJC/8c2eda973ccb57a0f471380266149aa2/jose-results-before.jpg?fl=progressive",
    JOSE_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3B5RpTOEayhhWfqitaNXYo/07f63dcdaa3e492e1d1908c4402ca7be/jose-results-after.jpg?fl=progressive",
    JOSE_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1ngkM9rlVGuk0BdeOBD12y/c03633650afa88e08d6cce5c3f889821/jose-tn.png",
    JASON_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3yiUJZ6VZ3WCtRGml7FfTx/a38c7f818e692a6046fb89b42fb9d45a/jason-before.jpg?fl=progressive",
    JASON_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/01yg3aMa5IIGjvhEZ5q3ht/bd70c24e9223d7b059952965c11e9641/jason-after.jpg?fl=progressive",
    JASON_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/31jdDCgiaZXymCczUbJLFM/d46cc8b8d4651d20a8062d175a3e7e8d/results-jason-tn.png",
    ANURADHA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4jWJIyEbnSWCdOTMArsAm8/8447b30523b0e0c6fa29e5ffc7a98aa2/anuradha-before.jpg?fl=progressive",
    ANURADHA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/SfGE2q6qcgFFststehZVd/36e5e5d32c2d6a7e9f7059a191dd47a0/anuradha-after.jpg?fl=progressive",
    ANURADHA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4f9nbQkLbv57VVT9GYb8I1/4be755be285d8e5623538763ea0bedc8/anuradha-tn.png",
    SAM_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6o5iOKoG5V1X0TouS4Z3Dj/64cbd50c03b43384d6511c67ee3dacdd/sam-before.jpg?fl=progressive",
    SAM_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1qHDZZt1SUC5XdUJFm5uwI/28f0c188401fc505c87aa08cc0a37a96/sam-after.jpg?fl=progressive",
    ADRIAN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4fx8vmJj40ZxBxBsLjuZiL/059c8e3a9a280182771ad606b21a8ecc/adrian-before.jpg?fl=progressive",
    ADRIAN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5Z2WsVUPSI3FSSXaWa0x4A/b4e396243fedb8897477f7f81b8f49f6/adrian-after.jpg?fl=progressive",
    TANNER_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4SjL5mak5KdOaA3ag7Ldso/71e4b3b836826d6ee2a7ac3d261a961d/tanner-before.jpg?fl=progressive",
    TANNER_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2MKDakgsk8q9GnZdrTmbaK/e99a3d676d563f295ff7df7e7b927939/tanner-after.jpg?fl=progressive",
    RICHARD_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/23eEshnmE2AxlGFaPVOpqv/1b13de9125b101368173618865856f10/richard_before.jpg?fl=progressive",
    RICHARD_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1Y2Bar77ewZru3MPgS34EM/3cc1391d3567a805a5be3dd19a4822bc/richard_after.jpg?fl=progressive",
    RICHARD_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6gJHLL0yiW3B7Ct4ZxXhC4/f67150ea0faf59c78395e755b5e96ba8/richard_tn.png",
    ROBERT_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/0NTdcE5wPXT272plxgZdc/efb41a20c81da37dc0194e4f2aa2129d/robert-results-before.jpg?fl=progressive",
    ROBERT_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6ZZGe6pT907Yx3eVLxwO7d/aa0c603e71d3de8deb037c5968f965c5/robert-results-after.jpg?fl=progressive",
    ROBERTD_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6gJHLL0yiW3B7Ct4ZxXhC4/f67150ea0faf59c78395e755b5e96ba8/richard_tn.png",
    STEPHEN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6SLBDD2SHJAML09he4cCBB/9b2e264a1a2db006daecc9c3c3ba7305/stephen_before.jpg?fl=progressive",
    STEPHEN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3ZpQ5e9yEyJkV3pnkQm6Ov/f603f7265b2f3466702e21ac700ccdd9/stephen_after.jpg?fl=progressive",
    STEPHEN_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5xI01iidcdXdHCnlT9Z3fl/c6cdfa7b094fd0a7f91d1dec1adc283e/stephen_tn.png",
    OTTAVIO_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4BEWSfSNOrn9uENw83GSjr/3fd26925a84beb71c9b028fe27863606/ottavio_before.jpg?fl=progressive",
    OTTAVIO_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/13wC56g3meUcTHa8tY86Ps/e8b2d35964d797d6317174855f57b01e/ottavio_after.jpg?fl=progressive",
    OTTAVIO_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/74qyVXjxkMr1eiCepSe9Da/5a07a13d89a590cbbe0c92de8d9ab6bb/ottavio_tn.png",
    DAVID_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2F1DBBH2XzPAR4EpeBdc4L/7e2443d8ecbb44f25fabb47ae69f6d6b/david_before.jpg?fl=progressive",
    DAVID_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7upwVktzgdm6aBkpr2Ix5j/be8103531c137388ee6471b7bd43a8a4/david_after.jpg?fl=progressive",
    DAVID_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2ncXjG2Biiop0PYI3hZrvN/2fad54bd3d132dd1c3682782e77b3152/david_tn.png",
  },
  RESULTS_MEN: {
    ADRIAN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/41rC9RMltP5Hv55XCJfSL4/76c639ce264ffb4c4572cb117bde2255/results-adrian-before.jpg?fl=progressive",
    ADRIAN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7rj5oV8CmPum4mKSNs4Hbk/27a03d7e300805dfbadcb2ca5aabc957/results-adrian-after.jpg?fl=progressive",
    ADRIAN_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7dmPsCpDISvVQPRnMEmn5P/8a45a3a6387a33b6dfd6e5f20912ea60/results-adrian-tn.png",
    ANURADHA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7eRmp4KPu6Pdry55YOTTwl/e48664ec292aa5717768a09db0afab35/anuradha-before-mens.jpg?fl=progressive",
    ANURADHA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1ChmeFi7nbvtV0D04gifdn/074f39a3cdc80b57194b084b50593905/anuradha-after-mens.jpg?fl=progressive",
    ANURADHA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4f9nbQkLbv57VVT9GYb8I1/4be755be285d8e5623538763ea0bedc8/anuradha-tn.png",
    BRIAN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5v6BDgqZ64P1Ajr8G1pHEx/8b99d74a3be87d002576e8c93c500b54/results-brian-before.jpg?fl=progressive",
    BRIAN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2zS0FThsXTOhzMuuqBuPpz/3ac332da9316cac7211d6ab85044d648/results-brian-after.jpg?fl=progressive",
    BRIAN_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Nr4z81RFTRCNVWtC1TaGI/075a14dbf1bd4ace019e22488034f4a4/results-brian-tn.png",
    DANNY_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5RliUcTXo4VwtooBSGbYMh/e7156dc88aa691cbc4eea0c06adce7b9/results-danny-tn.png",
    DANNY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7haENw8YyfD9hXAezUwYxN/8f7b9e82046abe5cee09b1401945b3cd/results-danny-before.jpg?fl=progressive",
    DANNY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1sB3v4LQPfBbteRAolHXkg/705e40f85ac19d25800c07457f645292/results-danny-after.jpg?fl=progressive",
    JASON_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3yiUJZ6VZ3WCtRGml7FfTx/a38c7f818e692a6046fb89b42fb9d45a/jason-before.jpg?fl=progressive",
    JASON_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/01yg3aMa5IIGjvhEZ5q3ht/bd70c24e9223d7b059952965c11e9641/jason-after.jpg?fl=progressive",
    JASON_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/31jdDCgiaZXymCczUbJLFM/d46cc8b8d4651d20a8062d175a3e7e8d/results-jason-tn.png",
    JASON_BEFORE_ALT:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6tYiJh7Ch8vq3Q8pY38xst/8a719f5026918e94a7be330c20311d6a/jason-before-variant.jpg?fl=progressive",
    JASON_AFTER_ALT:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6tTei0FxzRn026pjLUNC42/6890e264a3f97c607e89758abbe3cb4c/jason-after-variant.jpg?fl=progressive",
    JASON_BEFORE_SIDE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5QasAwopktlS0nPHumXAAZ/5c1d568211e2bd97e1fc3a55aab49d57/jasonBefore.png",
    JASON_AFTER_SIDE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3ytBlrQZBtK73J2Er91gc1/9472c47292813b33dff87145a5af78ff/jasonAfter.png",
    JIM_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6eZZiiyAXldrw9KUm5xzF1/10ea56c3224b0832642c4892412e5c0b/jim-before.png",
    JIM_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6j2KSzzoNjOQC11Iu883Qw/e3b67166f9f20a2860793623eddf4b66/jim-after.png",
    JIM_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2AzHECe2QXqN2TNSB80qx7/7b143121ac863639bce1e42d59465dc1/jim_tn.png",
    JON_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/xKPrPUjjHujDxyn0b01g0/c63261ed552abfbf29645cf25b149eda/results-jon-before.png",
    JON_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/WvPReUOtEAawwIrGDWlUx/807172f5941fbbfa5586abd49279b39f/results-jon-after.png",
    JON_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6fOJLag7d9r9YvubJmT54z/53ae02a5f19ab0548e66aae391716fe1/testimonial-thumbnail-jon.png",
    JOSE_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4HwdEVlMaHafkR69ABvlLA/59ecbf7b77809bd5c8179afdda5746ed/results-jose-before.jpg?fl=progressive",
    JOSE_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/792r3yeH9yEyxDSiy5jUVL/ddc4852b26056f6182dd043e9600f5d7/results-jose-after.jpg?fl=progressive",
    JOSE_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6y0VrZiVZi5kIb71Ktyyc6/50489539f8dc3548571827f9d20dc573/results-jose-tn.png",
    KYRON_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3qFK4TYihGltvASJ6asFm/f85e38de1ac3d87c50a2ab53c0a73585/results-kyron-before.jpg?fl=progressive",
    KYRON_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5wyqqhlIJuJWCm10CMp4YG/c1f9775b9f694548802dab6a67d5c4ba/results-kyron-after.jpg?fl=progressive",
    KYRON_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/209OiVL5ylmig82bNdD2ck/2339369571badfa28db4f6e31756851d/results-kyron-tn.png",
    MARK_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/Mtzz3DInwTCm0IeDxoXgG/7f38c0b715ad27a43ad84621a2baddf7/results-mark-before.jpg?fl=progressive",
    MARK_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5RUEe0gpFYXNxucbr11sJq/097ab566f8e1c2d69e9670906c09f90b/results-mark-after.jpg?fl=progressive",
    MARK_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5JA5omwGhwmLdcOnQyugoO/132defb54a98e9830f08fdbba80740ec/results-mark-tn.png",
    SAM_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2OVsJknIT73T1hHnV90Rvv/60599325a54db480393e72f76e36692a/results-sam-before.jpg?fl=progressive",
    SAM_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3134KIIA2HlM58Ue1MhF9N/49900ce1d4e5894da2c0f8d16d44fcd5/results-sam-after.jpg?fl=progressive",
    SAM_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7n1o2QvgU2ZYh2l2X7Qpwb/22cb7aa81e9f0bc3bb346f360865b374/results-sam-tn.png",
    TANNER_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2VdVLiktLvaLKtiCryz9WQ/0a618e42557154da16869b71f01c2e5e/results-tanner-before.jpg?fl=progressive",
    TANNER_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7z5Qv10ckNV49W7klE9xvj/b084b0a070dd4085ca1f8e5a3eaa79ee/results-tanner-after.jpg?fl=progressive",
    TANNER_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3TFkYUy8g0HjfDwoNekSgX/c486c5db3159ff59bc42756e2a67aac6/results-tanner-tn.png",
  },
  RESULTS_MEN_50_PLUS: {
    DAVID_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2F1DBBH2XzPAR4EpeBdc4L/d34259ad668606d225caad880cb44621/david_before.jpg?fl=progressive",
    DAVID_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7upwVktzgdm6aBkpr2Ix5j/b0aeeb6db89b10ceee989da69f57b14b/david_after.jpg?fl=progressive",
    DAVID_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2ncXjG2Biiop0PYI3hZrvN/2fad54bd3d132dd1c3682782e77b3152/david_tn.png",
    RICHARD_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/23eEshnmE2AxlGFaPVOpqv/78c0e8176ae4eb090a42716be3354ce5/richard_before.jpg?fl=progressive",
    RICHARD_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1Y2Bar77ewZru3MPgS34EM/efedce4e17898bb89819e65a2c1a737c/richard_after.jpg?fl=progressive",
    RICHARD_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6gJHLL0yiW3B7Ct4ZxXhC4/f67150ea0faf59c78395e755b5e96ba8/richard_tn.png",
    OTTAVIO_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3bVmoUKWyNlSgxuwIaxAwe/e58366a3bf92b7a85488be09fcc3cf68/results-ottavio-before.jpg?fl=progressive",
    OTTAVIO_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2aNb8Iq86ysEbZslmvpc1Y/561cd76caf7281a41631532bfeded64c/results-ottavio-after.jpg?fl=progressive",
    OTTAVIO_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/74qyVXjxkMr1eiCepSe9Da/5a07a13d89a590cbbe0c92de8d9ab6bb/ottavio_tn.png",
    STEPHEN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6SLBDD2SHJAML09he4cCBB/4ea20f821aac9c690076eb2c48d23ce6/stephen_before.jpg?fl=progressive",
    STEPHEN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3ZpQ5e9yEyJkV3pnkQm6Ov/42be4c1e216e809eea60c10f1b798bf0/stephen_after.jpg?fl=progressive",
    STEPHEN_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5xI01iidcdXdHCnlT9Z3fl/c6cdfa7b094fd0a7f91d1dec1adc283e/stephen_tn.png",
  },
  RESULTS_WOMEN_NOVA: {
    ANTONELLA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2hvolrBP9tDt4aOW2DNYma/b3aa63ab6800faa104d9280e843ab149/antonella-before.jpg?fl=progressive",
    ANTONELLA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3IkOZz9lHAByjYQYzwMdhS/e42d36a354477d392b5a6f9e0984c583/antonella-after.jpg?fl=progressive",
    ANTONELLA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5LygiKoop1aackqnTFYnk1/0f843c528006926ca23a7f76b66b0345/antonella-tn.png",
    LISA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1fMbiPRvjY5D5eXXx7R4Ij/702183c96dcfd0a2bc4b4bb9e77a106a/lisa-before.jpg?fl=progressive",
    LISA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4wPi1byJGfCgglqe97ROUY/37dd856ef383f9e14fe4d6b6dbf246b2/lisa-after.jpg?fl=progressive",
    LISA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5CsbewOo7khiGOMUrU3n1q/1d0de24f87009bb34922293c97250faa/lisa-tn.png",
    JODI_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1h7X9jdItxGMoBVhpFTkCX/6dfbf18569e691bf8aed81f6fe718c87/jodi-before.jpg?fl=progressive",
    JODI_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1DeBJKudF0Xuf9jnaxgvNj/a1aed770fef6c007d032863bffb6b81c/jodi-after.jpg?fl=progressive",
    JODI_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2sevXMwVBZburB8ioohldT/b623b02393065ce3a3e293b7dfb4c674/jodi-tn.png",
    ALEJANDRA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/S2yCvchz07SARWEswpcP3/6947a97ed70fc73bda300e7f2b494a9c/alejandra-before.jpg?fl=progressive",
    ALEJANDRA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7JWuxldEBbjIOmnM5MMLoa/a00584a2af6344b9bad936f9fae4fe4d/alejandra-after.jpg?fl=progressive",
    JOANNA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/20kpUKThf1L7mHkXw3w0AB/1195544714869ce7bfb5b07541af148b/ugc-joanna-before.jpg?fl=progressive",
    JOANNA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1VYWlJJZxu4n4poZeE3N6I/e8b207cc853e7f75577935a0dc4b1719/ugc-joanna-after.jpg?fl=progressive",
    JOANNA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4cVAZNwv2odWSOfHizrYkJ/7824b968bd7e4dcf7be47a5533192df8/ugc-joanna-tn.png",
    TANYA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4bjabl4coq6lMcDFo1o9Py/3b71867238f0b5f88aead6a30012fc2c/tanya-before.jpg?fl=progressive",
    TANYA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1ExpN6f0hL2hEzE8n0TYL1/ff9c5dec5ed3d97c0af53ef559e81c6d/tanya-after.jpg?fl=progressive",
    TANYA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7cwXJtwjFizQmtLhmE4ryi/2ee415e0fd2417fb899922da1ec0397e/tanya-tn.png",
    NEGHIN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/17c5ssH0L1959Mk2y4OwLr/6bf7f8942505ff3bfc57ec05a9aa2b66/neghin-before.jpg?fl=progressive",
    NEGHIN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/kEyIBiMRhmSXDMXiTPb3Y/9c7dd9e6a3c0f6f160d684fa7d67d18f/neghin-after.jpg?fl=progressive",
    NEGHIN_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6fFA1Mk0nHVyN316cN0FYC/f2628783ca69a6cc2788d415bc531ea3/neghin-tn.png",
    LILYANA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1xRlzfxyiGtul5keYo7la2/62227ee790d40c2d95694dd8e731ffa9/lilyana-before.jpg?fl=progressive",
    LILYANA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3bTG65ZRBM16CYRaryFd1m/ed117c9db2b2c7c1b6fc153996f21279/lilyana-after.jpg?fl=progressive",
    LILYANA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4VmLt6HiUM2YM5dZv7ZDDC/7db2deb9e90665ad63a65c2e1bb3e428/lilyana-tn.png",
    CANDACE_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3aiQpUBjJukntnudsG0VpZ/a8c500f531011eccff24e4af787a6c79/candace-tn.png",
    CANDACE_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3T8QdZ9HE95NKkQPOLCyRp/a44be307b024efca832e99c76050b3c0/candace-before.jpg?fl=progressive",
    CANDACE_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/225pQdIsMuhCtX039rQthx/2a73cbc85b0a4e1bc450893efbc1290e/candace-after.jpg?fl=progressive",
    ALIZA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7Ev96872PFjQ0qdTUOXsne/33a4f0c1f598556997a7f2b0f84c30e6/results-aliza-before.jpg?fl=progressive",
    ALIZA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4zvrKJyGmqeqTWQpZIPUw4/6298a78625d6439d0d8b99a1d2ba75d5/results-aliza-after.jpg?fl=progressive",
    ALIZA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5PUyZstakRVfxavx6Vi27X/a3be831e2eacce95ef20dfdc86feaeed/aliza-tn.png",
    CAT_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3SkzhKFdHUmTClFS6InRYn/d00e786ebd75b3fb15ae3520e70c28d9/cat-before.jpg?fl=progressive",
    CAT_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3PBhPehNiRaW7GflwVtmgk/815a35328ef3152cb75ab61094cfe638/cat-after.jpg?fl=progressive",
    CAT_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/a5NTTdrqknaQvrL6pqXuT/4da31d257e956e31032fa7e65e3d8092/cat-thumbnail.jpg?fl=progressive",
    DAWNTE_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/OOjEn8opzsNmMdBkZTjLk/851f71932473b9ce9b6385486b663f38/dawnte-before.jpg?fl=progressive",
    DAWNTE_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5iHI9fkvqUpBLIUMhL4YRs/0be8a4fc4f4ce29dcf97ee58bd7fbeac/dawnte-after.jpg?fl=progressive",
    DAWNTE_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4II84OX7C4zYv6UADFxWBi/17a7040d7e6043e0ed2fb5887477b565/dawnte-tn.png",
    ENSLEY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1Y46VR7qPjraPCSLpVyK4w/d31ca786df807594a797997cd2392848/ensley-before.jpg?fl=progressive",
    ENSLEY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/BxLkhnKfRuyiQtHoc2zIV/5cee6465bb5698cdb857648ae0321de7/ensley-after.jpg?fl=progressive",
    ENSLEY_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4rMCbjab6kyzxZukGv8FG/e88fd06309cc9aa081c72fc99f699fef/ensley-tn.png",
    ERRYN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2LjZibvbgkdN6LJt5bAW74/b24a6129d1fc522c18790974d8260391/results-erryn-before.jpg?fl=progressive",
    ERRYN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3ItcbWapqu3A1qEKKhIPW/052660c21f1fe4f13e9237e698e14419/results-erryn-after.jpg?fl=progressive",
    FELISHA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/17d6sUUPcGzGQVyQXjwOXF/eaf915ab33b7297ab84840f4adfba777/results-felisha-before.jpg?fl=progressive",
    FELISHA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1u3YVvTmtz9yBRXEVdYkI9/f3030cb8f6a6dd7cb2fc83bd368dc7c7/results-felisha-after.jpg?fl=progressive",
    HEIDI_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3wkQDoKQg7nBpAebBwwXuX/284d56268c2ea4c3c5cc9627a7efff7d/heidi-before.jpg?fl=progressive",
    HEIDI_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5bxLfWEdK06y0VYg5k06oN/3cfdae2ef33439a2a256b457b8b231c0/heidi-after.jpg?fl=progressive",
    KAREN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6RKmgtL9QIKTW2iUEFChFY/80410b9ec6c917ada7f2d6dcfd363774/karen-before.jpg?fl=progressive",
    KAREN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/61qwc9hbl5DeAvCM0J1F6D/3c725223b229ebac1446a65501039eb7/karen-after.jpg?fl=progressive",
    KARIN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3tgepqXwqPg8xXjVtIzuKm/073da3a696b5df91c8a46e782ad16366/results-karin-before.jpg?fl=progressive",
    KARIN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2oTIyZxgh2Oga8CYDkTJhb/5f254e2d8164dd2e47e9de9adc5396cb/results-karin-after.jpg?fl=progressive",
    KAYLA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/14NgQM6WHR0QXGPSkVNHxW/c4acb072f4f8ccf3b69e5b9c732f7bbd/kayla-before.jpg?fl=progressive",
    KAYLA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2kW6nTp0nsC7uKINhjosqN/b1d754e8ec5c206221147bc94a0a6be9/kayla-after.jpg?fl=progressive",
    KAYLA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4UxuIVhoSY2jUJ22EkrVd8/8ae89c6c5fa467bfa9236071bdc04505/kayla-tn.png",
    KIMBERLY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4sXJrLHbTNOhV907aMw9y6/d851a18c81f85c9fef6287de37ff1ee2/kymberly-before.jpg?fl=progressive",
    KIMBERLY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1utBNXOPKA8tAm421K2Zlm/ec44e87ecc7a1474656de83d11675947/kymberly-after.jpg?fl=progressive",
    KIMBERLY_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3SkFGZVTPygQd3l0RKQphi/9025bebf886dfaaa3f750e10d6895b87/kymberly-tn.png",
    KRISTY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/67nUjg5ShINidnLT7oNZOa/b2b00a2f6d47d3d424edce0824b38d03/kristy-before.jpg?fl=progressive",
    KRISTY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7FM1a4E65UgsMqPdPlYPoz/77ceb3a2c542909b32a840f46822325c/kristy-after.jpg?fl=progressive",
    LINDSEY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/BS8cKZUgXEii1MtxfLBwE/cf7b2326433e6a5aaef74570b455a477/lindsey-before.jpg?fl=progressive",
    LINDSEY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1wm49DNiKyae8X7HzFXZWj/6a58ce69de46d35b470d59f5945c7a82/lindsey-after.jpg?fl=progressive",
    LINDSEY_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2WTKsYFX2oIQuigRHdTE0u/19c02ff3e2c9983ef6b6613a347af829/lindsey-tn.png",
    LYDIA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6NDf4pZPpeBNjmYHofj6Ik/08a7c88e229bf97eb6d12aef9b4ebde1/lydia-before.jpg?fl=progressive",
    LYDIA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5kGKS7yY2hRGEDY0uvSapI/a66c467f51ae9300a5242290a0ccc829/lydia-after.jpg?fl=progressive",
    LYDIA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/A4njNCDnjUHxTcYVsKP4m/4347044f1afcdcdb5a9238ba6b8be3ab/lydia-tn.png",
    MIYOKI_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/76WiJXsF6Hc7xbv36uKibQ/7138d3c72ac3071b585c19c02b76d94b/miyoki-before.jpg?fl=progressive",
    MIYOKI_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4tSqg4JQ64QXSR3gDVadQJ/81cbee1df590a2cbdf7adeae36ce118a/miyoki-after.jpg?fl=progressive",
    MIYOKI_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2f5I3AvS8vRS4ZO1xTnz5M/8a36b91cb9ae1a9e962c0ac07c4c8cf3/miyoki-tn.jpg?fl=progressive",
    MAJIT_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1be4lQT4eOE2LCaXXAMzEf/15b958e583f7d96758319769e847885f/majit-before.jpg?fl=progressive",
    MAJIT_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3KE4BSRFBGgLaUxvb4g5GV/7962bf648241446be1e8d75d42cb92c0/majit-after.jpg?fl=progressive",
    NAOMI_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2qZwBTMjm7NrUmFT8b4uhK/c66e025f42713774b4ffa01118eb5b88/naomi-before.jpg?fl=progressive",
    NAOMI_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/X6eOCg3OQm4Za6n2224U3/c662448a2009b2ea1a72165334db89f5/naomi-after.jpg?fl=progressive",
    NAOMI_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1u5fG0I25KAYAMmjntcnwe/f3f6c05bbaa18376e76381ae51d30fd1/naomi-tn.png",
    TERRY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/43pLIiWz25gB1OnOh0awDq/a311b3a44d68070be0c9f1e1ef959faf/terry-before.jpg?fl=progressive",
    TERRY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3TOdFOUtT2jOx4jehfml4F/0c29eca9438eccb45268eb26c8719423/terry-after.jpg?fl=progressive",
    TERRY_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/YPmcP8jhLitYWHsLJ0Y5D/c59aa8b2a90c68aad7dc955450f18db9/terry-tn.png",
    DEYANNA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/YATmP3czlL0SfsGXicGkJ/c4836b9b76ebaa5002de380004c56657/deyanna-before.jpg?fl=progressive",
    DEYANNA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2crlNtMvWYD5o2oIyjskuC/d9caca5e4a7938da672808b8cb5c8ff5/deyanna-after.jpg?fl=progressive",
    DEYANNA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3hlfwTwZSkOVFYYwJEvXHd/7bdfd9e130a88486d48f856a5c3c0725/deyanna-tn.png",
    SHERRY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2nTDH9PtgIpUGeBwYcJRDr/a8dcc9ea7bea54d9eac98c2bb34614d8/sherry_before.jpg?fl=progressive",
    SHERRY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/41MczbiT2znpGx2MEyfGUx/385e61dc4d8e75aa7dc118b050445466/sherry_after.jpg?fl=progressive",
    SHERRY_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5gBj34ywFZK1SYRcPET3XU/d531b16a00a94e45b6ad8d7189007bc1/sherry_tn.png",
    ELSIE_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/60p3T2PrNXY9hqgCjL7nob/f1993a9e427c8c249e52b810fb00d1d2/elsie_before.jpg?fl=progressive",
    ELSIE_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/249JCgqULl0TctP0FzkW5y/e80d3eb8438bb399ec67f0a6232d83a2/elsie_after.jpg?fl=progressive",
    ELSIE_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2vFrQMiEIsT2LZleIO6muM/758b2090a48d75d145e9a0bdbb12984a/elsie_tn.png",
    JESSICA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/40421xca10oeHomvk1QCoo/64d3076d7e26c4a09a40b8ce645cdfa9/jessica_before.jpg?fl=progressive",
    JESSICA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/365ZgMrB0FK2ptopmbyLtB/020b74dc3fef01355a854ec0ed0443c1/jessica_after.jpg?fl=progressive",
    JESSICA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7v74oWlC9M3FggZGo3kyuj/a74f2c3a78d05d4f4d14212640214e2b/jessica_tn.png",
    FRANCINE_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/53cZx3gTmdoDiZYfxdjKBu/b45d06fa8f390b992eb5524a474e45fb/francine_before.jpg?fl=progressive",
    FRANCINE_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5O43OCZ1mZmWQGvCs9CGdn/4e3a3dda945bb4a2b02fba2d3c3e92dd/francine_after.jpg?fl=progressive",
    FRANCINE_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1lTjYwdGgVSax3p5fcZgZl/0469bbe568103d4be5b0abf9d7f1fd1a/francine_tn.png",
  },
  RESULTS_WOMEN: {
    ALEJANDRA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/cccXHMFlOXFIvHrfOUSWW/91229a8a3b6c776072d74bf66efcae4f/alejandra-before.png",
    ALEJANDRA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/57dFpVCfRHqFCiK27zq17A/3a89a788b304c6afe77804b95d668f41/alejandra-after.png",
    ALEJANDRA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5WRB7KMu9AfpmRkMIzcwfg/003136302d6d810add3b381f3910423a/results-alejandra-tn.png",
    ALIZA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3HDjbl78Aj6nWXqkSmqhgE/2834c40a8adc2f79555416a4ba139fed/results-aliza-before.jpg?fl=progressive",
    ALIZA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3uFiAmHU5fLcbFbzbYO1jx/2e0d8c51c5e13245d667a42a12bc9f60/results-aliza-after.jpg?fl=progressive",
    ALIZA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4uWO1yOJKPr2tUj1dUWV4/83e8a047f1ba10e5f7e875448e893309/results-aliza-tn.png",
    CANDACE_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1FJihP22Hl2P5YXGRvZsUF/7274c00a61580dd7f89c36c2940b3667/results_candace_tn.png",
    CANDACE_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7pAY0AHNXbdW6kl70UkRsn/8e2c5d5f0ffbc8b72f8f8cea887eff34/candace-before.png",
    CANDACE_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5FxISlpVC8e4IwwGPVoMaa/1961d05019c48eb38bc7a6a93f1cb069/candace-after.png",
    CAT_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1oA7bQt13qYIfcgD0BHcZG/ad73b9fc90a7f9fa7b0a9d0a010bec6c/results-cat-before.jpg?fl=progressive",
    CAT_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/Dic0eJIeBU1gMqfliPXhi/b190858e9818b7a6991e37b647d9813e/results-cat-after.jpg?fl=progressive",
    CAT_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/73PQSydccj8RjbB7qYWjHN/1c807542dd23a53cd0d23cef1b8694aa/results-cat-tn.png",
    DAWNTE_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/40TcMeze1owB5uhOndhw8b/75445956ad741afae8ca694f22fb4d2b/dawnte-before.png",
    DAWNTE_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7BGYWK9tiZVz5aXNeaCCgS/0e970831ceca767d071be42cab243af4/dawnte-after.png",
    DAWNTE_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5bEnz4eYTumQrb0wk7bACq/135d1a33d775ee8bda24a739b77d85fe/results-dawnte-tn.png",

    ELSIE_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7DAJC6IvXCPl40J9KG3rWj/3a50ec8aeaf8f59d31c1dd61e1289df7/results-elsie-before.jpg?fl=progressive",
    ELSIE_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/59KXMFFl9PMrs8xVkOvTUP/3c94512e9ddac0fdf7fcaf8ca4d32c78/results-elsie-after.jpg?fl=progressive",
    ELSIE_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6hClwa3hPKyMUzLg8K5V2y/72b8e5c07154cf6a659db845f3851b0e/results-elsie-tn.png",

    ERICA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/49FV6ZRDP12BKH6I913qOp/69c6aef804ee1455be97bb34599dde55/testimonial-erica-before.jpg?fl=progressive",
    ERICA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1cSMVPp6JjFFW4T1ab3mJX/ad66725fe6e1a84146a86bef0c221d71/testimonial-erica-after.jpg?fl=progressive",
    ERICA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4GUV6BoMWSyi8pcRNcObdE/46dc9af35506c3e4a33481e20930b27a/testimonial-thumbnail-erica.png",
    KRISTY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/JAA9M1Hl6KSbFEeJuIpme/2eed1bb4d3091ee0b9b95e6ea0a4311e/kristy-before.png",
    KRISTY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7ED09Lpfy58HcpVT2KJYev/aef79ba73d058a757bbd085307613be2/kristy-after.png",

    SABINA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1uQfa2Tuh9vMl9rWSakgHQ/69f74276f436e785ce5fa95e78fe35d0/results-sabina-before.jpg?fl=progressive",
    SABINA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6fLJ665NStauHjstkDd2pH/238a6157d368312dc139ae9706ee6612/results-sabina-after.jpg?fl=progressive",
    SABINA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4AzISonZDo3ctvCV5mxEUD/23fbae52846411e9c78e9039edc99697/testimonial-thumbnail-sabina.png",

    TAMARA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6CwEbk5XQHSJ308VD03LyL/c4ab64ea090a3e259b71030c58380d7e/testimonial-tamara-before.jpg?fl=progressive",
    TAMARA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5GEAZU4yp8elxHzkA3F2pQ/6e534628244c9e92c35eab3352aabc1b/testimonial-tamara-after.jpg?fl=progressive",
    TAMARA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3hGC4VTXBch88c6JwFC8OA/b400f87b321cc7944028bfaf11fc696e/testimonial-thumbnail-tamara.png",

    ERRYN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4LOhXRUSWGBvuo3q1A3JMy/e37fe8bfe78d30bbb15b5d4f753442e5/results-erryn-before.jpg?fl=progressive",
    ERRYN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/51rUJ7mC4r7yF6TsVobsrQ/18fdac8a3b056feceb428d3979d5fd87/results-erryn-after.jpg?fl=progressive",
    ERRYN_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7c3UsVEVumKig1lRLFlJw0/cd3c6fe56088cb25a43852ae3fa1c8e6/results-erryn-tn.png",

    FELISHA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4HUGW0luxYKjWF3LYAu8Q7/59018a8d13ae89a2cfd4f4cba7522ee2/results-felisha-before.jpg?fl=progressive",
    FELISHA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5Qul37yttmDLzcdFEpRo0h/572956326872b60552f4bcf8fe9df273/results-felisha-after.jpg?fl=progressive",
    FELISHA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5tSsUmkEvxo9QwMPlOevJZ/70a4bfd2b1ac47d05c63c7228bd1c8ee/results-felisha-tn.png",

    FRANCINE_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/53cZx3gTmdoDiZYfxdjKBu/b45d06fa8f390b992eb5524a474e45fb/francine_before.jpg?fl=progressive",
    FRANCINE_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5O43OCZ1mZmWQGvCs9CGdn/4e3a3dda945bb4a2b02fba2d3c3e92dd/francine_after.jpg?fl=progressive",
    FRANCINE_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7xcQULPzpCLVCgdHepoWGS/0ded70d2b284aec1f5024154ceda90ca/results-francine-tn.png",

    JACQUELINE_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4UGcGnPs65D4MZkkOIOamc/923cce91f826ab4f20934274213a7bac/results-jacqueline-before.jpg?fl=progressive",
    JACQUELINE_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7ayEW1V5aN5LG1zMhzy1jd/27f12c4d27d32084f9928a652a495516/results-jacqueline-after.jpg?fl=progressive",
    JACQUELINE_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/71KS7ekG1ANXDtvXhEK1uE/205882db9868698325aefa905105e5ec/results-jacqueline-tn.png",

    KARIN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6p5RFDA8BGimlYELz9WS2f/ffc49b7b6163c7db081f55304c4a809b/karin-before.png",
    KARIN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5ocCvIGh4Dj8Gio7j9tBWI/be3f075b4ae72ac9ecb407a4935db0dc/karin-after.png",
    KARIN_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6viBCDtILjuc6ZJpQxk538/f89b2cf7376cd756b2205bc1f6010a34/results-karin-tn.png",

    KAYLA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/14NgQM6WHR0QXGPSkVNHxW/c4acb072f4f8ccf3b69e5b9c732f7bbd/kayla-before.jpg?fl=progressive",
    KAYLA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2kW6nTp0nsC7uKINhjosqN/b1d754e8ec5c206221147bc94a0a6be9/kayla-after.jpg?fl=progressive",
    KAYLA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6AQzYfpyWCHXF89APtBHuy/012aff9164f9dc938ac0ab8458852467/results-kayla-tn.png",
    KAREN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/dEhV4hRPlZNocJ3M3WGDT/4a34f3ccb4771628a935bee07e49fd34/karen-before.png",
    KAREN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5FiWWZYWdiCgcPuskUETsK/27025502263662d814b25f0f2539898b/karen-after.png",
    KIMBERLY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3buMYH4Z10sfAJuHfhHnzK/d58a3342226dbcbe691601d68c78dc08/kimberly-results-before.jpg?fl=progressive",
    KIMBERLY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4ZCqEIhQpRUhAM2qayNAHY/a758d70839c03698a9bc3b1034c90b49/kimberly-results-after.jpg?fl=progressive",
    KIMBERLY_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2HdaKzbj4evObBOnZGPfOo/9a8df1476a81d82b6512736bad2e98d6/kimberly-results-tn.jpg?fl=progressive",

    LERA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5y0s68Hnoc7DlkXbeZ0qwO/58fce942da900e41f08429f8b014e090/results-lera-before.jpg?fl=progressive",
    LERA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1q0ZIAyacQozxd68Nl7LdX/8b8088bd9b2d2662dc6c9c6c91b0e183/results-lera-after.jpg?fl=progressive",
    LERA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6CYcwNLVwe734I80kXFZs1/33afb17efaed7f6d9cc6a308228f7463/results-lera-tn.png",

    LINDSEY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4h5N9e1GexNDZ7w63i8qn8/a63bbb51206d3302628f19ff77ceaff2/results-lindsey-before.jpg?fl=progressive",
    LINDSEY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6diS7N7XZInrcryurHAIo7/c26e3d3fce77e3651a17bca29d89fea1/results-lindsey-after.jpg?fl=progressive",
    LINDSEY_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Th5ScfDV57mvfTDIsL5Ad/841077503ce3950b8ce5d90849952a31/results-lindsey-tn.png",

    LYDIA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/uEQZQ27FaMeUVj5tGRjxk/cc69aa49b7a3552e43cf13ca934a6750/lydia-results-before.jpg?fl=progressive",
    LYDIA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1ejez8QTlvjtRrTzKEvoft/7565e422e9f141a8ffddb8978c703724/lydia-results-after.jpg?fl=progressive",
    LYDIA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2XanaiY8MnmHzjTWBB0yTt/30bd4e332dbbee84b2da68b7f4090ebd/lydia-results-tn.jpg?fl=progressive",

    MIYOKI_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/35o2OfuVEZIwn1ZExdbrCS/5dffaf3645f9cb1ffaaa1290e4833e3c/miyoki_results_before.png",
    MIYOKI_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4GKqIatcHDCTdxGBCGVfg8/777edaf1c70153a397091fa27c4045b5/miyoki_results_after.png",
    MIYOKI_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/76GTpssoFSJNdpH8Qn9mfs/f9e10351502ce2c8b39f9d1e5dac50bd/results-miyoki-tn.png",

    MITRA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/XKCP2lF2BfXs442ziGzE9/f51efe2ff8d8df7f7e8bcb018d3c4982/testimonial-mitra-before.jpg?fl=progressive",
    MITRA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6rIWhIVk8WKeEVxhf9jnST/6b466b88c2543450f4bd01f5e5ddfb60/testimonial-mitra-after.jpg?fl=progressive",
    MITRA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4DjLtDcSMD3hTsx7nSl1zm/07b569045eb24ffb44d7daeb3d82cf73/testimonial-thumbnail-mitra.png",

    NAME_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/v8pJKtEIBcYC9QNdziwtQ/76d029ac20cd1f68a2cda7b63cd93bc2/results-name-before.jpg?fl=progressive",
    NAME_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/57WgE6TlpG1EQTl5XqP4Fe/2bd7b2d4228bc593e5f4ae9da46a310d/results-name-after.jpg?fl=progressive",
    NAME_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1YWZyKaYZnKb7Bo8yB31DR/2186434c50d4ddeb9825ad8f3a552e3a/results-name-tn.png",

    NAOMI_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7fTnef8pxfYvuIRgDnAY3a/5728bac4c909046cddc0c777df9dce7a/results-naomi-before.jpg?fl=progressive",
    NAOMI_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6402afQQcfn8cUivQbDp7K/3ca5ad9e0f2f4f3dafeac41bc766636c/results-naomi-after.jpg?fl=progressive",
    NAOMI_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3GY52VAdaynriBvqPdjxs3/4bed29566829383378da27423eefbcac/results-naomi-tn.png",

    NATALIA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1sUeT4cxKZVwIMuxULgg93/de305050ba2339b73b986c3a20327b4f/results-natalia-before.jpg?fl=progressive",
    NATALIA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2N6kVEmNaH6bAUJfFeDoAF/7df774dde3adf7c604748365dd3538b4/results-natalia-after.jpg?fl=progressive",
    NATALIA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5ypE3PLdIGkm7TpZStsf5R/09446eb875840bd07e49c148f85bc9ff/results-natalia-tn.png",

    SHERRY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1zQbCCXMTwH3aKk9QOONCe/9b6dc91f30c5f5ff76a03a7487609e94/results-sherry-before.jpg?fl=progressive",
    SHERRY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4TaNH4Z0ttizljtedDafAW/e84613810b82f257468d7457779a3430/results-sherry-after.jpg?fl=progressive",
    SHERRY_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3UPpf5Z9IiCY8R3cAiewgq/1e772be883074512bce505ab632e0bdc/results-sherry-tn.png",

    TANYA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2zzCEY5fap7iJmS3ArwBT5/e639ed735a0a5945a437b46d184deee2/results-tanya-before.jpg?fl=progressive",
    TANYA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2Dm27bG5RVfEOK6ZmFikFj/bbd3ea82eb720bc7c327aa16949c73b2/results-tanya-after.jpg?fl=progressive",
    TANYA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6Ug1rgxKGHztdXdmidbiYN/c8efab574a2941d29daa25009c725673/results-tanya-tn.png",

    TERESA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/12ebKVs53O4W7UNxKBoW0M/2269d76e0a39e0297ef84b6c9419ad3b/results-teresa-before.jpg?fl=progressive",
    TERESA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Ej4jMG2Cz6v0qgclTFTBc/dbd689f7651bf49a2f35e5224b958050/results-teresa-after.jpg?fl=progressive",
    TERESA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/11XvpdeNa4GHgwGlEaGQ8z/76fc94b129497a2281cdc039a23c500a/results-teresa-tn.png",

    TERRY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4sgcbw9MMA1rQDVjnb17Ws/14b907dcb5507f48910f27334b6e84ee/results-terry-before.jpg?fl=progressive",
    TERRY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4gE8glM01tNVMGLFknz7YU/ddda8ab9ecc7e2f51c6cec3ed4502159/results-terry-after.jpg?fl=progressive",
    TERRY_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7Hqm11Hqcr66NwiQEfSbFM/f925714aacb0f285c4bf640459a122ea/results-terry-tn.png",

    WENDY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2ENeP6B612bv9Hy5fFLIkB/47ec56657d37d9f0742fe02b087b9f38/testimonial-wendy-before.jpg?fl=progressive",
    WENDY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5BniqgdaYSe9uHpuuQIA4A/aaefa895d73bf6896e88e634a6c9394f/testimonial-wendy-after.jpg?fl=progressive",
    WENDY_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2jks3IHJRrqwQ6R172Pbe1/8a305e93d95bb8fdf7a0275e41bfa633/testimonial-thumbnail-wendy.png",

    JESSICA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2EJBtwCYPzMgNPyR3wMBfU/05107abfdb3dd65b98652607365c0bcb/results-jessica-before.jpg?fl=progressive",
    JESSICA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/45GV6GiwKtvRJs6wEZQy8R/41486816e9ccef8760e8e45fab373acc/results-jessica-after.jpg?fl=progressive",
    JESSICA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1CvZNgX8ro9D1TcYjcbwL4/c08bb5ba3b080b94755ddf2a29880769/results-jessica-tn.png",

    DEYANNA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/YATmP3czlL0SfsGXicGkJ/c4836b9b76ebaa5002de380004c56657/deyanna-before.jpg?fl=progressive",
    DEYANNA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2crlNtMvWYD5o2oIyjskuC/d9caca5e4a7938da672808b8cb5c8ff5/deyanna-after.jpg?fl=progressive",
    DEYANNA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3hlfwTwZSkOVFYYwJEvXHd/7bdfd9e130a88486d48f856a5c3c0725/deyanna-tn.png",

    LILYANA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7fB7wW5SnEdxbzKVPmfaNm/5e6e7d58e023d2c953fca9abd43c3a03/results-lilyana-before.jpg?fl=progressive",
    LILYANA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5KNIiJ60iUYNIWngpA44lP/558396d9bf8051f8cc1e7445c6cd16bd/results-lilyana-after.jpg?fl=progressive",
    LILYANA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7q7JuL0Sif6Z5yYBooZDYh/f955575694cddd2d439f74396dbf9329/results-lilyana-tn.png",

    NEGHIN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/227Hs2DcjQTpZJfDs2LQma/e8c6603ff8ce2d4fd968b947ddafed80/results-neghin-before.jpg?fl=progressive",
    NEGHIN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2gW4kOIaA3Qe1mvxYcyOGr/c0a9133a1cef568c4159dd43e3cc8d62/results-neghin-after.jpg?fl=progressive",
    NEGHIN_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/a2tY29nX3NClN1pp2QSsv/95fa380649a2ba4833c856e43cfad914/results-neghin-tn.png",

    ENSLEY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5NjxHxibM76PYZkGykhejP/bc8eb02101e5a59f5f2eebb24aaffeea/ensley-before.png",
    ENSLEY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7nHyMnSbHzTPXN1mQEeoaF/f7cc550d9da81b48aaf46185363c8dd3/ensley-after.png",
    ENSLEY_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3dk0DmHWPDlk3XoqWbSrA0/bdcc1bcb7b4c58264f96ce581aeec8d3/results-ensley-tn.png",
    MAJIT_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/61ffb7ww0fMkfi8Ankj2ln/7f9162f4b833c7bfbef1be57251dc0b2/MajitBefore.png",
    MAJIT_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/XBkgAk9W8hkluVS4xclXe/1afcee592cf2d5befdf079ad441be395/MajitAfter.png",
    HEIDI_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6QnMIF3iKbnf5NuYKk9aLh/2818c88dc3ac217c1254e575b0e6e0cb/heidi-before.png",
    HEIDI_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/30aNhn80Sp2AIQvyHJwFyL/6464f0d57afeb49e18b46191719ae517/heidi-after.png",
  },
  RESULTS_UGC: {
    LISA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1fMbiPRvjY5D5eXXx7R4Ij/702183c96dcfd0a2bc4b4bb9e77a106a/lisa-before.jpg?fl=progressive",
    LISA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4wPi1byJGfCgglqe97ROUY/37dd856ef383f9e14fe4d6b6dbf246b2/lisa-after.jpg?fl=progressive",
    LISA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5CsbewOo7khiGOMUrU3n1q/1d0de24f87009bb34922293c97250faa/lisa-tn.png",
    ANTONELLA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/QHwOV2kQLu90JjfL4GeHk/b4e0929d40ee93432e1a6817c9f5f15d/ugc-antonella-after.jpg?fl=progressive",
    ANTONELLA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2af3JsLC9LwktIbJYo9ILi/e9b34afc3df222fc6f268a7eba8d3809/ugc-antonella-tn.png",
    ANTONELLA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/51faKvqWq0BNtqXDSZcbji/4fb2ebdc9761d83fbae665fd184a25c0/ugc-antonella-before.jpg?fl=progressive",
    RUMANDO_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1npDK9YVH9yxIcefmK7z2f/d5cd4bad8b2b963fb39423c09eacbe52/ugc-rumando-after.jpg?fl=progressive",
    RUMANDO_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/gV6JIgQQmuEF1W83dlPkO/c06194b3a5fc79958bef09eaba8f59ae/ugc-rumando-tn.png",
    MICHAEL_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7oMyz51gNe2O0AsJ8H57pr/3af03ff362588104135c8d380b203746/ugc-michael-before.jpg?fl=progressive",
    MICHAEL_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6PEWjVEd3WiPzo4NR2rPTq/8854a56dc179ed1b8f8c37903b36b2a4/ugc-michael-after.jpg?fl=progressive",
    MICHAEL_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7nNIUxu4Y36spzehScbntl/2c35618b7c20248b400b9b6dd18246d5/ugc-michael-tn.png",
    LANCE_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1C9wcIfJiLQpUkBQpiB6tE/eb6fdb68c5ffc802700b8b04f6422571/ugc-lance-before.jpg?fl=progressive",
    LANCE_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1aYUe2m1tEDLJZk4gZbRgm/8240f86c742688abc60c7bf741747b56/ugc-lance-after.jpg?fl=progressive",
    LANCE_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1ku9YDPesYBsrswtDlpOWP/fcf843d67c337b396b4c77178147bf81/ugc-lance-tn.png",
    KARLA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1bodVmIZyXIMhXrRs8UHPG/a66486f4652d432becdcd916196103bf/ugc-karla-before.jpg?fl=progressive",
    KARLA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5bhYG8CtD4JqfMVMkhXVmg/57146921413e7c6c3452676b42a94ec9/ugc-karla-after.jpg?fl=progressive",
    KARLA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/Uw8JRhLVBA6HYanVYmKE5/ed9e52811ad39a2fb1599fae41f20400/ugc-karla-tn.png",
    JODI_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4a2LOmuGnQbyhwCvNV3yvY/7439d9dfbc6696bf511f2f3206b53356/ugc-jodi-before.jpg?fl=progressive",
    JODI_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5BAX2I6g7iig4Tk8iZI55u/cba5db1a5d080b36da3903c56d74ad89/ugc-jodi-after.jpg?fl=progressive",
    JODI_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2Q3yDMSPFyYgX4FbZCjvQu/68fb7198db5af2eba059793276b188d4/ugc-jodi-tn.png",
    JENNY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3uR2hj4EoGJnJIpXDRmcle/99e9bf5a456f1bf75d398aed2c919dc9/ugc-jenny-before.jpg?fl=progressive",
    JENNY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1B637gmyIE7aWywmmaIHFR/66b0d46c0478159f05cb051258d1e922/ugc-jenny-after.jpg?fl=progressive",
    JENNY_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/ViN9YJBgIukNfNJkuXPwk/e4fb27acf8af4438d931126823645f7d/ugc-jenny-tn.png",
    DANA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/610FdQJOCJRkJp3PSM2z6h/f88e79369f6a0732d72d85bb8e4195fe/ugc-dana-before.jpg?fl=progressive",
    DANA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6EJ6D65GwnLaeFdrZNShhs/2735a5d6b32faef5aaf9cd5cc57dd4cc/ugc-dana-after.jpg?fl=progressive",
    DANA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6aDTbFjb5ih07YDe0s7Msz/142104eaf0e50a9f9a02d655138d155d/ugc-dana-tn.png",
    CARISSA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3c4oyElg729mv3TqFZltiV/8e8f613ffa097213e834032a80593ae1/ugc-carissa-before.jpg?fl=progressive",
    CARISSA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3LeB6zQUNZSEpvIfU270zQ/374df4c410e8d7c6eaa681a5b295050f/ugc-carissa-after.jpg?fl=progressive",
    CARISSA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3EYlx5hE4JTmnlW48A1SrI/79fe9fc09c8a3b21834b866c8e101bc4/ugc-carissa-tn.png",

    ASHLYN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1gs1v61u3KKNvcJK0zdnZU/734297ab428501f7be54b9f22969037a/ugc-ashlyn-before.jpg?fl=progressive",
    ASHLYN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/27DawJSqW5PeevPy2tjVps/cf0d4b88460724e45437b0e90b7eae5a/ugc-ashlyn-after.jpg?fl=progressive",
    ASHLYN_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4gZteQxdJluu0yRgV1JCNy/827d93883c47c0a6e4c6e2e3c1bdba34/ugc-ashlyn-tn.png",
    MELANIE_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7f9KOGqwOPmgaE1vtjFkX3/606d98b048e4b44ba68c887c9f6fc92d/ugc-melanie-before.jpg?fl=progressive",
    MELANIE_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1wlKyTH1U09cbMQ7lFbapb/3a66c3937324812764151c2de5ba1acc/ugc-melanie-after.jpg?fl=progressive",
    MELANIE_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4WZD35leudvkpPJ0teGjSY/be2a36ed2eba01009541804343da4cc4/ugc-melanie-tn.png",
    BIANCA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4Ss0Wq4KWbcciTHNIghkT7/152191b587dc953dfb97b57e48432afb/ugc-bianca-after.jpg?fl=progressive",
    BIANCA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/13ErhM56kOENfbe4iFbm4T/55e480ffe016d59796b22ae24e9e2e6c/ugc-bianca-tn.png",
    HALI_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7DXrKpupkFaNyE7knKMbxw/9e33b0641e64361f743a48dc2c2aa097/ugc-hali-after.jpg?fl=progressive",
    HALI_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4j34fZIn6dmEMZEgDdhgkb/05f2e2e83b36a96062938adc748ca7fa/ugc-hali-tn.png",

    CRYSTAL_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1jHmmYQWENE7nfjIPdZp5j/64882b3ab0a6c4e7977e95fa8ec6106b/ugc-crystal-before.jpg?fl=progressive",
    CRYSTAL_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/DvHHjscY2YugmSgKEoI51/f7baccc5041936b7b480e5949e7ef005/ugc-crystal-after.jpg?fl=progressive",
    CRYSTAL_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2yVy5QEekr6gPvH1jOtQ3k/85f6da9653d938069ef7895d04c1310f/ugc-crystal-tn.png",
    JOANNA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/20kpUKThf1L7mHkXw3w0AB/1195544714869ce7bfb5b07541af148b/ugc-joanna-before.jpg?fl=progressive",
    JOANNA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1VYWlJJZxu4n4poZeE3N6I/e8b207cc853e7f75577935a0dc4b1719/ugc-joanna-after.jpg?fl=progressive",
    JOANNA_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4cVAZNwv2odWSOfHizrYkJ/7824b968bd7e4dcf7be47a5533192df8/ugc-joanna-tn.png",
    JAMIE_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/j4sN7J8JKV4qLpv8BRPZy/31c9fbe85cf47ae7f843544f25addb52/ugc-jamie-before.jpg?fl=progressive",
    JAMIE_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2PrUYZElA1A0EMNvpkC4GA/75cb04e0168b7a470ce4f0614142f087/ugc-jamie-after.jpg?fl=progressive",
    JAMIE_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1dF2vLq4QZBoFGBLhGjUvc/8648a8317c3567c0247c8710a32e1612/ugc-jamie-tn.png",
    KATIE_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1N7OCT14DGBCzT1YXm1niZ/305ff5a8a379399b9416402ee5e061e4/ugc-katie-before.jpg?fl=progressive",
    KATIE_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2NZgdqfcxjyo5zrMPLbhJf/0d45c823db374b3af0843d35f0f8c9c9/ugc-katie-after.jpg?fl=progressive",
    KATIE_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1RoRGPxg7J97VCwpvD1umD/0a479f8fecc5b9f157885a799283e28d/ugc-katie-tn.png",
    ANNETTE_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7kKcFIMy9uGnl9YAzEFcoM/5919af062bae554e92e7435cbc1aecd4/Annette_Before__1_.jpg",
    ANNETTE_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3fDpjYrwVOf922xbRc8ewj/d9096de5f89da65c9d0cc779cfb283a2/Annette_After__1_.jpg",
    ANNETTE_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5PiExMNtz26BxpWDrDJuFx/0822250a2a3c8a1ac14a8ef9118af405/Annette_TN__1_.jpg",
    CRISTY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7IaKREMmVnVmNFfrR6bdLy/7d38a26c66a74c6e7d4234bad28ef7a1/Cristy_Before__1_.jpg",
    CRISTY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1XYTfw0EplH0lXClnGSgA0/be57cde7c4bf8a9319da9f9bf1063443/Cristy_After__1_.jpg",
    CRISTY_TN:
      "https://images.ctfassets.net/0rbfqd9c4jdo/Qq0SkLZqsN5gO2DpKNQpq/f2c4b2b7fd11015ecb099289edae41ed/Cristy_TN__1_.jpg",
    DIANISLEYDIS_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3vfHnnJg4GcaQJzqRvrXS4/60ac90fbb61b5da6f378f30435a5027f/Dianisleydis_before.jpg",
    DIANISLEYDIS_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3tG3Seo7qfxYUNfAH6LB0t/45a92ee734bdbb6fab2e761a991907e2/Dianisleydis_after.jpg",
    KANEE_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2kCmDUTIm3h2RZH6qePHCg/d35faf795988dcffd625634254cbade9/Kanee_before.jpg",
    KANEE_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7eh9feNwoZiSOCoBvecAXs/67759a411e7e93fd234e7302dca2a803/Kanee_after.jpg",
    BRITTANY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1Y39NSej07VnD1sHQxqQUc/2b407e987d9f5de017784118ea0b7681/Brittany_before.jpg",
    BRITTANY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/imQf0mvgTX9UHuUcxwilC/bf09cad10da7dc082877f42037eb727d/Brittany_after.jpg",
    TAYLOR_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2eJJRij91rUryWJsJrk2di/ea19a2856a284e31595a3b3a2a9771c4/Taylor_before.jpg",
    TAYLOR_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4HkloG7LY31zo2HhhBWcRl/7c78617bdf49faec44aa0d09c13d1d71/Taylor_after.jpg",
    BENJAMIN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7G4KvJDtVtHTLonQIN4XWu/bd94c025e80fa847227a4c6e5670e5b7/Benjamin_before.jpg",
    BENJAMIN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6QuALQlRW6OMxCkKLiBqB8/c26015eb18c42563a9e01d3a6129e704/Benjamin_after.jpg",
    MARK_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6BPVxDqtb4wdQS9stS43wR/0411dba01393bdcda0bf2adde1ef5cc0/Mark_before.jpg",
    MARK_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/7eI4Iza4zz0RNCo9de9rpQ/5d1e4da10430d807f41e7f2f21b41753/Mark_after.jpg",
    NATHAN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/kfzaB74KX2dInp7xu0aNv/805a172c217d9686c125177c56c6975a/Nathan_before.jpg",
    NATHAN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/36HXdJtLDUzBfnvrZWHQ4A/ff222bb162e43f0ba3f31f29909fbdd9/Nathan_after.jpg",
  },
  RESULTS_STRAND_SERUM: {
    GIANNA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5wQANvkrjrAYjCKxrEiUpR/dc13bcebcfe3f13e4988d500a9fcafa1/Gianna_Before.jpg",
    GIANNA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/1HDjyjI3fZdjLz0j5bUXKU/6965f2a7fca65bf2701e288daae50d9d/Gianna_After.jpg",
    JANET_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2qI0quvh20FwtMS04c9MP1/03bb744c29bf44ad1b2c702a2947ff55/Janet_Before.jpg",
    JANET_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/79QVGQsBtgaJUct8WnTGwn/0372134d20a1e0ccd7b7fb558e2cbf55/Janet_After.jpg",
    DONNA_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6maFOmEllyHuCTKqVQim3J/54fef6ea41649079a1d39344f15b0cfc/Donna_Before.jpg",
    DONNA_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2vfxaTNH8iJIKlQo8TjUI8/c2e524f414ebddcecdaae46a8747a9bf/Donna_After.jpg",
    TIFFANY_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/2CFb1sMXCA494qxwphYSdq/e5a427083ac6b3937a618bc4a52fdf14/Tiffany_Before.jpg",
    TIFFANY_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/4g7xlH1OSKJmAzUloqiQfg/c3082902aecf8b8aad24d7d1698ecd32/Tiffany_After.jpg",
    JORDYN_BEFORE:
      "https://images.ctfassets.net/0rbfqd9c4jdo/3gXcyrxAdOONAopP1kJ1da/9fc160bed30a12c1eaaee974e1add9e3/Jordyn_Before.jpg",
    JORDYN_AFTER:
      "https://images.ctfassets.net/0rbfqd9c4jdo/6i5O3X2zr87fA5iXpBtpl1/046cc4f41a40302f849f4ea578a96505/Jordyn_After.jpg",
  },
};
